import { faTimes, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AppBar from "../../common/AppBar.js";
import Snackbar from "../../common/Snackbar.js";
import { getBom } from "../../redux/partSlice.js";
import { getAllAppSetups } from "../../redux/appSetupSlice.js";
import { BASE_URL } from "../../config.js";
import ModulePreview from "../AddModule/ModulePreview.js";
import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SignatureCanvas from "react-signature-canvas";
import dayjs from "dayjs";
import {
  createProcedureRevision,
  getProcedureRevisionsForPart,
  getRevAllNodes,
  getTrainingLogForPart,
} from "../../redux/procedureRevisionSlice.js";
import { fetchMergedTrainingLogsForDocumentTable } from "../../util/trainingLogDocumentFetch.js";
import ExportFormatPopup from "../Preview/components/ExportFormatPopup.js";
import { runDocumentPdfExport } from "../Preview/documentPdfExportApi.js";
import { createProcedureRevisionStatus } from "../../redux/procedureRevisionStatusSlice.js";
import { getAllSectionsForPart } from "../../redux/sectionSlice.js";
import RectangleElement from "../Canvas/components/rectangle/RectangleElement.jsx";
import {
  getAllAttachmentsForStep,
  getAllAttachmentsForSubstep,
  getAllCanvasesForStep,
  getAllCanvasesForSubstep,
  getAllFormsForStep,
  getAllFormsForSubstep,
  getAllRichTextsForStep,
  getAllRichTextsForSubstep,
  getAllStepsForSection,
  getAllSubstepsForStep,
  getAllVideosForStep,
  getAllVideosForSubstep,
} from "../../redux/stepSlice.js";
import {
  fetchApprovedUsers,
  fetchReleasedUsers,
  fetchSubmittedUsers,
} from "../../redux/userSlice.js";
import { formatName, useRedirectToRevision } from "../../util/AppUtils.jsx";
import { getUnitNameById } from "../../util/AppUtils.js";
import { generateSHA256 } from "../../util/generateSHA256.js";
import "./SubassemblyDetails.css";
import ArrowElement from "../Canvas/components/arrow/ArrowElement.jsx";
import Loader from "../../common/Loader.js";
import {
  applyTransparency,
  measureHtmlHeight,
  renderPreview,
  renderVideo,
} from "../SectionElements/plugins/utils.js";
import CircleElement from "../Canvas/components/circle/CircleElement.jsx";
import Popup from "../../common/Popup/Popup.js";
import SearchBarWithFilter from "../../components/SearchBarWithFilter.js";
import ExportCsvBtn from "../../common/AppSpecificConpnents/ExportCsvBtn.js";
import { getAllVersionHistories } from "../../redux/versionHistorySlice.js";
import DoubleSidedArrowElement from "../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import LineElement from "../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../Canvas/components/canvas-core/CanvasImage.jsx";
import {
  calcTotalNodesCount,
  getAdjustedSiblingOrder,
} from "../../util/AppUtils.js";
import TextElement from "../Canvas/components/text/TextElement.jsx";
import { getAllUnits } from "../../redux/unitSlice.js";
import Konva from "konva";
import ZoomControls from "../../common/ZoomControls.js";
import CanvasDisplay from "../Canvas/components/canvas-core/CanvasDisplay.jsx";
import ShowLightText from "../../common/SmallButUseFull/ShowLightText.js";
import RenderHtml from "../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import { getVideoUrl } from "../../util/videoUrlHelper.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  HeadingWithTreePath,
  generateCompleteTreePath,
} from "./utils/treePathUtils";

// Add this component at the top of the file, after the imports

// Function to read canvas data from IndexedDB
const getCanvasDataFromIndexedDB = async (canvasId) => {
  if (!window.indexedDB) {
    return null;
  }

  try {
    const db = await new Promise((resolve, reject) => {
      const request = window.indexedDB.open("canvasElementsDB");
      request.onsuccess = (event) => resolve(event.target.result);
      request.onerror = (event) => reject(event.target.error);
    });

    const transaction = db.transaction(["canvasElements"], "readonly");
    const store = transaction.objectStore("canvasElements");

    const data = await new Promise((resolve, reject) => {
      const getRequest = store.get(canvasId);
      getRequest.onsuccess = () => resolve(getRequest.result);
      getRequest.onerror = () => reject(getRequest.error);
    });

    db.close();
    return data;
  } catch (error) {
    console.error("Error reading from IndexedDB:", error);
    return null;
  }
};

// Function to merge IndexedDB data with API data
const mergeCanvasData = (apiData, indexedDBData) => {
  if (!indexedDBData) return apiData;

  // If IndexedDB data exists, use it to update the API data
  if (apiData && apiData.pages && indexedDBData.pages) {
    // Create a map of existing pages by their ID
    const pageMap = new Map();
    apiData.pages.forEach((page) => {
      const pageId = page.canvas_page_id || page.page_id || page.id;
      if (pageId) pageMap.set(pageId, page);
    });

    // Update with IndexedDB data
    indexedDBData.pages.forEach((indexedPage) => {
      const pageId =
        indexedPage.canvas_page_id || indexedPage.page_id || indexedPage.id;
      if (pageId) {
        pageMap.set(pageId, {
          ...pageMap.get(pageId),
          ...indexedPage,
          // Preserve API data but override with IndexedDB data
          canva_snap_url: indexedPage.canva_snap_url || indexedPage.snapshot,
          shape_data: indexedPage.shape_data || indexedPage.shapes,
          image_data: indexedPage.image_data || indexedPage.images,
          // Preserve pageOrder from IndexedDB data
          pageOrder: indexedPage.pageOrder,
        });
      }
    });

    return {
      ...apiData,
      pages: Array.from(pageMap.values()),
    };
  }

  return apiData;
};

const PreviewNodes = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [enhancedCanvasData, setEnhancedCanvasData] = useState({});
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);

  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [template, setTemplate] = useState("Blank");
  const { bomTable } = useSelector((state) => state.parts);
  const { sections, loading: sectionsLoading } = useSelector(
    (state) => state.section,
  );
  const { loading } = useSelector((state) => state.procedureRevisionStatus);

  const [selectedPartUnitTypeId, setSelectedPartUnitTypeId] = useState(null);

  const {
    units,
    loading: unitsLoading,
    pagination,
  } = useSelector((state) => state.units);
  const zoomContainerRef = useRef(null); // The element you want to zoom

  const isContentEmpty = (htmlContent) => {
    if (!htmlContent) return true;
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;
    const textContent = tempDiv.textContent || tempDiv.innerText || "";
    return !textContent.trim();
  };
  const hasUserContent = (text) => {
    return text.content && !isContentEmpty(text.content);
  };
  const getTextStyle = (text, styleType) => {
    return text?.textStyles?.[styleType] || {};
  };
  const dispatch = useDispatch();

  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;
  let substepCounter = 1;
  let stepCounter = 1;
  let richTextsCounter = {};
  let attachmentCounter = 1;

  let attachmentCount = useRef(1);
  let canvasCount = useRef(1);
  let formCount = useRef(1);
  let richTextCount = useRef(1);
  let videoCount = useRef(1);

  const sigPadRef = useRef();
  const [revisionDetailsForForm, setRevisionDetailsForForm] = useState("");
  const location = useLocation();
  const { rule } = useSelector((state) => state.procedureTemplateRule);
  const element = location.state?.element;

  // Debug: Log the navigation element and fetch units
  useEffect(() => {
    // Fetch units data for BOM table unit display
    dispatch(getAllUnits({ limit: 1000, offset: 0 }));

    if (element) {
      if (element.type === "canvas") {
      }
    }
  }, [dispatch, element]);
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const [steps, setSteps] = useState(stepsBySection || {});
  const [substeps, setSubsteps] = useState(substepsByStep || {});
  const [hasAddedStep, setHasAddedStep] = useState(false);
  const [hasAddedSubstep, setHasAddedSubstep] = useState(false);
  const [isNavigatingAway, setIsNavigatingAway] = useState(false);
  const navigateAwayRef = useRef(false);
  const hasFetchedStepsRef = useRef(false);
  const hasFetchedSubstepsRef = useRef(false);
  const hasFetchedContentRef = useRef(false);

  useEffect(() => {
    const newElement = element;

    // Handle new step
    if (!hasAddedStep && newElement?.type === "step" && newElement.sectionId) {
      const sectionId = newElement.sectionId;

      setSteps((prev) => {
        const existing = prev[sectionId] || [];

        const alreadyExists = existing.some(
          (step) =>
            step.step_tree_node_id &&
            step.step_tree_node_id === newElement.step_tree_node_id
        );

        const fallbackExists = existing.some(
          (step) =>
            !newElement.step_tree_node_id &&
            step.created_at === newElement.created_at &&
            step.short_description === newElement.short_description
        );

        // Additional check for edit mode duplicates
        const editModeDuplicate = existing.some(
          (step) =>
            step.step_tree_node_id === newElement.step_tree_node_id &&
            step.isEditMode === newElement.isEditMode
        );

        // If the step already exists, replace it with the freshly edited data
        if (alreadyExists) {
          const updatedList = existing.map((step) =>
            step.step_tree_node_id === newElement.step_tree_node_id
              ? { ...step, ...newElement }
              : step
          );
          return {
            ...prev,
            [sectionId]: updatedList,
          };
        }

        if (fallbackExists || editModeDuplicate) return prev;

        return {
          ...prev,
          [sectionId]: [...existing, newElement],
        };
      });

      setHasAddedStep(true);
    }

    // Handle new substep
    if (
      !hasAddedSubstep &&
      newElement?.type === "substep" &&
      newElement.stepId
    ) {
      const stepId = newElement.stepId;

      setSubsteps((prev) => {
        const existing = prev[stepId] || [];

        const newId =
          newElement.substep_tree_node_id || newElement.sub_step_tree_node_id;
        const alreadyExists = existing.some((substep) => {
          const existId =
            substep.substep_tree_node_id || substep.sub_step_tree_node_id;
          return existId && newId && existId === newId;
        });

        const fallbackExists = existing.some(
          (substep) =>
            !newElement.substep_tree_node_id &&
            substep.created_at === newElement.created_at &&
            substep.short_description === newElement.short_description
        );

        // Additional check for edit mode duplicates
        const editModeDuplicate = existing.some((substep) => {
          const existId =
            substep.substep_tree_node_id || substep.sub_step_tree_node_id;
          return (
            existId &&
            newId &&
            existId === newId &&
            substep.isEditMode === newElement.isEditMode
          );
        });

        // If the substep is already present by ID, replace it with the updated data
        if (alreadyExists) {
          const updatedList = existing.map((substep) => {
            const existId =
              substep.substep_tree_node_id || substep.sub_step_tree_node_id;
            return existId === newId ? { ...substep, ...newElement } : substep;
          });
          return {
            ...prev,
            [stepId]: updatedList,
          };
        }

        if (fallbackExists || editModeDuplicate) return prev;

        // Insert the new substep in the correct alphabetical position
        // Sort existing substeps by sibling_order to maintain alphabetical order
        const sortedExisting = existing.slice().sort((a, b) => {
          const aOrder = parseFloat(a.sibling_order || 0);
          const bOrder = parseFloat(b.sibling_order || 0);
          return aOrder - bOrder;
        });

        // Find the correct insertion position based on sibling_order
        const newOrder = parseFloat(newElement.sibling_order || 0);
        let insertIndex = sortedExisting.findIndex((substep) => {
          const substepOrder = parseFloat(substep.sibling_order || 0);
          return substepOrder > newOrder;
        });

        // If no position found, insert at the end
        if (insertIndex === -1) {
          insertIndex = sortedExisting.length;
        }

        // Insert the new substep at the correct position
        const updatedList = [...sortedExisting];
        updatedList.splice(insertIndex, 0, newElement);

        return {
          ...prev,
          [stepId]: updatedList,
        };
      });

      setHasAddedSubstep(true);
    }

    // No cleanup that toggles state here to avoid re-render loops
  }, [element, hasAddedStep, hasAddedSubstep]);

  const [finalRichTexts, setFinalRichTexts] = useState(richTexts || {});
  const [finalForms, setFinalForms] = useState(forms || {});
  const [finalAttachments, setFinalAttachments] = useState(attachments || {});
  const [finalVideos, setFinalVideos] = useState(videos || {});
  const [finalCanvases, setFinalCanvases] = useState(canvases || {});

  // Load IndexedDB data for canvas elements
  useEffect(() => {
    const loadCanvasDataFromIndexedDB = async () => {
      if (!finalCanvases || Object.keys(finalCanvases).length === 0) return;

      const enhancedData = {};

      for (const [stepId, canvases] of Object.entries(finalCanvases)) {
        for (const canvas of canvases) {
          const canvasId = canvas.canvas_tree_node_id;
          if (canvasId) {
            try {
              const indexedDBData = await getCanvasDataFromIndexedDB(canvasId);
              if (indexedDBData) {
                const mergedData = mergeCanvasData(canvas, indexedDBData);
                enhancedData[canvasId] = mergedData;
              }
            } catch (error) {
            }
          }
        }
      }

      setEnhancedCanvasData(enhancedData);
    };

    loadCanvasDataFromIndexedDB();
  }, [finalCanvases]);

  const addElementToMap = ({ element, targetMap, setTargetMap }) => {
    const stepId = element.stepId;
    const substepId = element.substepId;

    const targetId = substepId || stepId;
    if (!targetId) return;

    setTargetMap((prev) => {
      const existing = prev[targetId] || [];

      // Helper: compare across multiple candidate keys (id/ref) for equality
      const idsEqual = (a, b, keys) => {
        for (const keyA of keys) {
          const valA = a[keyA];
          if (!valA) continue;
          for (const keyB of keys) {
            const valB = b[keyB];
            if (valB && valA === valB) return true;
          }
        }
        return false;
      };

      // More robust duplicate detection
      const alreadyExists = existing.some((item) => {
        // Substep container identity
        if (
          idsEqual(element, item, [
            "sub_step_tree_node_id",
            "substep_tree_node_id",
          ])
        ) {
          return true;
        }
        // Rich text identity (id or ref)
        if (
          idsEqual(element, item, ["rich_text_node_id", "rich_text_node_ref"])
        ) {
          return true;
        }
        // Form identity (id or ref)
        if (
          idsEqual(element, item, ["form_tree_node_id", "form_tree_node_ref"])
        ) {
          return true;
        }
        // Attachment identity (id or ref)
        if (
          idsEqual(element, item, [
            "attachment_tree_node_id",
            "attachment_tree_node_ref",
          ])
        ) {
          return true;
        }
        // Canvas identity (id or ref)
        if (
          idsEqual(element, item, [
            "canvas_tree_node_id",
            "canvas_tree_node_ref",
          ])
        ) {
          return true;
        }
        // Video identity (id or ref)
        if (
          idsEqual(element, item, ["video_tree_node_id", "video_tree_node_ref"])
        ) {
          return true;
        }
        return false;
      });

      const fallbackExists = existing.some(
        (item) =>
          !element.sub_step_tree_node_id &&
          item.created_at === element.created_at &&
          item.short_description === element.short_description
      );

      // If this is an edited attachment coming from EditAttachment with fresh files,
      // replace the existing attachment entry in-place (match by id/ref or sibling_order)
      if (
        element.type === "attachment" &&
        Array.isArray(element.attachments) &&
        element.attachments.length > 0
      ) {
        const filteredExisting = existing.filter((item) => {
          // Prefer identity by id/ref regardless of item.type presence
          const isSameIdentity = idsEqual(element, item, [
            "attachment_tree_node_id",
            "attachment_tree_node_ref",
          ]);
          if (isSameIdentity) return false;
          // Fallback: replace by sibling order if provided
          const elemOrder =
            element.sibling_order ?? element.procedure_tree?.sibling_order;
          const itemOrder =
            item.sibling_order ?? item.procedure_tree?.sibling_order;
          if (
            elemOrder != null &&
            itemOrder != null &&
            String(elemOrder) === String(itemOrder)
          ) {
            return false;
          }
          return true;
        });
        const result = {
          ...prev,
          [targetId]: [...filteredExisting, element],
        };
        return result;
      }

      // If this is an edited rich text coming from EditRichTextPage,
      // replace the existing rich text entry in-place (match by id/ref or sibling_order)
      if (element.type === "richText") {
        const filteredExisting = existing.filter((item) => {
          // Prefer identity by id/ref regardless of item.type presence
          const isSameIdentity = idsEqual(element, item, [
            "rich_text_node_id",
            "rich_text_node_ref",
          ]);
          if (isSameIdentity) return false;
          // Fallback: replace by sibling order if provided
          const elemOrder =
            element.sibling_order ?? element.procedure_tree?.sibling_order;
          const itemOrder =
            item.sibling_order ?? item.procedure_tree?.sibling_order;
          if (
            elemOrder != null &&
            itemOrder != null &&
            String(elemOrder) === String(itemOrder)
          ) {
            return false;
          }
          return true;
        });
        const result = {
          ...prev,
          [targetId]: [...filteredExisting, element],
        };

        return result;
      }

      if (alreadyExists || fallbackExists) return prev;

      // Special handling for canvas elements with fresh data from navigation
      if (
        element.type === "canvas" &&
        element.pages &&
        element.pages.length > 0
      ) {
        // For canvas elements with fresh data, replace any existing canvas with the same ID or REF
        const filteredExisting = existing.filter((item) => {
          if (item.type === "canvas") {
            return !idsEqual(element, item, [
              "canvas_tree_node_id",
              "canvas_tree_node_ref",
            ]);
          }
          return true;
        });

        return {
          ...prev,
          [targetId]: [...filteredExisting, element],
        };
      }

      return {
        ...prev,
        [targetId]: [...existing, element],
      };
    });
  };

  useEffect(() => {
    if (navigateAwayRef.current) return;
    if (!element || !element.type) return;

    switch (element.type) {
      case "richText":
        addElementToMap({
          element,
          targetMap: finalRichTexts,
          setTargetMap: setFinalRichTexts,
        });
        break;
      case "form":
        addElementToMap({
          element,
          targetMap: finalForms,
          setTargetMap: setFinalForms,
        });
        break;
      case "attachment":
        addElementToMap({
          element,
          targetMap: finalAttachments,
          setTargetMap: setFinalAttachments,
        });
        break;
      case "canvas":
        // Debug: Log the actual pages data structure
        if (element.pages && element.pages.length > 0) {
        }

        // For canvas elements from navigation (like from EditCanvasPage),
        // we need to prioritize the fresh data over existing Redux data
        if (element.pages && element.pages.length > 0) {
          // Create a canvas element with the fresh data from navigation
          const freshCanvasElement = {
            ...element,
            // Ensure the canvas data structure matches what's expected
            pages: element.pages.map((page) => {
              const updatedPage = {
                ...page,
                // Ensure snapshot is properly mapped - prioritize snapshot over canva_snap_url
                canva_snap_url: page.snapshot || page.canva_snap_url,
              };

              return updatedPage;
            }),
          };

          addElementToMap({
            element: freshCanvasElement,
            targetMap: finalCanvases,
            setTargetMap: setFinalCanvases,
          });
        } else {
          // Fallback to normal processing for canvases without fresh data
          addElementToMap({
            element,
            targetMap: finalCanvases,
            setTargetMap: setFinalCanvases,
          });
        }
        break;
      case "video":
        // If this is an existing video with edited data or explicit video payload, replace in-place
        if (
          element.video ||
          (element.isExistingVideo && element.existingVideoId)
        ) {
          const targetId = element.substepId || element.stepId;
          if (targetId) {
            setFinalVideos((prev) => {
              const existing = prev[targetId] || [];
              const newIds = [
                element.video_tree_node_id,
                element.video_tree_node_ref,
                element.existingVideoId,
              ].filter(Boolean);
              const elemOrder = String(
                element.sibling_order ??
                  element.procedure_tree?.sibling_order ??
                  ""
              );
              const filtered = existing.filter((item) => {
                const itemIds = [
                  item.video_tree_node_id,
                  item.video_tree_node_ref,
                ].filter(Boolean);
                const itemOrder = String(
                  item.sibling_order ?? item.procedure_tree?.sibling_order ?? ""
                );
                const idMatch = newIds.some((nid) => itemIds.includes(nid));
                const orderMatch =
                  elemOrder && itemOrder && elemOrder === itemOrder;
                return !(idMatch || orderMatch);
              });
              return {
                ...prev,
                [targetId]: [...filtered, element],
              };
            });
          }
          break;
        }
        addElementToMap({
          element,
          targetMap: finalVideos,
          setTargetMap: setFinalVideos,
        });
        break;
      default:
        break;
    }
  }, [element]);

  const {
    submittedUsers: users,
    approvedUsers,
    releasedUsers,
  } = useSelector((state) => state.users);
  const { revisionData, trainingLogs } = useSelector(
    (state) => state.procedureRevision
  );
  const { versionHistories } = useSelector((state) => state.versionHistory);
  const { items: appSetupItems } = useSelector((state) => state.appSetup || {});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });

  // Load application setup data on component mount
  useEffect(() => {
    dispatch(getAllAppSetups());
  }, [dispatch]);
  const handleEndDrawing = () => {
    const dataUrl = sigPadRef.current.getCanvas().toDataURL("image/png");
    setSignature(dataUrl);
  };
  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };

  const {
    partId = "",
    partNumber = "",
    description = "",
    status = "",
    revision: myRevision = "",
    type = "",
    revisionId = "",
    basedOnText = "",
    releasedText = "",
    currentText = "",
    // Optional overrides passed from EditProcedureRevision Preview button
    overrideReference,
    overrideRevisionDetails,
  } = location.state || {};

  // If caller passes revisionData via navigation state (e.g., AddProcedure preview),
  // prefer that for rendering the Revisions Table; otherwise fall back to redux data.
  const revisionDataFromState =
    (location.state && location.state.revisionData) || null;
  const revisionDataToRender = Array.isArray(revisionDataFromState)
    ? revisionDataFromState
    : revisionData;
  const [revision, setRevision] = useState("A");

  const [isReviewed, setIsReviewed] = useState("Blank");
  const stripHtmlPreserveFormatting = (html) => {
    if (!html) return "";

    let text = html.replace(/<br\s*\/?>/gi, "\n");
    text = text.replace(/<\/p><p>/gi, "\n\n");
    text = text.replace(/<p>/gi, "");
    text = text.replace(/<\/p>/gi, "\n");

    text = text.replace(/<[^>]*>/g, ""); // Remove all other HTML tags
    text = text.replace(/&nbsp;/g, " ");
    text = text.replace(/&amp;/g, "&");
    text = text.replace(/&lt;/g, "<");
    text = text.replace(/&gt;/g, ">");

    return text.trim();
  };
  const hasTaskContent = (text) => {
    return text.task && !isContentEmpty(text.task);
  };
  const hasNoteContent = (text) => {
    return text.note && !isContentEmpty(text.note);
  };

  const [zoomLevel, setZoomLevel] = useState(1);

  const handleZoom = (factor) => {
    const rawZoom = zoomLevel * factor;
    const clampedZoom = Math.max(0.1, Math.min(rawZoom, 5)); // Clamp between 0.1 and 5
    const roundedZoom = Math.round(clampedZoom * 10) / 10; // Round to nearest 0.1 (10%)
    setZoomLevel(roundedZoom);
  };

  const handleManualZoom = (e) => {
    const input = parseFloat(e.target.value);
    if (!isNaN(input)) {
      const clampedInput = Math.max(10, Math.min(input, 500)); // Clamp 10% to 500%
      const roundedInput = Math.round(clampedInput / 10) * 10; // Nearest multiple of 10
      setZoomLevel(roundedInput / 100); // Store as decimal
    }
  };

  const calculateTextBlockWidth = (text) => {
    // If a specific width is provided, use it
    if (text.width) {
      return text.width;
    }

    let maxLineLengthPx = 0;
    const minWidth = 250; // Minimum width for overall readability
    const padding = 20; // Internal padding within the text box

    // Function to estimate character width (can be further refined)
    const getCharWidth = (fontSize = 14, fontFamily = "Roboto") => {
      // These factors are approximations and might need fine-tuning
      if (fontFamily.includes("Roboto") || fontFamily.includes("Helvetica")) {
        return fontSize * 0.55;
      } else if (fontFamily.includes("Times")) {
        return fontSize * 0.5;
      } else if (
        fontFamily.includes("Courier") ||
        fontFamily.includes("monospace")
      ) {
        return fontSize * 0.6;
      }
      return fontSize * 0.55; // Default heuristic
    };

    // Helper to calculate line width in pixels
    const calculateLineWidth = (content, fontSize, fontFamily) => {
      const words = content.split(/\s+/);
      let currentLinePx = 0;
      let maxWidthPx = 0;
      const spaceWidth = getCharWidth(fontSize, fontFamily); // Estimate for a space

      words.forEach((word) => {
        const wordWidth = word.length * getCharWidth(fontSize, fontFamily);
        if (currentLinePx + wordWidth + spaceWidth > minWidth) {
          // If adding word exceeds minWidth, new line. Consider breaking on word boundaries.
          maxWidthPx = Math.max(maxWidthPx, currentLinePx);
          currentLinePx = wordWidth + spaceWidth;
        } else {
          currentLinePx += wordWidth + spaceWidth;
        }
      });
      maxWidthPx = Math.max(maxWidthPx, currentLinePx);
      return maxWidthPx;
    };

    // Calculate width for Parts section
    if (text.partsByType) {
      for (const [typeName, typeData] of Object.entries(text.partsByType)) {
        if (!typeData.parts || typeData.parts.length === 0) continue;

        const typeFontSize = text.textStyles?.type?.fontSize || 16;
        const typeFontFamily = text.textStyles?.type?.fontFamily || "Roboto";
        maxLineLengthPx = Math.max(
          maxLineLengthPx,
          calculateLineWidth(typeName, typeFontSize, typeFontFamily)
        );

        if (typeData.parts && typeData.parts.length > 0) {
          const partFontSize = text.textStyles?.part?.fontSize || 14;
          const partFontFamily = text.textStyles?.part?.fontFamily || "Roboto";

          typeData.parts.forEach(({ part, qty, unit }) => {
            const line = `${part}${qty ? ` - Qty-${qty} ${unit}` : ` ${unit}`}`;
            maxLineLengthPx = Math.max(
              maxLineLengthPx,
              calculateLineWidth(line, partFontSize, partFontFamily)
            );
          });
        }
      }
    }

    // Calculate width for Task content
    if (hasTaskContent(text)) {
      const taskContent = stripHtmlPreserveFormatting(text.task);
      const taskFontSize = getTextStyle(text, "task").fontSize || 14;
      const taskFontFamily = getTextStyle(text, "task").fontFamily || "Roboto";
      maxLineLengthPx = Math.max(
        maxLineLengthPx,
        calculateLineWidth(taskContent, taskFontSize, taskFontFamily)
      );
    }

    // Calculate width for Note content
    if (hasNoteContent(text)) {
      const noteContent = stripHtmlPreserveFormatting(text.note);
      const noteFontSize = getTextStyle(text, "note").fontSize || 14;
      const noteFontFamily = getTextStyle(text, "note").fontFamily || "Roboto";
      maxLineLengthPx = Math.max(
        maxLineLengthPx,
        calculateLineWidth(noteContent, noteFontSize, noteFontFamily)
      );
    }

    // Calculate width for User Content
    if (hasUserContent(text)) {
      const userContent = stripHtmlPreserveFormatting(text.content);
      const contentFontSize = getTextStyle(text, "content").fontSize || 14;
      const contentFontFamily =
        getTextStyle(text, "content").fontFamily || "Roboto";
      maxLineLengthPx = Math.max(
        maxLineLengthPx,
        calculateLineWidth(userContent, contentFontSize, contentFontFamily)
      );
    }

    // Add padding to the maximum calculated content width, ensure it's at least minWidth
    return Math.max(minWidth, maxLineLengthPx + padding * 2); // 2x padding for left/right
  };

  /**
   * Calculates the total height of a text group, considering all its sections (parts, task, note, content).
   * This is used for the background rectangle and drag bound.
   * @param {object} text - The text object.
   * @returns {number} The calculated height of the text group.
   */
  function calculateGroupHeight(text) {
    let height = 0;
    const PADDING_TOP = 20;
    const PADDING_BOTTOM = 20;
    const SECTION_SPACING = 20;
    const LABEL_HEIGHT = 20;
    const LINE_SPACING = 6;

    const boxWidth = text.width || calculateTextBlockWidth(text);

    height += PADDING_TOP;

    // Parts section
    let hasRenderedPartsSection = false;
    if (text.partsByType) {
      for (const [typeName, typeData] of Object.entries(text.partsByType)) {
        if (!typeData.parts || typeData.parts.length === 0) continue;
        hasRenderedPartsSection = true;

        const typeFontSize = text.textStyles?.type?.fontSize || 16;
        const typeFontFamily = text.textStyles?.type?.fontFamily || "Roboto";
        height += estimateKonvaTextHeight(
          typeName,
          typeFontSize,
          typeFontFamily,
          boxWidth
        );
        height += LINE_SPACING;

        const partFontSize = text.textStyles?.part?.fontSize || 14;
        const partFontFamily = text.textStyles?.part?.fontFamily || "Roboto";

        typeData.parts.forEach((partData) => {
          const content = `${partData.part}${
            partData.qty
              ? ` - Qty-${partData.qty} ${partData.unit}`
              : ` ${partData.unit}`
          }`;
          height += estimateKonvaTextHeight(
            content,
            partFontSize,
            partFontFamily,
            boxWidth - 10
          );
          height += LINE_SPACING;

          if (partData.note) {
            const safeNote = partData.note
              .replace(/<\/div><div>/g, "<br>")
              .replace(/<div>/g, "")
              .replace(/<\/div>/g, "");
            const noteFontSize = text.textStyles?.note?.fontSize || 14;
            const noteFontFamily =
              text.textStyles?.note?.fontFamily || "Roboto";

            const renderedNoteHeight = measureHtmlHeight(
              safeNote,
              boxWidth - 20,
              noteFontSize,
              noteFontFamily
            );

            height += renderedNoteHeight + LINE_SPACING;
          }
        });
        height += LINE_SPACING * 2;
      }
    }
    if (hasRenderedPartsSection) {
      height += SECTION_SPACING;
    }
    // Task section
    if (hasTaskContent(text)) {
      height += LABEL_HEIGHT;
      const safeTask = text.task
        ?.replace(/<\/div><div>/g, "<br>")
        .replace(/<div>/g, "")
        .replace(/<\/div>/g, "");
      const taskFontSize = getTextStyle(text, "task").fontSize || 14;
      const taskFontFamily = getTextStyle(text, "task").fontFamily || "Roboto";

      const renderedTaskHeight = measureHtmlHeight(
        safeTask,
        boxWidth - 20,
        taskFontSize,
        taskFontFamily
      );

      height += renderedTaskHeight + SECTION_SPACING;
    }

    // Note section
    if (hasNoteContent(text)) {
      height += LABEL_HEIGHT;
      const safeNote = text.note
        ?.replace(/<\/div><div>/g, "<br>")
        .replace(/<div>/g, "")
        .replace(/<\/div>/g, "");
      const noteFontSize = getTextStyle(text, "note").fontSize || 14;
      const noteFontFamily = getTextStyle(text, "note").fontFamily || "Roboto";

      const renderedNoteHeight = measureHtmlHeight(
        safeNote,
        boxWidth - 20,
        noteFontSize,
        noteFontFamily
      );

      height += renderedNoteHeight + SECTION_SPACING;
    }

    // Content section
    if (hasUserContent(text)) {
      height += LABEL_HEIGHT;

      const safeContent = text.content
        ?.replace(/<\/div><div>/g, "<br>")
        .replace(/<div>/g, "")
        .replace(/<\/div>/g, "");
      const contentFontSize = getTextStyle(text, "content").fontSize || 14;
      const contentFontFamily =
        getTextStyle(text, "content").fontFamily || "Roboto";

      const renderedContentHeight = measureHtmlHeight(
        safeContent,
        boxWidth - 20,
        contentFontSize,
        contentFontFamily
      );

      height += renderedContentHeight;

      if (text.showContentInput) {
        height += 150; // Textarea + save button buffer
      }

      height += SECTION_SPACING;
    }

    // height += PADDING_BOTTOM;

    const MIN_GROUP_HEIGHT = 80;
    return Math.max(MIN_GROUP_HEIGHT, height);
  }

  const formatListContent = (content, type) => {
    if (!type || !content) return content;

    const lines = content.split("\n");
    return lines
      .map((line, index) => {
        if (line.trim() === "") return ""; // Handle empty lines
        if (type === "bullet") return `• ${line}`;
        if (type === "number") return `${index + 1}. ${line}`;
        return line;
      })
      .filter(Boolean) // Remove empty strings
      .join("\n");
  };

  const estimateKonvaTextHeight = (
    textContent,
    fontSize = 14,
    fontFamily = "Roboto",
    boxWidth = 300
  ) => {
    if (!textContent) return 0;
    const dummyText = new Konva.Text({
      text: textContent,
      fontSize: fontSize,
      fontFamily: fontFamily,
      width: boxWidth,
      wrap: "word",
      lineHeight: 1.2, // Match actual Konva line height
    });
    return dummyText.height();
  };

  const [submissionBy, setSubmissionBy] = useState("");
  const navigate = useNavigate();
  const [limit, setLimit] = useState(100);
  const [offset, setOffset] = useState(0);
  const [revisionDetails, setRevisionDetails] = useState("");
  const [password, setPassword] = useState("");
  const [signature, setSignature] = useState("");
  const [releasedBy, setReleasedBy] = useState("");
  const [approvedBy, setApprovedBy] = useState([]); // Multi-select
  const RedirectToRevision = useRedirectToRevision();
  const getFilteredUnits = () => {
    if (!selectedPartUnitTypeId) {
      return [];
    }

    if (!selectedPartUnitTypeId || !units || units.length === 0) {
      return units || [];
    }

    // Find the unit type that matches the selected part's unit type ID
    const matchingUnitType = units.find(
      (unit) => unit.unit_type_id === selectedPartUnitTypeId
    );

    if (
      matchingUnitType &&
      matchingUnitType.unit_type_for_name &&
      matchingUnitType.unit_type_for_name.length > 0
    ) {
      // Return only the matching unit type
      return [matchingUnitType];
    }
    return units || [];
  };

  const createRevision = async () => {
    if (!revision || revision === "A") {
      showSnackbar("No revision selected!", "error");

      return;
    }
    const required_by_details = [
      {
        purpose: "Submit",
        user_ref: submissionBy,
        is_open: true,
        user: users.find((u) => u.id === submissionBy) || {},
      },
      ...approvedBy.map((id) => ({
        purpose: "Approve",
        user_ref: id,
        is_open: true,
        user: users.find((u) => u.id === id) || {},
      })),
      {
        purpose: "Release",
        user_ref: releasedBy,
        is_open: true,
        user: users.find((u) => u.id === releasedBy) || {},
      },
    ];

    const prevCreatedRev = structuredClone(revisionData).sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    const newRevisionData = {
      rev: revision,

      revision_details: revisionDetails,
      part_ref: partId,
      is_latest: true,
      is_maintained_outside_system: false,
      status_changed_to: "Not Submitted",
      is_in_release_history: false,
      past_procedure_revisions_reviewed: {},
      required_by_details,
      audit_trail_data: {
        signature,
        hash: password,
        comment: revisionDetailsForForm,
      },
    };
    newRevisionData.template_ref = prevCreatedRev[0].part_ref;
    newRevisionData.revision_ref = prevCreatedRev[0].procedure_revision_id;
    try {
      const payload = await dispatch(
        createProcedureRevision({
          revisionData: newRevisionData,
          version_content: {
            procedure_number: partNumber,
            type: type,
            description: description,
          },
        })
      ).unwrap();
      const createdRevisionId =
        payload?.results?.tableOfProcedures?.procedure_revision_ref;
      showSnackbar("Revision created successfully!", "success");

      setModalOpen(false);
      navigate(
        `/revision-submission/${partId}/${revision}/${type}/${partNumber}/${createdRevisionId}/${
          description || "-"
        }`,
        { state: { status: "Not Submitted" } }
      );
    } catch (error) {
      showSnackbar("Error creating revision: " + error?.message, "error");
    }
  };

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };
  // STEP 1: Build sections list, replacing an existing section with edited data when previewing from EditSection
  const sortedSections = (() => {
    if (!element) return [...sections];
    // If element looks like a Section override (has a section name), try to replace matching existing section
    if (element.section_name) {
      const elemId = element.section_tree_node_id;
      const elemOrder =
        element.sibling_order || element.procedure_tree?.sibling_order;
      const filtered = sections.filter((sec) => {
        if (elemId && sec.section_tree_node_id === elemId) return false;
        const secOrder = sec.sibling_order || sec.procedure_tree?.sibling_order;
        if (
          elemOrder !== undefined &&
          elemOrder !== null &&
          secOrder !== undefined &&
          secOrder !== null &&
          String(secOrder) === String(elemOrder)
        ) {
          return false;
        }
        return true;
      });
      return [...filtered, element];
    }
    // For non-section elements, append as before
    return [...sections, element];
  })();

  // STEP 2: Build stepGlobalNumbers map
  let globalStepCounter = 1;
  const stepGlobalNumbers = {}; // { step_tree_node_id: globalStepNumber }

  sortedSections.forEach((section) => {
    const newSteps = steps[section.section_tree_node_id] || [];
    newSteps.forEach((step) => {
      stepGlobalNumbers[step.step_tree_node_id] = globalStepCounter++;
    });
  });
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash

  const computeCumulativeMediaCounters = (sortedSections, steps, endIndex) => {
    const addMediaCounts = (nodeId, acc) => {
      if (finalAttachments[nodeId]?.length)
        acc.attachmentCounter += attachments[nodeId].length;
      if (finalVideos[nodeId]?.length)
        acc.videoCounter += finalVideos[nodeId].length;
      if (finalForms[nodeId]?.length)
        acc.formCounter += finalForms[nodeId].length;
      if (finalCanvases[nodeId]?.length)
        acc.canvasCounter += finalCanvases[nodeId].length;
      if (finalRichTexts[nodeId]?.length)
        acc.richTextCounter += finalRichTexts[nodeId].length;
    };

    const processSubstepsRecursively = (stepId, acc) => {
      const newSubsteps = substeps[stepId] || [];
      newSubsteps.forEach((substep) => {
        const substepId = substep.sub_step_tree_node_id;
        addMediaCounts(substepId, acc);

        // Recurse if substep itself has substeps
        if (substeps[substepId]?.length) {
          processSubstepsRecursively(substepId, acc);
        }
      });
    };

    return sortedSections.slice(0, endIndex).reduce(
      (acc, section) => {
        const newSteps = steps[section.section_tree_node_id] || [];

        newSteps.forEach((step) => {
          const stepId = step.step_tree_node_id;
          addMediaCounts(stepId, acc);
          processSubstepsRecursively(stepId, acc);
        });

        return acc;
      },
      {
        attachmentCounter: 0,
        videoCounter: 0,
        formCounter: 0,
        canvasCounter: 0,
        richTextCounter: 0,
      }
    );
  };
  const handleCreateRevision = async () => {
    if (!revisionDetails) {
      showSnackbar("Comment is mandatory.", "error");

      return;
    }

    if (!password) {
      showSnackbar("Password is mandatory.", "error");

      return;
    }

    if (!signature) {
      showSnackbar("Signature is mandatory.", "error");

      return;
    }

    let user_ref = "";

    for (let i = 0; i < revisionData.length; i++) {
      const statusChanges = revisionData[i].status_changes || [];

      for (let j = 0; j < statusChanges.length; j++) {
        const requiredBy = statusChanges[j].required_by || [];

        for (let k = 0; k < requiredBy.length; k++) {
          const entry = requiredBy[k];

          if (entry.purpose?.toLowerCase() === "submit") {
            user_ref = entry.user?.id || "";
            break;
          }
        }

        if (user_ref) break; // exit early if found
      }

      if (user_ref) break; // exit early if found
    }
    const prevData = revisionData.find(
      (r) => r.procedure_revision_id === revisionId
    );
    const formData = {
      procedure_revision_id_ref: revisionId,
      status_changed_to: "Submitted For Approval",
      is_in_release_history: true,
      user_ref,
      is_open: true,
      purpose: "Submit",
      is_latest: true,
      past_procedure_revisions_reviewed: "{}",
      audit_trail_data: {
        hash: password,
        signature,
        action: "REVISION_SENT_FOR_APPROVAL",
        comment: revisionDetails,
        parent_version: prevData.version_id_ref,
        version_content: {
          ...prevData,
          action_to_show: `Submitted ${partNumber} Rev ${myRevision}`,
          rejector: localStorage.user_name,
          procedure_number: partNumber,
          type: type,
          description: description,
        },
      },
    };

    try {
      await dispatch(createProcedureRevisionStatus(formData)).unwrap();
      showSnackbar("Revision sent for approval successfully!", "success");

      setModalOpen(false);
      navigate(
        `/approve-revision/${partId}/${myRevision}/${type}/${partNumber}/${revisionId}/${description}`
      );
    } catch (error) {
      showSnackbar(
        "Error sending revision for approval: " + error?.message,
        "error"
      );
    }
  };

  const handleRejectRevision = async () => {
    if (!revisionDetails) {
      showSnackbar("Comment is mandatory.", "error");

      return;
    }

    if (!password) {
      showSnackbar("Password is mandatory.", "error");

      return;
    }

    if (!signature) {
      showSnackbar("Signature is mandatory.", "error");

      return;
    }
    let user_ref = "";

    for (let i = 0; i < revisionData.length; i++) {
      const statusChanges = revisionData[i].status_changes || [];

      for (let j = 0; j < statusChanges.length; j++) {
        const requiredBy = statusChanges[j].required_by || [];

        for (let k = 0; k < requiredBy.length; k++) {
          const entry = requiredBy[k];

          if (entry.purpose?.toLowerCase() === "reject") {
            user_ref = entry.user?.id || "";
            break;
          }
        }

        if (user_ref) break; // exit early if found
      }

      if (user_ref) break; // exit early if found
    }
    const prevData = revisionData.find(
      (r) => r.procedure_revision_id === revisionId
    );
    const formData = {
      procedure_revision_id_ref: revisionId,
      status_changed_to: "Rejected",
      is_in_release_history: true,
      user_ref: submissionBy,
      is_open: true,
      purpose: "Reject",
      is_latest: true,
      past_procedure_revisions_reviewed: "{}",
      audit_trail_data: {
        ...auditData,
        hash: password,
        signature,
        user_ref: localStorage.getItem("user_id"),
        action: "REVISION_REJECTED",
        comment: revisionDetails,
        parent_version: prevData?.version_id_ref,
        version_content: {
          ...prevData,
          rejector: localStorage.user_name,
          action_to_show: `Rejected ${partNumber} Rev ${myRevision}`,
          procedure_number: partNumber,
          type: type,
          description: description,
        },
      },
    };

    try {
      await dispatch(createProcedureRevisionStatus(formData)).unwrap();
      showSnackbar("Revision rejected successfully!", "success");

      setModalOpen(false);
      navigate(
        `/rejected-revision/${partId}/${myRevision}/${type}/${partNumber}/${description}/Rejected/${revisionId}`
      );
    } catch (error) {
      showSnackbar(
        "Error while rejecting revision: " + error?.message,
        "error"
      );
    }
  };

  // Handle Save Button Click (Open Modal)

  const handleSaveClick = () => {
    if (revisionData.length === 0) {
      setModalOpen(true);
      return;
    }
    const sorted = [...revisionData].sort((a, b) => {
      const revA = parseRevision(a.rev);
      const revB = parseRevision(b.rev);
      if (!revA && !revB) return 0;
      if (!revA) return 1;
      if (!revB) return -1;
      if (revA.type === "special") return -1;
      if (revB.type === "special") return 1;
      if (revA.base !== revB.base) return revA.base.localeCompare(revB.base);
      if (revA.type === "major" && revB.type !== "major") return -1;
      if (revB.type === "major" && revA.type !== "major") return 1;
      if (revA.minorNum !== revB.minorNum) return revA.minorNum - revB.minorNum;
      return revA.amendChar.localeCompare(revB.amendChar);
    });

    const lastRev = sorted[sorted.length - 1]?.rev || "";
    const parsed = parseRevision(lastRev);

    const isAmendedMajor = /^[A-Z]{1,3}-[a-z]+$/.test(lastRev);

    if (!parsed) {
      snackbar("Can't create a new revision with an empty revision.", "error");
      return;
    }

    if (parsed.type === "special" || isAmendedMajor) {
      snackbar(
        "This revision is invalid and cannot be used to create a new revision.",
        "error"
      );
      return;
    }

    setModalOpen(true);
  };

  const [selectedRevision, setSelectedRevision] = useState("");
  const [approvers, setApprovers] = useState("");
  const [submitters, setSubmitters] = useState("");
  const [releasers, setReleasers] = useState("");
  const [requestors, setRequestors] = useState("");
  const [rejectors, setRejectors] = useState("");
  useEffect(() => {
    setSelectedRevision(revisionData?.find((rev) => rev.rev === myRevision));
    const statusUsers = selectedRevision?.required_by || [];

    setApprovers(
      statusUsers
        .filter((req) => req.purpose === "Approve")
        .map((req) => `${req.user.first_name} ${req.user.last_name}`)
        .join(", ") || "No Approvers"
    );

    setReleasers(
      statusUsers
        .filter((req) => req.purpose === "Release")
        .map((req) => `${req.user.first_name} ${req.user.last_name}`)
        .join(", ") || "No Releasers"
    );

    setRejectors(
      statusUsers
        .filter((req) => req.purpose === "Reject")
        .map((req) => `${req.user.first_name} ${req.user.last_name}`)
        .join(", ") || "No Rejectors"
    );

    setSubmitters(
      statusUsers
        .filter((req) => req.purpose === "Submit")
        .map((req) => `${req.user.first_name} ${req.user.last_name}`)
        .join(", ") || "No Submitters"
    );
  }, [revisionData, myRevision, selectedRevision?.status, selectedRevision]);

  // Version History Popup State
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [versionHistorySearch, setVersionHistorySearch] = useState("");
  const [versionHistoryFilter, setVersionHistoryFilter] = useState("all");
  const [searchType, setSearchType] = useState("all_columns");
  const [selectedColumns, setSelectedColumns] = useState({
    date: true,
    versionId: true,
    status: true,
    modifiedBy: true,
    comment: true,
  });

  // Export popup state
  const [isExportPopupOpen, setIsExportPopupOpen] = useState(false);
  const [exportFormat, setExportFormat] = useState("pdf");
  /** Drives the hidden ExportFormatPopup ZIP-style tree (same as module ZIP PDF). */
  const [pdfEngineZipPayload, setPdfEngineZipPayload] = useState(null);
  const pdfEngineContentRef = useRef(null);

  // State to track current page for each canvas
  const [canvasCurrentPages, setCanvasCurrentPages] = useState({});
  // Search dropdown state for Version History
  const [isVersionDropdownOpen, setIsVersionDropdownOpen] = useState(false);
  const versionFilterOptions = [
    { value: "all", label: "Revision History" },
    { value: "version_history", label: "Version History" },
  ];
  // Export UI state
  const [isExporting, setIsExporting] = useState(false);
  const [previewNodesContentReady, setPreviewNodesContentReady] =
    useState(false);
  const areNodesReadyForExport =
    !loading && !sectionsLoading && previewNodesContentReady;
  // Sorting state for Version History
  const [versionSortConfig, setVersionSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const handleVersionSort = (key) => {
    let direction = "ascending";
    if (
      versionSortConfig.key === key &&
      versionSortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setVersionSortConfig({ key, direction });
  };
  const getVersionSortIcon = (key) => {
    if (versionSortConfig.key !== key) {
      return (
        <span
          style={{
            display: "flex",
            flexDirection: "column",
            fontSize: "8px",
            position: "absolute",
            right: "5px",
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <span>▲</span>
          <span>▼</span>
        </span>
      );
    }
    return versionSortConfig.direction === "ascending" ? (
      <span
        style={{
          display: "flex",
          flexDirection: "column",
          fontSize: "8px",
          position: "absolute",
          right: "5px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        <span style={{ color: "#0D6EFD" }}>▲</span>
        <span>▼</span>
      </span>
    ) : (
      <span
        style={{
          display: "flex",
          flexDirection: "column",
          fontSize: "8px",
          position: "absolute",
          right: "5px",
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        <span>▲</span>
        <span style={{ color: "#0D6EFD" }}>▼</span>
      </span>
    );
  };
  const getSortedVersionHistory = (data) => {
    if (!versionSortConfig.key) return data;
    return [...data].sort((a, b) => {
      let aValue = "";
      let bValue = "";
      switch (versionSortConfig.key) {
        case "date":
          aValue = a.created_at || "";
          bValue = b.created_at || "";
          break;
        case "versionId":
          aValue = a.rev || "";
          bValue = b.rev || "";
          break;
        case "status":
          aValue = a.status_changes?.[0]?.status_changed_to || "";
          bValue = b.status_changes?.[0]?.status_changed_to || "";
          break;
        case "modifiedBy": {
          const aUser = a.required_by?.find(
            (rb) => rb.purpose?.toLowerCase() === "submit"
          )?.user;
          const bUser = b.required_by?.find(
            (rb) => rb.purpose?.toLowerCase() === "submit"
          )?.user;
          aValue = aUser
            ? `${aUser.first_name || ""} ${aUser.last_name || ""}`
            : "";
          bValue = bUser
            ? `${bUser.first_name || ""} ${bUser.last_name || ""}`
            : "";
          break;
        }
        case "comment":
          aValue = a.revision_details || "";
          bValue = b.revision_details || "";
          break;
        default:
          break;
      }
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
      if (aValue < bValue)
        return versionSortConfig.direction === "ascending" ? -1 : 1;
      if (aValue > bValue)
        return versionSortConfig.direction === "ascending" ? 1 : -1;
      return 0;
    });
  };

  // Table columns for search bar
  const versionHistoryColumns = [
    { id: "date", label: "Date" },
    { id: "versionId", label: "Version ID" },
    { id: "status", label: "Status" },
    { id: "modifiedBy", label: "Modified by" },
    { id: "comment", label: "Comment" },
  ];

  // Filtered and searched data (UI only)
  const filteredRevisionData = revisionData.filter((row) => {
    // Version filter (UI only, can be expanded)
    if (versionHistoryFilter !== "all" && row.rev !== versionHistoryFilter)
      return false;
    // Search logic (simple, can be expanded)
    if (versionHistorySearch) {
      const search = versionHistorySearch.toLowerCase();
      return (
        (row.rev || "").toLowerCase().includes(search) ||
        (row.revision_details || "").toLowerCase().includes(search) ||
        (row.status_changes?.[0]?.status_changed_to || "")
          .toLowerCase()
          .includes(search) ||
        (row.required_by?.[0]?.user?.first_name || "")
          .toLowerCase()
          .includes(search) ||
        (row.required_by?.[0]?.user?.last_name || "")
          .toLowerCase()
          .includes(search) ||
        (row.comment || "").toLowerCase().includes(search)
      );
    }
    return true;
  });

  // Unique versions for dropdown
  const versionOptions = [
    { value: "all", label: "Revision History" },
    ...[...new Set(revisionData.map((r) => r.rev))].map((rev) => ({
      value: rev,
      label: rev,
    })),
  ];

  const parseRevision = (rev) => {
    if (!rev) return null;

    // Check for special characters in the revision
    const hasSpecialChars = /[@#$%!^&*]/.test(rev);
    if (hasSpecialChars) {
      return {
        base: "",
        type: "special_chars",
        minorNum: 0,
        amendChar: "",
        original: rev,
      };
    }

    if (rev === "-") {
      return {
        base: "",
        type: "special",
        minorNum: 0,
        amendChar: "",
        original: rev,
      };
    }

    if (/^[A-Z]{1,3}-$/.test(rev)) {
      return {
        base: rev.slice(0, -1),
        type: "major",
        minorNum: 0,
        amendChar: "",
        original: rev,
      };
    }

    const amendMatch = rev.match(/^([A-Z]{1,3})(\d+)-([a-z]+)$/);
    if (amendMatch) {
      const [, base, num, amendChar] = amendMatch;
      return {
        base,
        type: "amend",
        minorNum: parseInt(num),
        amendChar,
        original: rev,
      };
    }

    const minorMatch = rev.match(/^([A-Z]{1,3})(\d+)([a-z]*)$/);
    if (minorMatch) {
      const [, base, num, amendChar] = minorMatch;
      return {
        base,
        type: amendChar ? "amend" : "minor",
        minorNum: parseInt(num),
        amendChar: amendChar || "",
        original: rev,
      };
    }

    return null;
  };

  // New comprehensive function to check revision creation conditions
  const canCreateRevision = (currentRevision, allRevisions) => {
    if (!currentRevision || !allRevisions || allRevisions.length === 0) {
      return { canCreate: false, reason: "Invalid revision data" };
    }

    const currentStatus = currentRevision?.status_changes
      ?.find((sc) => sc.is_latest)
      ?.status_changed_to?.toLowerCase();

    const currentRevParsed = parseRevision(currentRevision?.rev);

    if (!currentRevParsed) {
      return { canCreate: false, reason: "Invalid current revision format" };
    }

    // Check for invalid revision types
    if (
      currentRevParsed.type === "special" ||
      currentRevParsed.type === "special_chars"
    ) {
      return {
        canCreate: false,
        reason:
          "This revision is invalid and cannot be used to create a new revision",
      };
    }

    // Sort all revisions to understand the hierarchy
    const sortedRevisions = [...allRevisions].sort((a, b) => {
      const revA = parseRevision(a.rev);
      const revB = parseRevision(b.rev);
      if (!revA && !revB) return 0;
      if (!revA) return 1;
      if (!revB) return -1;
      if (revA.type === "special") return -1;
      if (revB.type === "special") return 1;
      if (revA.base !== revB.base) return revA.base.localeCompare(revB.base);
      if (revA.type === "major" && revB.type !== "major") return -1;
      if (revB.type === "major" && revA.type !== "major") return 1;
      if (revA.minorNum !== revB.minorNum) return revA.minorNum - revB.minorNum;
      return revA.amendChar.localeCompare(revB.amendChar);
    });

    const currentRevisionIndex = sortedRevisions.findIndex(
      (rev) =>
        rev.procedure_revision_id === currentRevision.procedure_revision_id
    );

    if (currentRevisionIndex === -1) {
      return {
        canCreate: false,
        reason: "Current revision not found in revision list",
      };
    }

    // Get revisions that come after the current revision
    const subsequentRevisions = sortedRevisions.slice(currentRevisionIndex + 1);

    // Helper function to check if a revision is rejected
    const isRejected = (revision) => {
      const status = revision?.status_changes
        ?.find((sc) => sc.is_latest)
        ?.status_changed_to?.toLowerCase();
      return status === "rejected";
    };

    // Helper function to check if a revision is in active status
    const isActiveStatus = (revision) => {
      const status = revision?.status_changes
        ?.find((sc) => sc.is_latest)
        ?.status_changed_to?.toLowerCase();
      return [
        "not submitted",
        "cancel requested",
        "change requested",
        "approved",
        "submitted for approval",
      ].includes(status);
    };

    // Helper function to check if a revision is released or archived
    const isReleasedOrArchived = (revision) => {
      const status = revision?.status_changes
        ?.find((sc) => sc.is_latest)
        ?.status_changed_to?.toLowerCase();
      return status === "released" || status === "archived";
    };

    // Helper function to check if all revisions in a major series are rejected
    const areAllRevisionsInMajorSeriesRejected = (
      currentRevParsed,
      allRevisions
    ) => {
      // Get all revisions that belong to the same major series as the current revision
      const currentMajorSeries = currentRevParsed.base;
      const revisionsInSameMajorSeries = allRevisions.filter((rev) => {
        const parsed = parseRevision(rev.rev);
        return parsed && parsed.base === currentMajorSeries;
      });

      // Check if all revisions in this major series are rejected
      return (
        revisionsInSameMajorSeries.length > 0 &&
        revisionsInSameMajorSeries.every(isRejected)
      );
    };

    // Helper function to check if any subsequent major series has all rejected revisions
    const hasSubsequentMajorSeriesWithAllRejected = (
      currentRevParsed,
      subsequentRevisions
    ) => {
      // Get all unique major series from subsequent revisions
      const subsequentMajorSeries = new Set();
      subsequentRevisions.forEach((rev) => {
        const parsed = parseRevision(rev.rev);
        if (parsed && parsed.base !== currentRevParsed.base) {
          subsequentMajorSeries.add(parsed.base);
        }
      });

      // Check if any of these major series have all their revisions rejected
      for (const majorSeries of subsequentMajorSeries) {
        const revisionsInMajorSeries = subsequentRevisions.filter((rev) => {
          const parsed = parseRevision(rev.rev);
          return parsed && parsed.base === majorSeries;
        });

        if (
          revisionsInMajorSeries.length > 0 &&
          revisionsInMajorSeries.every(isRejected)
        ) {
          return true;
        }
      }

      return false;
    };

    // Rule 1: For revisions with status "Not Submitted", "Cancel Request", "Change Requested", "Approved", "Submitted for Approval"
    // Allow creation of multiple revision types (A1a, B-, A3, etc.)
    if (isActiveStatus(currentRevision)) {
      if (subsequentRevisions.length === 0) {
        return { canCreate: true, reason: "No subsequent revisions exist" };
      }

      // Check if any subsequent revision is not rejected
      const hasNonRejectedSubsequent = subsequentRevisions.some(
        (rev) => !isRejected(rev)
      );

      if (hasNonRejectedSubsequent) {
        // Do NOT allow creating from active revisions when there are active subsequent revisions
        return {
          canCreate: false,
          reason: "Cannot create Revision as next Revision is already Created",
        };
      } else {
        // All subsequent revisions are rejected, can create any type of revision
        return {
          canCreate: true,
          reason:
            "All subsequent revisions are rejected, can create any revision type",
        };
      }
    }
    // Rule 2: For revisions with status "Released" or "Archived"
    if (isReleasedOrArchived(currentRevision)) {
      // Check if any subsequent revision has active status
      const hasActiveSubsequent = subsequentRevisions.some(isActiveStatus);

      if (hasActiveSubsequent) {
        // Only allow creating amendments when there are active subsequent revisions
        if (currentRevParsed.type === "amend") {
          // Check if there's already a next amendment in the same series
          const currentAmendChar = currentRevParsed.amendChar;
          const nextAmendChar = String.fromCharCode(
            currentAmendChar.charCodeAt(0) + 1
          );
          const nextAmendRev =
            currentRevParsed.minorNum === 0
              ? `${currentRevParsed.base}-${nextAmendChar}`
              : `${currentRevParsed.base}${currentRevParsed.minorNum}-${nextAmendChar}`;

          const existingRevision = allRevisions.find(
            (rev) => rev.rev === nextAmendRev
          );
          if (existingRevision) {
            return {
              canCreate: false,
              reason: `Amendment ${nextAmendRev} already exists`,
            };
          }
          return { canCreate: true, reason: "Can create next amendment only" };
        } else {
          // For non-amendment revisions, only allow creating amendments when there are active subsequent revisions
          return {
            canCreate: true,
            reason: "Can create amendment only (e.g., A1a)",
          };
        }
      } else {
        // Check if all subsequent revisions are rejected
        const allSubsequentRejected =
          subsequentRevisions.length > 0 &&
          subsequentRevisions.every(isRejected);

        if (allSubsequentRejected) {
          // All subsequent revisions are rejected, can create any type of revision
          return {
            canCreate: true,
            reason:
              "All subsequent revisions are rejected, can create any revision type",
          };
        } else {
          // No subsequent revisions exist, can create any type of revision
          return {
            canCreate: true,
            reason:
              "No subsequent revisions exist, can create any revision type",
          };
        }
      }
    }

    // Default case: if status is not recognized, don't allow creation
    return {
      canCreate: false,
      reason: `Revision creation not allowed for status: ${currentStatus}`,
    };
  };

  // Export CSV handler (UI only)
  const handleExportCSV = () => {
    // Export the actual versionHistories data that's displayed in the table
    const header = ["Date", "Version ID", "Status", "Modified by", "Comment"];
    const rows = versionHistories.map((row) => {
      const date = new Date(row.audit_date);

      // Convert to EST manually by shifting UTC offset
      const estDate = new Date(
        date.toLocaleString("en-US", {
          timeZone: "America/New_York",
        })
      );

      // Format date as YYYY-MM-DD
      const year = estDate.getFullYear();
      const month = String(estDate.getMonth() + 1).padStart(2, "0");
      const day = String(estDate.getDate()).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      // Format time as hh:mm AM/PM
      let hours = estDate.getHours();
      const minutes = String(estDate.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 to 12
      const formattedTime = `${hours}:${minutes} ${ampm}`;

      // Combine with hardcoded EST
      const finalString = `${formattedDate}, ${formattedTime} EST`;

      return [
        finalString,
        row.version_id || "-",
        row.action || "-",
        `${row.first_name || ""} ${row.last_name || ""}`.trim() || "-",
        row.comment || "-",
      ];
    });

    const csv = [header, ...rows]
      .map((r) => r.map((v) => `"${v}"`).join(","))
      .join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "version_history.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Export BOM table as CSV
  const handleExportBOMCSV = () => {
    try {
      const header = ["Type", "Item Code", "Description", "Qty Per", "Unit"];

      // Use the exact same ordering as the rendered BOM table
      const sortedBom = bomTable.slice().sort((a, b) => {
        const orderA = parseInt(a.orders || 0, 10);
        const orderB = parseInt(b.orders || 0, 10);
        if (orderA !== orderB) return orderA - orderB;

        const partNumberA = a.part_number || "";
        const partNumberB = b.part_number || "";

        const splitPart = (str) => {
          const match = str.match(/^(\d+)?([A-Za-z].*)?$/);
          if (!match) return { num: NaN, rest: str };
          return {
            num: match[1] ? parseInt(match[1], 10) : NaN,
            rest: match[2] || str,
          };
        };

        const aSplit = splitPart(partNumberA);
        const bSplit = splitPart(partNumberB);

        if (!isNaN(aSplit.num) && isNaN(bSplit.num)) return -1;
        if (isNaN(aSplit.num) && !isNaN(bSplit.num)) return 1;
        if (!isNaN(aSplit.num) && !isNaN(bSplit.num)) {
          if (aSplit.num !== bSplit.num) return aSplit.num - bSplit.num;
          return aSplit.rest.localeCompare(bSplit.rest);
        }
        return partNumberA.localeCompare(partNumberB);
      });

      const rows = sortedBom.map((row) => {
        const descriptionText = stripHtmlPreserveFormatting(
          row.part_description || ""
        )
          .replace(/\n+/g, " ")
          .trim();
        return [
          row.type_name || "",
          row.part_number || "",
          descriptionText,
          row.qty === 0 ? "" : row.qty || "",
          row.unit_name || "",
        ];
      });

      const csv = [header, ...rows]
        .map((r) =>
          r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${type || ""}_BOM.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Error exporting BOM CSV:", e);
    }
  };

  // Export Revisions table as CSV
  const handleExportRevisionsCSV = () => {
    try {
      const header = [
        "Rev",
        "Date Released",
        "Revision Details",
        "Submitter / Requestor",
        "Approver",
        "References",
        "Status",
      ];

      const sortedRevisions = [...revisionData].sort((a, b) => {
        const revA = parseRevision(a.rev);
        const revB = parseRevision(b.rev);
        if (!revA && !revB) return 0;
        if (!revA) return 1;
        if (!revB) return -1;
        if (revA.type === "special") return -1;
        if (revB.type === "special") return 1;
        if (revA.base !== revB.base) return revA.base.localeCompare(revB.base);
        if (revA.type === "major" && revB.type !== "major") return -1;
        if (revB.type === "major" && revA.type !== "major") return 1;
        if (revA.minorNum !== revB.minorNum)
          return revA.minorNum - revB.minorNum;
        return revA.amendChar.localeCompare(revB.amendChar);
      });

      const rows = sortedRevisions.map((rev) => {
        const requiredBy = "required_by" in rev ? rev.required_by : [];

        const submitterTexts = rev.is_maintained_outside_system
          ? ["MAINTAINED OUTSIDE OF SYSTEM"]
          : requiredBy
              .filter((rb) => rb.purpose?.toLowerCase() === "submit")
              .map((rb) => {
                const name = formatName(rev, rb.user);
                return !rb.is_open
                  ? `Submitted by ${name}`
                  : `Pending Submission from ${name}`;
              });

        const approverTexts = rev.is_maintained_outside_system
          ? ["MAINTAINED OUTSIDE OF SYSTEM"]
          : requiredBy
              .filter((rb) => rb.purpose?.toLowerCase() === "approve")
              .map((rb) => {
                const name = formatName(rev, rb.user);
                return !rb.is_open
                  ? `Approved by ${name}`
                  : `Pending Approval from ${name}`;
              });

        const isCurrent = rev.procedure_revision_id === revisionId;
        const detailsValue =
          isCurrent && overrideRevisionDetails != null
            ? overrideRevisionDetails
            : rev.revision_details;
        const referenceValue =
          isCurrent && overrideReference != null
            ? overrideReference
            : rev.reference;

        const dateReleased = rev.date_released
          ? new Date(rev.date_released).toLocaleDateString("ja-JP", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
            })
          : "-";

        const status =
          rev.status_changes?.find((sc) => sc.is_latest)?.status_changed_to ||
          "-";

        return [
          rev.rev || "-",
          dateReleased,
          detailsValue || "-",
          submitterTexts.join("; ") || "-",
          approverTexts.join("; ") || "-",
          referenceValue || "-",
          status,
        ];
      });

      const csv = [header, ...rows]
        .map((r) =>
          r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${type || ""}_Revisions.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Error exporting Revisions CSV:", e);
    }
  };

  // Export Training table as CSV
  const handleExportTrainingCSV = () => {
    try {
      const header = [
        "Date of Training",
        "Trainer",
        "Trainer Signature",
        "Trainee",
        "Trainee Signature",
        "Revision Trained",
        "Training Status of Trainee",
      ];

      const rows = trainingLogs.map((row) => {
        const date = row.date_of_training
          ? new Date(row.date_of_training).toLocaleDateString()
          : "";

        const trainerName = row.trainer
          ? `${row.trainer.first_name || ""} ${
              row.trainer.last_name || ""
            }`.trim()
          : "N/A";

        const traineeName = row.trainee
          ? `${row.trainee.first_name || ""} ${
              row.trainee.last_name || ""
            }`.trim()
          : "N/A";

        const trainerSig = row.trainer_signature?.data
          ? "Signed"
          : "No Signature";
        const traineeSig = row.trainee_signature?.data
          ? "Signed"
          : "No Signature";

        const revisionTrained = row.version_id_ref || "N/A";
        const status = row.is_maintained_outside_system
          ? "Maintained Outside System"
          : "In System";

        return [
          date,
          trainerName,
          trainerSig,
          traineeName,
          traineeSig,
          revisionTrained,
          status,
        ];
      });

      const csv = [header, ...rows]
        .map((r) =>
          r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${type || ""}_Training.csv`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Error exporting Training CSV:", e);
    }
  };

  // Normalize signature data from API (can arrive hex-prefixed with \x)
  const normalizeSignatureDataUrl = (raw) => {
    if (!raw) return "";
    if (typeof raw !== "string") return "";
    if (raw.startsWith("\\x")) {
      const hex = raw.slice(2);
      let out = "";
      for (let i = 0; i < hex.length; i += 2) {
        const byte = parseInt(hex.slice(i, i + 2), 16);
        if (!Number.isNaN(byte)) out += String.fromCharCode(byte);
      }
      raw = out;
    }
    // Ensure it's a data URL
    if (raw.startsWith("data:image")) return raw;
    // If it looks like base64 without header, prefix PNG header
    if (/^[A-Za-z0-9+/=]+$/.test(raw)) {
      return `data:image/png;base64,${raw}`;
    }
    return raw;
  };

  // Export Signatures (Submit, Approve, Release) as a styled PDF
  const handleExportSignaturesPDF = async () => {
    try {
      // Collect all status changes from all revisions with specified statuses
      const allStatusChanges = [];

      // Define the statuses we want to include
      const targetStatuses = [
        "submitted",
        "submitted for approval",
        "approved",
        "approve",
        "released",
        "release",
      ];

      // Use the same filtered data that the UI table uses
      const dataToUse =
        filteredRevisionData.length > 0 ? filteredRevisionData : revisionData;

      // Filter out rejected revisions - only include revisions with submitted/approved/released status
      const nonRejectedRevisions = dataToUse.filter((revision) => {
        // Get the latest status change to determine current status
        if (
          !revision.status_changes ||
          !Array.isArray(revision.status_changes)
        ) {
          return false;
        }

        // Sort status changes by date (most recent first) and get the latest one
        const latestStatusChange = [...revision.status_changes].sort((a, b) => {
          const dateA = new Date(a?.audit_trail?.date || a.created_at || 0);
          const dateB = new Date(b?.audit_trail?.date || b.created_at || 0);
          return dateB - dateA;
        })[0];

        const currentStatus = (
          latestStatusChange?.status_changed_to || ""
        ).toLowerCase();
        const isRejected = currentStatus.includes("reject");

        return !isRejected;
      });

      // Iterate through all non-rejected revisions to collect the most recent relevant status change per revision
      nonRejectedRevisions.forEach((revision) => {
        if (revision.status_changes && Array.isArray(revision.status_changes)) {
          // Find all status changes that match our target statuses and have signatures
          const relevantStatusChanges = [...revision.status_changes]
            .filter((statusChange) => {
              const status = (
                statusChange?.status_changed_to || ""
              ).toLowerCase();
              const isTargetStatus = targetStatuses.some((targetStatus) =>
                status.includes(targetStatus)
              );
              const hasSignature =
                statusChange.audit_trail && statusChange.audit_trail.signature;

              return isTargetStatus && hasSignature;
            })
            .sort((a, b) => {
              // Sort by date (most recent first)
              const dateA = new Date(a?.audit_trail?.date || a.created_at || 0);
              const dateB = new Date(b?.audit_trail?.date || b.created_at || 0);
              return dateB - dateA;
            });

          // Take only the most recent relevant status change with signature for this revision
          if (relevantStatusChanges.length > 0) {
            const mostRecentStatusChange = relevantStatusChanges[0];

            allStatusChanges.push({
              ...mostRecentStatusChange,
              revisionRev: revision.rev,
              revisionId: revision.procedure_revision_id,
            });
          } else {
          }
        }
      });

      // Sort by date (most recent first)
      allStatusChanges.sort((a, b) => {
        const dateA = new Date(a?.audit_trail?.date || a.created_at || 0);
        const dateB = new Date(b?.audit_trail?.date || b.created_at || 0);
        return dateB - dateA;
      });

      const rows = [];
      const pushRow = (entry) => {
        if (!entry) return; // only add if exists
        const user = entry.audit_trail?.user;
        const fullName = user
          ? `${user.first_name || ""} ${user.last_name || ""}`.trim()
          : "-";
        const d = entry.audit_trail?.date
          ? new Date(entry.audit_trail.date)
          : null;

        // Format date as YYYY-MM-DD
        const date = d
          ? d.toLocaleDateString("en-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })
          : "-";

        // Format time as requested (e.g., "4:20 PM")
        let time = "-";
        if (d) {
          let hours = d.getHours();
          const minutes = String(d.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          time = `${hours}:${minutes} ${ampm}`;
        }

        const sigUrl = normalizeSignatureDataUrl(entry.audit_trail?.signature);

        // Normalize status display
        let displayStatus = entry.status_changed_to || "";
        if (displayStatus.toLowerCase().includes("submitted for approval")) {
          displayStatus = "Submitted For Approval";
        } else if (displayStatus.toLowerCase().includes("submitted")) {
          displayStatus = "Submitted";
        } else if (
          displayStatus.toLowerCase().includes("approved") ||
          displayStatus.toLowerCase().includes("approve")
        ) {
          displayStatus = "Approved";
        } else if (
          displayStatus.toLowerCase().includes("released") ||
          displayStatus.toLowerCase().includes("release")
        ) {
          displayStatus = "Released";
        }

        rows.push({
          fullName,
          date,
          time,
          sigUrl,
          status: displayStatus,
          revisionRev: entry.revisionRev,
        });
      };

      // Add all matching status changes
      allStatusChanges.forEach(pushRow);

      // If no matching status changes found, show a message
      if (rows.length === 0) {
        showSnackbar(
          "No signature data found for the specified statuses.",
          "error"
        );
        return;
      }

      // Build a temporary DOM for clean rendering via html2canvas
      const temp = document.createElement("div");
      temp.style.position = "fixed";
      temp.style.left = "-10000px";
      temp.style.top = "0";
      temp.style.zIndex = "-1";
      temp.style.background = "#fff";
      temp.style.padding = "16px";
      temp.style.width = "1000px";

      const headerTitle = `${type || ""} ${partNumber || ""}`.trim();
      const headerSub = `Revision ${myRevision} Submission, Approval, and Release History`;

      // Get release information for the header
      let releaseInfo = "";
      let exportInfo = "";

      // Find the released status change to get release date and user
      const releaseStatusChange = allStatusChanges.find(
        (sc) =>
          sc.status_changed_to &&
          sc.status_changed_to.toLowerCase().includes("released")
      );

      if (releaseStatusChange && releaseStatusChange.audit_trail) {
        const releaseDate = new Date(releaseStatusChange.audit_trail.date);
        const releaseUser = releaseStatusChange.audit_trail.user;
        const releaseUserName = releaseUser
          ? `${releaseUser.first_name || ""} ${
              releaseUser.last_name || ""
            }`.trim()
          : "Unknown User";

        // Format release date in EST/EDT
        const releaseDateFormatted = releaseDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          timeZone: "America/New_York",
        });

        const releaseTimeFormatted = releaseDate.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
          timeZone: "America/New_York",
        });

        const timezone = releaseDate
          .toLocaleDateString("en-US", {
            timeZoneName: "short",
            timeZone: "America/New_York",
          })
          .split(", ")[1];

        releaseInfo = `Released ${releaseDateFormatted} at ${releaseTimeFormatted} ${timezone} by ${releaseUserName}`;
      }

      // Get current user info for export (you may need to get this from your auth state)
      const currentDate = new Date();
      const exportDateFormatted = currentDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone: "America/New_York",
      });

      const exportTimeFormatted = currentDate.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: "America/New_York",
      });

      const exportTimezone = currentDate
        .toLocaleDateString("en-US", {
          timeZoneName: "short",
          timeZone: "America/New_York",
        })
        .split(", ")[1];

      // Get current user name from local storage
      exportInfo = `Exported on ${exportDateFormatted} at ${exportTimeFormatted} ${exportTimezone} by ${localStorage.getItem(
        "user_name"
      )}`;

      // Get application setup data for header and footer
      // Sort by updated_at (or created_at) in descending order to get the latest
      let appSetup = null;
      if (appSetupItems && appSetupItems.length > 0) {
        const sortedItems = [...appSetupItems].sort((a, b) => {
          const dateA = new Date(a?.updated_at || a?.created_at || 0).getTime();
          const dateB = new Date(b?.updated_at || b?.created_at || 0).getTime();
          return dateB - dateA; // Descending order (latest first)
        });
        appSetup = sortedItems[0]; // Get the latest item
      }
      const companyName = appSetup?.company_name || "";
      const companyLogo = appSetup?.company_image;
      const footerText = appSetup?.footer || "";

      // Build company logo URL and convert to base64 to avoid CORS/taint issues
      let companyLogoUrl = "";
      if (companyLogo) {
        const logoUrl = companyLogo.startsWith("http")
          ? companyLogo
          : `${BASE_URL.replace("/api/", "")}${companyLogo}`;

        // Convert image to base64 using canvas to avoid taint issues
        try {
          companyLogoUrl = await new Promise((resolve, reject) => {
            const img = new window.Image();
            img.crossOrigin = "anonymous";

            img.onload = () => {
              try {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
                resolve(dataURL);
              } catch (error) {
                resolve(""); // Fallback to no logo
              }
            };

            img.onerror = () => {
              resolve(""); // Fallback to no logo
            };

            img.src = logoUrl;
          });
        } catch (error) {
          companyLogoUrl = ""; // Fallback to no logo
        }
      }

      // Build table via DOM API below to avoid nested template complexities

      // Fix template literal inlining for signature cells (since we need dynamic per-row)
      // Rebuild tbody with DOM to inject <img>
      const parser = document.createElement("div");
      parser.innerHTML = `
        <table style="width: 100%; border-collapse: collapse; font-size: 14px; margin-top: 20px;"></table>
      `;
      const tableEl = parser.querySelector("table");
      // Build header
      const thead = document.createElement("thead");
      thead.innerHTML = `
        <tr>
          <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">User</th>
          <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Date</th>
          <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Time</th>
          <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Signature</th>
          <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Status</th>
        </tr>`;
      const tbody = document.createElement("tbody");
      rows.forEach((r) => {
        const tr = document.createElement("tr");
        tr.innerHTML = `
          <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.fullName}</td>
          <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.date}</td>
          <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.time}</td>
          <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; height:60px; min-height:60px;\"></td>
          <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.status}</td>
        `;
        const sigTd = tr.children[3];
        if (r.sigUrl) {
          const img = document.createElement("img");
          img.src = r.sigUrl;
          img.style.height = "45px";
          img.style.maxWidth = "120px";
          img.style.objectFit = "contain";
          img.style.display = "block";
          img.style.margin = "0 auto";
          sigTd.appendChild(img);
        }
        tbody.appendChild(tr);
      });
      tableEl.appendChild(thead);
      tableEl.appendChild(tbody);

      // Create a wrapper div with proper layout structure
      const wrapperDiv = document.createElement("div");
      wrapperDiv.style.cssText =
        "min-height: 100vh; display: flex; flex-direction: column; font-family: Arial, Helvetica, sans-serif; color: #111; position: relative;";

      // Create content area
      const contentDiv = document.createElement("div");
      contentDiv.style.cssText = "flex: 1;";
      const companyheader = `
        <!-- Company Header -->
        ${
          companyName || companyLogoUrl
            ? `
          <div style=\"display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px; padding: 20px 0; border-bottom: 1px solid #ccc;\">
            ${
              companyLogoUrl
                ? `<img src=\"${companyLogoUrl}\" alt=\"Company Logo\" style=\"height: 60px; object-fit: contain;\" />`
                : `<div></div>`
            }
            <div style=\"display: flex; flex-direction: column; text-align: right; align-items: flex-end;\">
            ${
              companyName
                ? `<div style=\"font-size: 28px; font-weight: 700; color: #333; margin-bottom: 5px;\">${companyName}</div>`
                : ""
            }
              ${
                appSetup?.company_address
                  ? `<div style=\"display: flex; align-items: center; font-size: 14px; color: #666; margin-bottom: 3px;\">
                      <svg width=\"8\" height=\"12\" viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-right: 6px;\">
                        <path d=\"M4.16378 11.1999C3.19426 11.1999 2.40311 11.0492 1.7903 10.7479C1.1775 10.4462 0.871094 10.0569 0.871094 9.5799C0.871094 9.2649 1.00372 8.9904 1.26896 8.7564C1.5342 8.5224 1.90006 8.3379 2.36652 8.2029L2.68207 9.2289C2.52658 9.2739 2.38481 9.33024 2.25676 9.39792C2.12872 9.46524 2.04183 9.5259 1.99609 9.5799C2.115 9.7239 2.38939 9.8499 2.81926 9.9579C3.24914 10.0659 3.69731 10.1199 4.16378 10.1199C4.63024 10.1199 5.08079 10.0659 5.51542 9.9579C5.94969 9.8499 6.22628 9.7239 6.34518 9.5799C6.29945 9.5259 6.21256 9.46524 6.08451 9.39792C5.95646 9.33024 5.81469 9.2739 5.6592 9.2289L5.97475 8.2029C6.44122 8.3379 6.80487 8.5224 7.06573 8.7564C7.32622 8.9904 7.45646 9.2649 7.45646 9.5799C7.45646 10.0569 7.15006 10.4462 6.53725 10.7479C5.92445 11.0492 5.13329 11.1999 4.16378 11.1999ZM4.16378 9.5799C4.06317 9.5799 3.9717 9.55056 3.88939 9.49188C3.80707 9.43356 3.74762 9.3549 3.71103 9.2559C3.50067 8.6169 3.23542 8.0814 2.9153 7.6494C2.59518 7.2174 2.2842 6.8034 1.98237 6.4074C1.68969 6.0114 1.43597 5.6019 1.22122 5.1789C1.00609 4.7559 0.898533 4.2339 0.898533 3.6129C0.898533 2.7129 1.21408 1.9524 1.84518 1.3314C2.47628 0.710402 3.24914 0.399902 4.16378 0.399902C5.07841 0.399902 5.85128 0.710402 6.48237 1.3314C7.11347 1.9524 7.42902 2.7129 7.42902 3.6129C7.42902 4.2339 7.32384 4.7559 7.11347 5.1789C6.90311 5.6019 6.64701 6.0114 6.34518 6.4074C6.0525 6.8034 5.7439 7.2174 5.41939 7.6494C5.09451 8.0814 4.82689 8.6169 4.61652 9.2559C4.57994 9.3549 4.52048 9.43356 4.43817 9.49188C4.35585 9.55056 4.26439 9.5799 4.16378 9.5799ZM4.16378 4.7604C4.4839 4.7604 4.75829 4.6479 4.98695 4.4229C5.21561 4.1979 5.32994 3.9279 5.32994 3.6129C5.32994 3.2979 5.21561 3.0279 4.98695 2.8029C4.75829 2.5779 4.4839 2.4654 4.16378 2.4654C3.84365 2.4654 3.56926 2.5779 3.34061 2.8029C3.11195 3.0279 2.99762 3.2979 2.99762 3.6129C2.99762 3.9279 3.11195 4.1979 3.34061 4.4229C3.56926 4.6479 3.84365 4.7604 4.16378 4.7604Z\" fill=\"#AAAAAA\"/>
                      </svg>
                      ${appSetup.company_address}
                    </div>`
                  : ""
              }
              ${
                appSetup?.company_phone
                  ? `<div style=\"display: flex; align-items: center; font-size: 14px; color: #666;\">
                      <svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-right: 6px;\">
                        <path d=\"M6.72656 4.30005V2.80005H5.22656V1.80005H6.72656V0.300049H7.72656V1.80005H9.22656V2.80005H7.72656V4.30005H6.72656ZM8.70156 9.30005C7.62656 9.30005 6.57873 9.06038 5.55806 8.58105C4.53706 8.10205 3.6329 7.46872 2.84556 6.68105C2.0579 5.89372 1.42456 4.98955 0.945563 3.96855C0.466229 2.94788 0.226562 1.90005 0.226562 0.825049C0.226562 0.675049 0.276562 0.550049 0.376562 0.450049C0.476562 0.350049 0.601563 0.300049 0.751563 0.300049H2.77656C2.89323 0.300049 2.9974 0.337549 3.08906 0.412549C3.18073 0.487549 3.2349 0.583382 3.25156 0.700049L3.57656 2.45005C3.59323 2.56672 3.59123 2.67288 3.57056 2.76855C3.54956 2.86455 3.50156 2.95005 3.42656 3.02505L2.22656 4.25005C2.57656 4.85005 3.01406 5.41255 3.53906 5.93755C4.06406 6.46255 4.64323 6.91672 5.27656 7.30005L6.45156 6.12505C6.52656 6.05005 6.62456 5.99372 6.74556 5.95605C6.86623 5.91872 6.9849 5.90838 7.10156 5.92505L8.82656 6.27505C8.94323 6.30005 9.03906 6.35622 9.11406 6.44355C9.18906 6.53122 9.22656 6.63338 9.22656 6.75005V8.77505C9.22656 8.92505 9.17656 9.05005 9.07656 9.15005C8.97656 9.25005 8.85156 9.30005 8.70156 9.30005Z\" fill=\"#AAAAAA\"/>
                      </svg>
                      ${appSetup.company_phone}
                    </div>`
                  : ""
              }
            </div>
          </div>
        `
            : ""
        }
        
        <!-- Document Title and Info -->
        <div style=\"text-align: center; margin-bottom: 30px;\">
         <div style=\"display: flex; justify-content: space-between; margin-bottom: 15px; padding: 0 20px;\">
             <div style=\"text-align: left;\">
               <div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600; display: flex; align-items: center;\">${
                 type || "Document"
               } ${
        partNumber || ""
      } <span style=\"margin: 0 8px; font-size: 18px; font-weight: 300;\">|</span> Revision ${
        myRevision || ""
      }-</div>
             </div>
            <div style=\"text-align: right;\">
        ${
          releaseInfo
            ? `<div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600; margin-bottom: 4px;\">${releaseInfo}</div>`
            : ""
        }
              <div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600;\">${exportInfo}</div>
            </div>
          </div>
          <div style=\"font-size: 24px; font-weight: 700; margin-bottom: 15px; color: #333;text-align:left\">${headerTitle}</div>
          <div style=\"font-size: 18px; font-weight: 600; margin-bottom: 20px; color: #1a5fb4;text-align:left\">${headerSub}</div>
          
          <!-- Blue Info Section -->
          
        </div>
      `;
      // Compose into temp container
      contentDiv.innerHTML = `
        <!-- Company Header -->
        ${
          companyName || companyLogoUrl
            ? `
          <div style=\"display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px; padding: 20px 0; border-bottom: 1px solid #ccc;\">
            ${
              companyLogoUrl
                ? `<img src=\"${companyLogoUrl}\" alt=\"Company Logo\" style=\"height: 60px; object-fit: contain;\" />`
                : `<div></div>`
            }
            <div style=\"display: flex; flex-direction: column; text-align: right; align-items: flex-end;\">
            ${
              companyName
                ? `<div style=\"font-size: 28px; font-weight: 700; color: #333; margin-bottom: 5px;\">${companyName}</div>`
                : ""
            }
              ${
                appSetup?.company_address
                  ? `<div style=\"display: flex; align-items: center; font-size: 14px; color: #666; margin-bottom: 3px;\">
                      <svg width=\"8\" height=\"12\" viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-right: 6px;\">
                        <path d=\"M4.16378 11.1999C3.19426 11.1999 2.40311 11.0492 1.7903 10.7479C1.1775 10.4462 0.871094 10.0569 0.871094 9.5799C0.871094 9.2649 1.00372 8.9904 1.26896 8.7564C1.5342 8.5224 1.90006 8.3379 2.36652 8.2029L2.68207 9.2289C2.52658 9.2739 2.38481 9.33024 2.25676 9.39792C2.12872 9.46524 2.04183 9.5259 1.99609 9.5799C2.115 9.7239 2.38939 9.8499 2.81926 9.9579C3.24914 10.0659 3.69731 10.1199 4.16378 10.1199C4.63024 10.1199 5.08079 10.0659 5.51542 9.9579C5.94969 9.8499 6.22628 9.7239 6.34518 9.5799C6.29945 9.5259 6.21256 9.46524 6.08451 9.39792C5.95646 9.33024 5.81469 9.2739 5.6592 9.2289L5.97475 8.2029C6.44122 8.3379 6.80487 8.5224 7.06573 8.7564C7.32622 8.9904 7.45646 9.2649 7.45646 9.5799C7.45646 10.0569 7.15006 10.4462 6.53725 10.7479C5.92445 11.0492 5.13329 11.1999 4.16378 11.1999ZM4.16378 9.5799C4.06317 9.5799 3.9717 9.55056 3.88939 9.49188C3.80707 9.43356 3.74762 9.3549 3.71103 9.2559C3.50067 8.6169 3.23542 8.0814 2.9153 7.6494C2.59518 7.2174 2.2842 6.8034 1.98237 6.4074C1.68969 6.0114 1.43597 5.6019 1.22122 5.1789C1.00609 4.7559 0.898533 4.2339 0.898533 3.6129C0.898533 2.7129 1.21408 1.9524 1.84518 1.3314C2.47628 0.710402 3.24914 0.399902 4.16378 0.399902C5.07841 0.399902 5.85128 0.710402 6.48237 1.3314C7.11347 1.9524 7.42902 2.7129 7.42902 3.6129C7.42902 4.2339 7.32384 4.7559 7.11347 5.1789C6.90311 5.6019 6.64701 6.0114 6.34518 6.4074C6.0525 6.8034 5.7439 7.2174 5.41939 7.6494C5.09451 8.0814 4.82689 8.6169 4.61652 9.2559C4.57994 9.3549 4.52048 9.43356 4.43817 9.49188C4.35585 9.55056 4.26439 9.5799 4.16378 9.5799ZM4.16378 4.7604C4.4839 4.7604 4.75829 4.6479 4.98695 4.4229C5.21561 4.1979 5.32994 3.9279 5.32994 3.6129C5.32994 3.2979 5.21561 3.0279 4.98695 2.8029C4.75829 2.5779 4.4839 2.4654 4.16378 2.4654C3.84365 2.4654 3.56926 2.5779 3.34061 2.8029C3.11195 3.0279 2.99762 3.2979 2.99762 3.6129C2.99762 3.9279 3.11195 4.1979 3.34061 4.4229C3.56926 4.6479 3.84365 4.7604 4.16378 4.7604Z\" fill=\"#AAAAAA\"/>
                      </svg>
                      ${appSetup.company_address}
                    </div>`
                  : ""
              }
              ${
                appSetup?.company_phone
                  ? `<div style=\"display: flex; align-items: center; font-size: 14px; color: #666;\">
                      <svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-right: 6px;\">
                        <path d=\"M6.72656 4.30005V2.80005H5.22656V1.80005H6.72656V0.300049H7.72656V1.80005H9.22656V2.80005H7.72656V4.30005H6.72656ZM8.70156 9.30005C7.62656 9.30005 6.57873 9.06038 5.55806 8.58105C4.53706 8.10205 3.6329 7.46872 2.84556 6.68105C2.0579 5.89372 1.42456 4.98955 0.945563 3.96855C0.466229 2.94788 0.226562 1.90005 0.226562 0.825049C0.226562 0.675049 0.276562 0.550049 0.376562 0.450049C0.476562 0.350049 0.601563 0.300049 0.751563 0.300049H2.77656C2.89323 0.300049 2.9974 0.337549 3.08906 0.412549C3.18073 0.487549 3.2349 0.583382 3.25156 0.700049L3.57656 2.45005C3.59323 2.56672 3.59123 2.67288 3.57056 2.76855C3.54956 2.86455 3.50156 2.95005 3.42656 3.02505L2.22656 4.25005C2.57656 4.85005 3.01406 5.41255 3.53906 5.93755C4.06406 6.46255 4.64323 6.91672 5.27656 7.30005L6.45156 6.12505C6.52656 6.05005 6.62456 5.99372 6.74556 5.95605C6.86623 5.91872 6.9849 5.90838 7.10156 5.92505L8.82656 6.27505C8.94323 6.30005 9.03906 6.35622 9.11406 6.44355C9.18906 6.53122 9.22656 6.63338 9.22656 6.75005V8.77505C9.22656 8.92505 9.17656 9.05005 9.07656 9.15005C8.97656 9.25005 8.85156 9.30005 8.70156 9.30005Z\" fill=\"#AAAAAA\"/>
                      </svg>
                      ${appSetup.company_phone}
                    </div>`
                  : ""
              }
            </div>
          </div>
        `
            : ""
        }
        
        <!-- Document Title and Info -->
        <div style=\"text-align: center; margin-bottom: 30px;\">
         <div style=\"display: flex; justify-content: space-between; margin-bottom: 15px; padding: 0 20px;\">
             <div style=\"text-align: left;\">
               <div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600; display: flex; align-items: center;\">${
                 type || "Document"
               } ${
        partNumber || ""
      } <span style=\"margin: 0 8px; font-size: 18px; font-weight: 300;\">|</span> Revision ${
        myRevision || ""
      }-</div>
             </div>
            <div style=\"text-align: right;\">
        ${
          releaseInfo
            ? `<div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600; margin-bottom: 4px;\">${releaseInfo}</div>`
            : ""
        }
              <div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600;\">${exportInfo}</div>
            </div>
          </div>
          <div style=\"font-size: 24px; font-weight: 700; margin-bottom: 15px; color: #333;text-align:left\">${headerTitle}</div>
          <div style=\"font-size: 18px; font-weight: 600; margin-bottom: 20px; color: #1a5fb4;text-align:left\">${headerSub}</div>
          
          <!-- Blue Info Section -->
          
        </div>
      `;

      wrapperDiv.appendChild(contentDiv);
      contentDiv.appendChild(tableEl);

      // Add footer - always add the proprietary footer
      const footerDiv = document.createElement("div");
      footerDiv.style.cssText =
        "position: absolute; bottom: 0; left: 0; right: 0; padding: 15px 20px; border-top: 1px solid #ccc; font-size: 12px; color: #666; font-family: Arial, Helvetica, sans-serif; display: flex; justify-content: space-between; align-items: center; background: white;";

      const proprietaryText = `Proprietary information of ${
        companyName || "RUSHABH Instruments, LLC (RI)"
      }. Do not duplicate or reproduce in any form without written permission of RI.`;

      footerDiv.innerHTML = `
        <div style="flex: 1;">${proprietaryText}</div>
        <div style="font-weight: 600;" id="pageNumber">Page 1/1</div>
      `;
      wrapperDiv.appendChild(footerDiv);

      temp.appendChild(wrapperDiv);
      document.body.appendChild(temp);

      // Wait for all images (especially signatures) to load before capture
      const imgs = Array.from(temp.querySelectorAll("img"));
      await Promise.all(
        imgs.map((img) =>
          img.decode?.().catch(
            () =>
              new Promise((resolve) => {
                if (img.complete) return resolve();
                img.onload = () => resolve();
                img.onerror = () => resolve();
              })
          )
        )
      );

      // Calculate total pages first
      const tempCanvas = await html2canvas(temp, {
        useCORS: true,
        backgroundColor: "#fff",
        scale: 2,
      });
      const pageWidth = 595; // A4 width in points
      const pageHeight = 842; // A4 height in points
      const horizontalMargin = 24;
      const verticalMargin = 24;
      const footerHeight = 50; // Reserve space for footer
      const imgWidth = pageWidth - horizontalMargin * 2;
      const tempImgHeight = (tempCanvas.height * imgWidth) / tempCanvas.width;
      const drawableHeight = pageHeight - verticalMargin * 2 - footerHeight;
      const totalPages = Math.ceil(tempImgHeight / drawableHeight);

      document.body.removeChild(temp);

      const pdf = new jsPDF({ orientation: "p", unit: "pt", format: "a4" });

      // Calculate how many rows can fit per page
      const headerHeight = 150; // Reduced header height estimate
      const availableHeight = drawableHeight - headerHeight;
      const rowHeight = 50; // Reduced row height estimate (signature + padding)
      const maxRowsPerPage = Math.floor(availableHeight / rowHeight);

      // Ensure minimum of 10 rows per page, maximum of 14
      const minRowsPerPage = 10;
      const maxRowsPerPageLimit = 14;
      const finalMaxRowsPerPage = Math.max(
        minRowsPerPage,
        Math.min(maxRowsPerPage, maxRowsPerPageLimit)
      );

      // Debug logging

      // Split rows into pages
      const pages = [];
      for (let i = 0; i < rows.length; i += finalMaxRowsPerPage) {
        pages.push(rows.slice(i, i + finalMaxRowsPerPage));
      }

      // If no pages created, create at least one empty page
      if (pages.length === 0) {
        pages.push([]);
      }

      // Render each page with its own table
      for (let currentPage = 1; currentPage <= pages.length; currentPage++) {
        const pageRows = pages[currentPage - 1];

        // Create a new temporary container for this page
        const pageTemp = document.createElement("div");
        pageTemp.style.position = "fixed";
        pageTemp.style.left = "-10000px";
        pageTemp.style.top = "0";
        pageTemp.style.zIndex = "-1";
        pageTemp.style.background = "#fff";
        pageTemp.style.padding = "16px";
        pageTemp.style.width = "1000px";

        // Create wrapper div for this page
        const pageWrapperDiv = document.createElement("div");
        pageWrapperDiv.style.cssText =
          "min-height: 100vh; display: flex; flex-direction: column; font-family: Arial, Helvetica, sans-serif; color: #111; position: relative;";

        // Add header for this page
        const pageContentDiv = document.createElement("div");
        pageContentDiv.style.cssText = "flex: 1;";
        pageContentDiv.innerHTML = `
          <!-- Company Header -->
          ${
            companyName || companyLogoUrl
              ? `
            <div style=\"display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px; padding: 20px 0; border-bottom: 1px solid #ccc;\">
              ${
                companyLogoUrl
                  ? `<img src=\"${companyLogoUrl}\" alt=\"Company Logo\" style=\"height: 60px; object-fit: contain;\" />`
                  : `<div></div>`
              }
              <div style=\"display: flex; flex-direction: column; text-align: right; align-items: flex-end;\">
              ${
                companyName
                  ? `<div style=\"font-size: 28px; font-weight: 700; color: #333; margin-bottom: 5px;\">${companyName}</div>`
                  : ""
              }
                ${
                  appSetup?.company_address
                    ? `<div style=\"display: flex; align-items: center; font-size: 14px; color: #666; margin-bottom: 3px;\">
                        <svg width=\"8\" height=\"12\" viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-right: 6px;\">
                          <path d=\"M4.16378 11.1999C3.19426 11.1999 2.40311 11.0492 1.7903 10.7479C1.1775 10.4462 0.871094 10.0569 0.871094 9.5799C0.871094 9.2649 1.00372 8.9904 1.26896 8.7564C1.5342 8.5224 1.90006 8.3379 2.36652 8.2029L2.68207 9.2289C2.52658 9.2739 2.38481 9.33024 2.25676 9.39792C2.12872 9.46524 2.04183 9.5259 1.99609 9.5799C2.115 9.7239 2.38939 9.8499 2.81926 9.9579C3.24914 10.0659 3.69731 10.1199 4.16378 10.1199C4.63024 10.1199 5.08079 10.0659 5.51542 9.9579C5.94969 9.8499 6.22628 9.7239 6.34518 9.5799C6.29945 9.5259 6.21256 9.46524 6.08451 9.39792C5.95646 9.33024 5.81469 9.2739 5.6592 9.2289L5.97475 8.2029C6.44122 8.3379 6.80487 8.5224 7.06573 8.7564C7.32622 8.9904 7.45646 9.2649 7.45646 9.5799C7.45646 10.0569 7.15006 10.4462 6.53725 10.7479C5.92445 11.0492 5.13329 11.1999 4.16378 11.1999ZM4.16378 9.5799C4.06317 9.5799 3.9717 9.55056 3.88939 9.49188C3.80707 9.43356 3.74762 9.3549 3.71103 9.2559C3.50067 8.6169 3.23542 8.0814 2.9153 7.6494C2.59518 7.2174 2.2842 6.8034 1.98237 6.4074C1.68969 6.0114 1.43597 5.6019 1.22122 5.1789C1.00609 4.7559 0.898533 4.2339 0.898533 3.6129C0.898533 2.7129 1.21408 1.9524 1.84518 1.3314C2.47628 0.710402 3.24914 0.399902 4.16378 0.399902C5.07841 0.399902 5.85128 0.710402 6.48237 1.3314C7.11347 1.9524 7.42902 2.7129 7.42902 3.6129C7.42902 4.2339 7.32384 4.7559 7.11347 5.1789C6.90311 5.6019 6.64701 6.0114 6.34518 6.4074C6.0525 6.8034 5.7439 7.2174 5.41939 7.6494C5.09451 8.0814 4.82689 8.6169 4.61652 9.2559C4.57994 9.3549 4.52048 9.43356 4.43817 9.49188C4.35585 9.55056 4.26439 9.5799 4.16378 9.5799ZM4.16378 4.7604C4.4839 4.7604 4.75829 4.6479 4.98695 4.4229C5.21561 4.1979 5.32994 3.9279 5.32994 3.6129C5.32994 3.2979 5.21561 3.0279 4.98695 2.8029C4.75829 2.5779 4.4839 2.4654 4.16378 2.4654C3.84365 2.4654 3.56926 2.5779 3.34061 2.8029C3.11195 3.0279 2.99762 3.2979 2.99762 3.6129C2.99762 3.9279 3.11195 4.1979 3.34061 4.4229C3.56926 4.6479 3.84365 4.7604 4.16378 4.7604Z\" fill=\"#AAAAAA\"/>
                        </svg>
                        ${appSetup.company_address}
                      </div>`
                    : ""
                }
                ${
                  appSetup?.company_phone
                    ? `<div style=\"display: flex; align-items: center; font-size: 14px; color: #666;\">
                        <svg width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-right: 6px;\">
                          <path d=\"M6.72656 4.30005V2.80005H5.22656V1.80005H6.72656V0.300049H7.72656V1.80005H9.22656V2.80005H7.72656V4.30005H6.72656ZM8.70156 9.30005C7.62656 9.30005 6.57873 9.06038 5.55806 8.58105C4.53706 8.10205 3.6329 7.46872 2.84556 6.68105C2.0579 5.89372 1.42456 4.98955 0.945563 3.96855C0.466229 2.94788 0.226562 1.90005 0.226562 0.825049C0.226562 0.675049 0.276562 0.550049 0.376562 0.450049C0.476562 0.350049 0.601563 0.300049 0.751563 0.300049H2.77656C2.89323 0.300049 2.9974 0.337549 3.08906 0.412549C3.18073 0.487549 3.2349 0.583382 3.25156 0.700049L3.57656 2.45005C3.59323 2.56672 3.59123 2.67288 3.57056 2.76855C3.54956 2.86455 3.50156 2.95005 3.42656 3.02505L2.22656 4.25005C2.57656 4.85005 3.01406 5.41255 3.53906 5.93755C4.06406 6.46255 4.64323 6.91672 5.27656 7.30005L6.45156 6.12505C6.52656 6.05005 6.62456 5.99372 6.74556 5.95605C6.86623 5.91872 6.9849 5.90838 7.10156 5.92505L8.82656 6.27505C8.94323 6.30005 9.03906 6.35622 9.11406 6.44355C9.18906 6.53122 9.22656 6.63338 9.22656 6.75005V8.77505C9.22656 8.92505 9.17656 9.05005 9.07656 9.15005C8.97656 9.25005 8.85156 9.30005 8.70156 9.30005Z\" fill=\"#AAAAAA\"/>
                        </svg>
                        ${appSetup.company_phone}
                      </div>`
                    : ""
                }
              </div>
            </div>
          `
              : ""
          }
          
          <!-- Document Title and Info -->
          <div style=\"text-align: center; margin-bottom: 30px;\">
           <div style=\"display: flex; justify-content: space-between; margin-bottom: 15px; padding: 0 20px;\">
               <div style=\"text-align: left;\">
                 <div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600; display: flex; align-items: center;\">${
                   type || "Document"
                 } ${
          partNumber || ""
        } <span style=\"margin: 0 8px; font-size: 18px; font-weight: 300;\">|</span> Revision ${
          myRevision || ""
        }-</div>
               </div>
              <div style=\"text-align: right;\">
          ${
            releaseInfo
              ? `<div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600; margin-bottom: 4px;\">${releaseInfo}</div>`
              : ""
          }
                <div style=\"color: #1a5fb4; font-size: 14px; font-weight: 600;\">${exportInfo}</div>
              </div>
            </div>
            <div style=\"font-size: 24px; font-weight: 700; margin-bottom: 15px; color: #333;text-align:left\">${headerTitle}</div>
            <div style=\"font-size: 18px; font-weight: 600; margin-bottom: 20px; color: #1a5fb4;text-align:left\">${headerSub}</div>
            
            <!-- Blue Info Section -->
            
          </div>
        `;

        // Create table for this page only
        const pageTableEl = document.createElement("table");
        pageTableEl.style.cssText =
          "width: 100%; border-collapse: collapse; font-size: 14px; margin-top: 20px;";

        // Build header
        const thead = document.createElement("thead");
        thead.innerHTML = `
          <tr>
            <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">User</th>
            <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Date</th>
            <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Time</th>
            <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Signature</th>
            <th style=\"background:#000; color:#fff; text-align:center; padding:12px 8px; border:1px solid #000; font-weight: bold; font-size: 14px;\">Status</th>
          </tr>`;

        // Build body with only this page's rows
        const tbody = document.createElement("tbody");
        pageRows.forEach((r) => {
          const tr = document.createElement("tr");
          tr.innerHTML = `
            <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.fullName}</td>
            <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.date}</td>
            <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.time}</td>
            <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; height:60px; min-height:60px;\"></td>
            <td style=\"padding:12px 8px; border:1px solid #000; text-align:center; vertical-align:middle; font-size: 14px;\">${r.status}</td>
          `;
          const sigTd = tr.children[3];
          if (r.sigUrl) {
            const img = document.createElement("img");
            img.src = r.sigUrl;
            img.style.height = "45px";
            img.style.maxWidth = "120px";
            img.style.objectFit = "contain";
            img.style.display = "block";
            img.style.margin = "0 auto";
            sigTd.appendChild(img);
          }
          tbody.appendChild(tr);
        });

        pageTableEl.appendChild(thead);
        pageTableEl.appendChild(tbody);
        pageContentDiv.appendChild(pageTableEl);

        pageWrapperDiv.appendChild(pageContentDiv);
        pageTemp.appendChild(pageWrapperDiv);
        document.body.appendChild(pageTemp);

        // Wait for images to load
        const pageImgs = Array.from(pageTemp.querySelectorAll("img"));
        await Promise.all(
          pageImgs.map((img) =>
            img.decode?.().catch(
              () =>
                new Promise((resolve) => {
                  if (img.complete) return resolve();
                  img.onload = () => resolve();
                  img.onerror = () => resolve();
                })
            )
          )
        );

        // Capture this page
        const pageCanvas = await html2canvas(pageTemp, {
          useCORS: true,
          backgroundColor: "#fff",
          scale: 2,
        });

        document.body.removeChild(pageTemp);

        const pageImgData = pageCanvas.toDataURL("image/png");
        const pageImgHeight = (pageCanvas.height * imgWidth) / pageCanvas.width;

        if (currentPage === 1) {
          // First page - add to existing PDF
          pdf.addImage(
            pageImgData,
            "PNG",
            horizontalMargin,
            verticalMargin,
            imgWidth,
            pageImgHeight,
            undefined,
            "FAST"
          );
        } else {
          // Additional pages
          pdf.addPage();
          pdf.addImage(
            pageImgData,
            "PNG",
            horizontalMargin,
            verticalMargin,
            imgWidth,
            pageImgHeight,
            undefined,
            "FAST"
          );
        }

        // Add footer to each page using jsPDF methods
        pdf.setFontSize(8);
        pdf.setTextColor(102, 102, 102);
        // Add a line separator above footer
        pdf.setLineWidth(0.5);
        pdf.setDrawColor(204, 204, 204);
        pdf.line(
          horizontalMargin,
          pageHeight - 35,
          pageWidth - horizontalMargin,
          pageHeight - 35
        );
        // Add footer text
        pdf.text(proprietaryText, horizontalMargin, pageHeight - 15);
        pdf.text(
          `Page ${currentPage}/${pages.length}`,
          pageWidth - horizontalMargin,
          pageHeight - 15,
          { align: "right" }
        );
      }

      const fileName = `${type || "Document"}_${partNumber || ""}_${
        filteredRevisionData.length > 0 ? "Filtered" : "All"
      }_Revisions_Signatures.pdf`;
      pdf.save(fileName.replace(/\s+/g, "_"));
    } catch (e) {
      console.error("Error exporting signatures PDF:", e);
    }
  };
  // Same PDF pipeline as module ZIP export (API → RenderRevisionNodes → ExportFormatPopup).
  const handleExportPDF = async () => {
    try {
      if (!partId || !revisionId) {
        alert("Missing part or revision for PDF export.");
        return;
      }

      const nodesResult = await dispatch(
        getRevAllNodes({ partId, revisionId }),
      ).unwrap();
      const nodesData = Array.isArray(nodesResult) ? nodesResult : [];

      let zipBomRows = [];
      try {
        const bomPayload = await dispatch(
          getBom({ partId, revisionId }),
        ).unwrap();
        zipBomRows = Array.isArray(bomPayload?.results)
          ? bomPayload.results
          : [];
      } catch (bomErr) {
      }

      let zipTrainingLogRows = [];
      try {
        const revPayload = await dispatch(
          getProcedureRevisionsForPart({ partId }),
        ).unwrap();
        const revs = Array.isArray(revPayload?.results)
          ? revPayload.results
          : [];
        zipTrainingLogRows = await fetchMergedTrainingLogsForDocumentTable(
          dispatch,
          partId,
          revisionId,
          revs,
        );
      } catch (tlErr) {
      }

      setPdfEngineZipPayload({
        partId,
        revisionId,
        myRevision: myRevision || "",
        typeName: type || "",
        partNumber: partNumber || "",
        description: description || "",
        revisionData: revisionDataToRender || revisionData || [],
        nodesData,
      });

      await new Promise((resolve) =>
        requestAnimationFrame(() => requestAnimationFrame(resolve)),
      );

      await runDocumentPdfExport({
        meta: {
          type: type || "",
          partNumber: partNumber || "",
          description: description || "",
          myRevision: myRevision || "",
          revisionId,
        },
        revisionDataOverride: revisionDataToRender || revisionData || [],
        filteredRevisionDataOverride: [],
        bomTableOverride: zipBomRows,
        trainingLogsOverride: zipTrainingLogRows,
        allNodesDataForTrainingLog: nodesData,
      });

      setPdfEngineZipPayload(null);
    } catch (e) {
      console.error("Error exporting PDF:", e);
      setPdfEngineZipPayload(null);
      alert(`Error exporting PDF: ${e?.message || e}`);
    }
  };

  // Export full preview page to mHTML (single-file HTML snapshot)
  const handleExportMHTML = async () => {
    try {
      const container = zoomContainerRef.current;
      if (!container) return;

      const previousTransform = container.style.transform;
      container.style.transform = "scale(1)";

      const titleText = `${type || "Document"} ${partNumber || ""} Rev ${
        myRevision || ""
      }`.trim();

      // Clone preview container and absolutize media URLs
      const clone = container.cloneNode(true);
      const absolutize = (url) => {
        try {
          return new URL(url, window.location.href).href;
        } catch {
          return url;
        }
      };
      clone.querySelectorAll("img").forEach((el) => {
        if (el.getAttribute("src"))
          el.setAttribute("src", absolutize(el.getAttribute("src")));
      });
      clone.querySelectorAll("video, source").forEach((el) => {
        if (el.getAttribute("src"))
          el.setAttribute("src", absolutize(el.getAttribute("src")));
      });
      clone.querySelectorAll("a").forEach((el) => {
        if (el.getAttribute("href"))
          el.setAttribute("href", absolutize(el.getAttribute("href")));
      });

      // Replace canvas elements with images so content persists without app runtime
      try {
        const liveCanvases = Array.from(container.querySelectorAll("canvas"));
        const clonedCanvases = Array.from(clone.querySelectorAll("canvas"));
        for (let i = 0; i < clonedCanvases.length; i++) {
          const live = liveCanvases[i];
          const cloned = clonedCanvases[i];
          if (!live || !cloned) continue;
          let dataURL = "";
          try {
            dataURL = live.toDataURL("image/png");
          } catch (_) {
            // Tainted canvas – fallback to element snapshot
            const snap = await html2canvas(live, {
              useCORS: true,
              backgroundColor: "#fff",
              scale: 2,
            });
            dataURL = snap.toDataURL("image/png");
          }
          const img = document.createElement("img");
          img.src = dataURL;
          // Preserve size
          const rect = live.getBoundingClientRect();
          img.width = Math.max(1, Math.round(rect.width));
          img.height = Math.max(1, Math.round(rect.height));
          img.style.width = rect.width + "px";
          img.style.height = rect.height + "px";
          cloned.replaceWith(img);
        }
      } catch (_) {}
      // Collect same-origin CSS rules for inline style snapshot
      let inlinedCSS =
        "body{margin:16px;background:#fff;color:#000;font-family:Arial,Helvetica,sans-serif;}";
      try {
        Array.from(document.styleSheets).forEach((sheet) => {
          try {
            const rules = sheet.cssRules || [];
            Array.from(rules).forEach((rule) => {
              inlinedCSS += rule.cssText || "";
            });
          } catch (_) {
            /* ignore cross-origin stylesheets */
          }
        });
      } catch (_) {}

      // Ensure absolute positioning context for cloned root to avoid relying on app styles
      const html = `<!DOCTYPE html>\n<html>\n<head>\n<meta charset=\"UTF-8\"/>\n<meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\"/>\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/>\n<title>${titleText}</title>\n<style>${inlinedCSS}</style>\n</head>\n<body style=\"margin:16px\">\n<div id=\"export-root\" style=\"position:relative; transform-origin: top left;\">${clone.outerHTML}</div>\n<script>try{document.querySelectorAll('[contenteditable]').forEach(e=>e.removeAttribute('contenteditable'));}catch(e){}</script>\n</body>\n</html>`;

      // Restore transform
      container.style.transform = previousTransform;

      // Save as standard single-file HTML for maximum compatibility
      const blob = new Blob([html], { type: "text/html;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${type || "Document"}_${partNumber || ""}_Rev_${
        myRevision || ""
      }.html`.replace(/\s+/g, "_");
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Error exporting mHTML:", e);
    }
  };

  useEffect(() => {
    if (users.length > 0 && !submissionBy) {
      setSubmissionBy(users[0].id);
    }
  }, [users, submissionBy]);

  useEffect(() => {
    if (users.length > 0 && approvedBy.length === 0) {
      setApprovedBy([users[0].id]); // ✅ wrap it in an array
    }
  }, [users, approvedBy]);

  useEffect(() => {
    if (users.length > 0 && !releasedBy) {
      setReleasedBy(users[0].id);
    }
  }, [users, releasedBy]);

  const getLatestReleasedRevision = (revisionDataList = []) => {
    const releasedRevisions = [];

    revisionDataList.forEach((rev) => {
      rev.status_changes?.forEach((statusChange) => {
        if (statusChange.status_changed_to === "Released") {
          releasedRevisions.push({
            ...rev,
            releasedAt: statusChange?.audit_trail?.date,
          });
        }
      });
    });

    // Sort by release date descending
    releasedRevisions.sort(
      (a, b) => dayjs(b.releasedAt).valueOf() - dayjs(a.releasedAt).valueOf()
    );

    return releasedRevisions[0] || null;
  };

  const latestReleased = getLatestReleasedRevision(
    [...revisionData].sort((a, b) => {
      const revA = parseRevision(a.rev);
      const revB = parseRevision(b.rev);
      if (!revA && !revB) return 0;
      if (!revA) return 1;
      if (!revB) return -1;
      if (revA.type === "special") return -1;
      if (revB.type === "special") return 1;
      if (revA.base !== revB.base) return revA.base.localeCompare(revB.base);
      if (revA.type === "major" && revB.type !== "major") return -1;
      if (revB.type === "major" && revA.type !== "major") return 1;
      if (revA.minorNum !== revB.minorNum) return revA.minorNum - revB.minorNum;
      return revA.amendChar.localeCompare(revB.amendChar);
    })
  );

  const handleAppBarBack = useCallback(() => {
    navigateAwayRef.current = true;
    setIsNavigatingAway(true);
    // Defer cleanup to unmount effect to avoid blocking navigation
    navigate(-1);
  }, [navigate]);

  useEffect(() => {
    setPreviewNodesContentReady(false);
    hasFetchedStepsRef.current = false;
    hasFetchedSubstepsRef.current = false;
    hasFetchedContentRef.current = false;
  }, [partId, revisionId]);

  // Add useEffect to fetch sections data if not available
  useEffect(() => {
    let cancelled = false;
    const fetchSectionsData = async () => {
      if (navigateAwayRef.current || cancelled) return;
      if (partId && revisionId && (!sections || sections.length === 0)) {
        try {
          await dispatch(getAllSectionsForPart({ partId, revisionId }));
        } catch (error) {
          console.error("Error fetching sections data in PreviewNodes:", error);
        }
      }
    };

    fetchSectionsData();
    return () => {
      cancelled = true;
    };
  }, [dispatch, partId, revisionId, sections]);

  // Add useEffect to fetch steps data for all sections
  useEffect(() => {
    if (hasFetchedStepsRef.current) return;
    let cancelled = false;
    const fetchStepsData = async () => {
      if (navigateAwayRef.current || cancelled) return;
      if (!partId || !revisionId || !sections || sections.length === 0) {
        return;
      }

      try {
        hasFetchedStepsRef.current = true;

        // Fetch steps for all sections
        for (const section of sections) {
          if (navigateAwayRef.current || cancelled) return;
          const sectionId = section.section_tree_node_id;

          // Only fetch if we don't already have steps for this section
          if (
            !stepsBySection[sectionId] ||
            stepsBySection[sectionId].length === 0
          ) {
            await dispatch(
              getAllStepsForSection({
                partId,
                revisionId,
                sectionId,
              })
            );
          }
        }
      } catch (error) {
        console.error("Error fetching steps data in PreviewNodes:", error);
      }
    };

    fetchStepsData();
    return () => {
      cancelled = true;
    };
  }, [dispatch, partId, revisionId, sections, stepsBySection]);

  // Add useEffect to fetch substeps data for all steps
  useEffect(() => {
    if (hasFetchedSubstepsRef.current) return;
    let cancelled = false;
    const fetchSubstepsData = async () => {
      if (navigateAwayRef.current || cancelled) return;
      if (!partId || !revisionId || !sections || sections.length === 0) {
        return;
      }

      try {
        hasFetchedSubstepsRef.current = true;

        // Fetch substeps for all steps in all sections
        for (const section of sections) {
          if (navigateAwayRef.current || cancelled) return;
          const sectionId = section.section_tree_node_id;
          const stepsInSection = stepsBySection[sectionId] || [];

          for (const step of stepsInSection) {
            if (navigateAwayRef.current || cancelled) return;
            const stepId = step.step_tree_node_id;

            // Only fetch if we don't already have substeps for this step
            if (
              !substepsByStep[stepId] ||
              substepsByStep[stepId].length === 0
            ) {
              await dispatch(
                getAllSubstepsForStep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                })
              );
            }
          }
        }
      } catch (error) {
        console.error("Error fetching substeps data in PreviewNodes:", error);
      }
    };

    fetchSubstepsData();
    return () => {
      cancelled = true;
    };
  }, [dispatch, partId, revisionId, sections, stepsBySection, substepsByStep]);

  // Add useEffect to fetch all content data for all steps and substeps
  useEffect(() => {
    if (hasFetchedContentRef.current) return;
    let cancelled = false;
    const fetchAllContentData = async () => {
      if (navigateAwayRef.current || cancelled) return;
      if (!partId || !revisionId || !sections || sections.length === 0) {
        if (
          partId &&
          revisionId &&
          !sectionsLoading &&
          (!sections || sections.length === 0)
        ) {
          setPreviewNodesContentReady(true);
        }
        return;
      }

      try {
        hasFetchedContentRef.current = true;
        // Fetch all content data for all steps in all sections
        for (const section of sections) {
          if (navigateAwayRef.current || cancelled) return;
          const sectionId = section.section_tree_node_id;
          const stepsInSection = stepsBySection[sectionId] || [];

          for (const step of stepsInSection) {
            if (navigateAwayRef.current || cancelled) return;
            const stepId = step.step_tree_node_id;

            // Fetch all types of content data for the step
            await Promise.all([
              dispatch(
                getAllRichTextsForStep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                })
              ),
              dispatch(
                getAllCanvasesForStep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                })
              ),
              dispatch(
                getAllFormsForStep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                })
              ),
              dispatch(
                getAllAttachmentsForStep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                })
              ),
              dispatch(
                getAllVideosForStep({
                  partId,
                  revisionId,
                  sectionId,
                  stepId,
                })
              ),
            ]);
            // Fetch all types of content data for all substeps of this step
            const substepsInStep = substepsByStep[stepId] || [];
            for (const substep of substepsInStep) {
              if (navigateAwayRef.current || cancelled) return;
              const substepId = substep.sub_step_tree_node_id;

              await Promise.all([
                dispatch(
                  getAllRichTextsForSubstep({
                    partId,
                    revisionId,
                    sectionId,
                    stepId,
                    substepId,
                  })
                ),
                dispatch(
                  getAllCanvasesForSubstep({
                    partId,
                    revisionId,
                    sectionId,
                    stepId,
                    substepId,
                  })
                ),
                dispatch(
                  getAllFormsForSubstep({
                    partId,
                    revisionId,
                    sectionId,
                    stepId,
                    substepId,
                  })
                ),
                dispatch(
                  getAllAttachmentsForSubstep({
                    partId,
                    revisionId,
                    sectionId,
                    stepId,
                    substepId,
                  })
                ),
                dispatch(
                  getAllVideosForSubstep({
                    partId,
                    revisionId,
                    sectionId,
                    stepId,
                    substepId,
                  })
                ),
              ]);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching content data in PreviewNodes:", error);
      } finally {
        if (!cancelled && !navigateAwayRef.current) {
          setPreviewNodesContentReady(true);
        }
      }
    };
    fetchAllContentData();
    return () => {
      cancelled = true;
    };
  }, [
    dispatch,
    partId,
    revisionId,
    sections,
    stepsBySection,
    substepsByStep,
    sectionsLoading,
  ]);

  // Cleanup localStorage when component unmounts
  useEffect(() => {
    return () => {
      navigateAwayRef.current = true;
      // Clear AddSection and EditSection localStorage when component unmounts
      try {
        const keys = Object.keys(localStorage);

        // Clear AddSection/EditSection data
        keys.forEach((key) => {
          if (key.startsWith("addSection_") || key.startsWith("editSection_")) {
            localStorage.removeItem(key);
          }
        });
      } catch (e) {
      }
    };
  }, []);

  // Handle module preview
  if (location.state?.previewType === "module") {
    return <ModulePreview />;
  }

  // Handle procedure preview – reuse AddProcedure layout components in read-only
  if (location.state?.previewType === "procedure") {
    const { procedurePreviewData, revision } = location.state || {};

    // Calculate latest revision if not provided
    const latestRevision =
      revision ||
      (() => {
        const revisionData = procedurePreviewData?.revisionData || [];
        if (revisionData.length === 0) return "A-";
        const sorted = [...revisionData].sort((a, b) => {
          const revA = parseRevision(a.rev);
          const revB = parseRevision(b.rev);
          if (!revA && !revB) return 0;
          if (!revA) return 1;
          if (!revB) return -1;
          if (revA.type === "special") return -1;
          if (revB.type === "special") return 1;
          if (revA.type === "special_chars") return -1;
          if (revB.type === "special_chars") return 1;
          if (revA.base !== revB.base)
            return revA.base.localeCompare(revB.base);
          if (revA.type === "major" && revB.type !== "major") return -1;
          if (revB.type === "major" && revA.type !== "major") return 1;
          if (revA.minorNum !== revB.minorNum)
            return revA.minorNum - revB.minorNum;
          return revA.amendChar.localeCompare(revB.amendChar);
        });
        return sorted[sorted.length - 1]?.rev || "A-";
      })();

    // Minimal inline preview rendering matching AddProcedure layout
    return (
      <div>
        <AppBar
          subTitleAboveTitle={
            <div style={{ marginBottom: "8px" }}>
              {localStorage.getItem("user_name")} is Previewing
            </div>
          }
          onBack={() => window.history.back()}
          title={
            procedurePreviewData?.procedureType
              ? `${procedurePreviewData.procedureType} ${procedurePreviewData.procedureNumber} Rev ${latestRevision}`
              : "Document Preview"
          }
          showBlackTitle={true}
          showTablesDropdown={false}
          showBookmark={false}
          showProfileButton={false}
          showQuestionIcon={false}
          buttons={[
            {
              label: (
                <svg
                  width="38"
                  height="36"
                  viewBox="0 0 38 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5 9.9C11.6326 9.9 11.7598 9.95268 11.8536 10.0464C11.9473 10.1402 12 10.2674 12 10.4V12.9C12 13.1652 12.1054 13.4196 12.2929 13.6071C12.4804 13.7946 12.7348 13.9 13 13.9H25C25.2652 13.9 25.5196 13.7946 25.7071 13.6071C25.8946 13.4196 26 13.1652 26 12.9V10.4C26 10.2674 26.0527 10.1402 26.1464 10.0464C26.2402 9.95268 26.3674 9.9 26.5 9.9C26.6326 9.9 26.7598 9.95268 26.8536 10.0464C26.9473 10.1402 27 10.2674 27 10.4V12.9C27 13.4304 26.7893 13.9391 26.4142 14.3142C26.0391 14.6893 25.5304 14.9 25 14.9H13C12.4696 14.9 11.9609 14.6893 11.5858 14.3142C11.2107 13.9391 11 13.4304 11 12.9V10.4C11 10.2674 11.0527 10.1402 11.1464 10.0464C11.2402 9.95268 11.3674 9.9 11.5 9.9Z"
                    fill="#6C757D"
                  />
                  <path
                    d="M18.646 11.854C18.6924 11.9006 18.7476 11.9375 18.8084 11.9627C18.8691 11.9879 18.9342 12.0009 19 12.0009C19.0658 12.0009 19.1309 11.9879 19.1916 11.9627C19.2524 11.9375 19.3076 11.9006 19.354 11.854L22.354 8.854C22.4479 8.76011 22.5006 8.63278 22.5006 8.5C22.5006 8.36722 22.4479 8.23989 22.354 8.146C22.2601 8.05211 22.1328 7.99937 22 7.99937C21.8672 7.99937 21.7399 8.05211 21.646 8.146L19.5 10.293V1.5C19.5 1.36739 19.4473 1.24021 19.3536 1.14645C19.2598 1.05268 19.1326 1 19 1C18.8674 1 18.7402 1.05268 18.6464 1.14645C18.5527 1.24021 18.5 1.36739 18.5 1.5V10.293L16.354 8.146C16.2601 8.05211 16.1328 7.99937 16 7.99937C15.8672 7.99937 15.7399 8.05211 15.646 8.146C15.5521 8.23989 15.4994 8.36722 15.4994 8.5C15.4994 8.63278 15.5521 8.76011 15.646 8.854L18.646 11.854Z"
                    fill="#6C757D"
                  />
                  <path
                    d="M6.94434 30.0034V31H2.05029V30.0034H6.94434ZM2.29785 21.7578V31H1.07275V21.7578H2.29785ZM6.29688 25.7314V26.728H2.05029V25.7314H6.29688ZM6.88086 21.7578V22.7607H2.05029V21.7578H6.88086ZM9.07715 24.1318L10.5815 26.6328L12.105 24.1318H13.4824L11.2354 27.5215L13.5522 31H12.1938L10.6069 28.4229L9.02002 31H7.65527L9.96582 27.5215L7.7251 24.1318H9.07715ZM15.9072 25.4521V33.6406H14.7266V24.1318H15.8057L15.9072 25.4521ZM20.5347 27.5088V27.6421C20.5347 28.1414 20.4754 28.6048 20.3569 29.0322C20.2384 29.4554 20.0649 29.8236 19.8364 30.1367C19.6121 30.4499 19.335 30.6932 19.0049 30.8667C18.6748 31.0402 18.2961 31.127 17.8687 31.127C17.4328 31.127 17.0477 31.055 16.7134 30.9111C16.3791 30.7673 16.0955 30.5578 15.8628 30.2827C15.63 30.0076 15.4438 29.6776 15.3042 29.2925C15.1688 28.9074 15.0757 28.4736 15.0249 27.9912V27.2803C15.0757 26.7725 15.1709 26.3175 15.3105 25.9155C15.4502 25.5135 15.6343 25.1707 15.8628 24.8872C16.0955 24.5994 16.377 24.3815 16.707 24.2334C17.0371 24.0811 17.418 24.0049 17.8496 24.0049C18.2812 24.0049 18.6642 24.0895 18.9985 24.2588C19.3328 24.4238 19.6143 24.6608 19.8428 24.9697C20.0713 25.2786 20.2427 25.6489 20.3569 26.0806C20.4754 26.508 20.5347 26.984 20.5347 27.5088ZM19.354 27.6421V27.5088C19.354 27.166 19.318 26.8444 19.2461 26.5439C19.1742 26.2393 19.062 25.9727 18.9097 25.7441C18.7616 25.5114 18.5711 25.3294 18.3384 25.1982C18.1056 25.0628 17.8285 24.9951 17.5068 24.9951C17.2106 24.9951 16.9525 25.0459 16.7324 25.1475C16.5166 25.249 16.3325 25.3866 16.1802 25.5601C16.0278 25.7293 15.903 25.924 15.8057 26.144C15.7126 26.3599 15.6427 26.5841 15.5962 26.8169V28.4609C15.6808 28.7572 15.7993 29.0365 15.9517 29.2988C16.104 29.557 16.3071 29.7664 16.561 29.9272C16.8149 30.0838 17.1344 30.1621 17.5195 30.1621C17.8369 30.1621 18.1099 30.0965 18.3384 29.9653C18.5711 29.8299 18.7616 29.6458 18.9097 29.4131C19.062 29.1803 19.1742 28.9137 19.2461 28.6133C19.318 28.3086 19.354 27.9849 19.354 27.6421ZM21.7217 27.6421V27.4961C21.7217 27.001 21.7936 26.5418 21.9375 26.1187C22.0814 25.6912 22.2887 25.321 22.5596 25.0078C22.8304 24.6904 23.1584 24.445 23.5435 24.2715C23.9285 24.0938 24.3602 24.0049 24.8384 24.0049C25.3208 24.0049 25.7546 24.0938 26.1396 24.2715C26.529 24.445 26.859 24.6904 27.1299 25.0078C27.4049 25.321 27.6144 25.6912 27.7583 26.1187C27.9022 26.5418 27.9741 27.001 27.9741 27.4961V27.6421C27.9741 28.1372 27.9022 28.5964 27.7583 29.0195C27.6144 29.4427 27.4049 29.813 27.1299 30.1304C26.859 30.4435 26.5311 30.689 26.146 30.8667C25.7651 31.0402 25.3335 31.127 24.8511 31.127C24.3687 31.127 23.9349 31.0402 23.5498 30.8667C23.1647 30.689 22.8346 30.4435 22.5596 30.1304C22.2887 29.813 22.0814 29.4427 21.9375 29.0195C21.7936 28.5964 21.7217 28.1372 21.7217 27.6421ZM22.896 27.4961V27.6421C22.896 27.9849 22.9362 28.3086 23.0166 28.6133C23.097 28.9137 23.2176 29.1803 23.3784 29.4131C23.5435 29.6458 23.7487 29.8299 23.9941 29.9653C24.2396 30.0965 24.5252 30.1621 24.8511 30.1621C25.1727 30.1621 25.4541 30.0965 25.6953 29.9653C25.9408 29.8299 26.1439 29.6458 26.3047 29.4131C26.4655 29.1803 26.5861 28.9137 26.6665 28.6133C26.7511 28.3086 26.7935 27.9849 26.7935 27.6421V27.4961C26.7935 27.1576 26.7511 26.8381 26.6665 26.5376C26.5861 26.2329 26.4634 25.9642 26.2983 25.7314C26.1375 25.4945 25.9344 25.3083 25.689 25.1729C25.4478 25.0374 25.1642 24.9697 24.8384 24.9697C24.5168 24.9697 24.2332 25.0374 23.9878 25.1729C23.7466 25.3083 23.5435 25.4945 23.3784 25.7314C23.2176 25.9642 23.097 26.2329 23.0166 26.5376C22.9362 26.8381 22.896 27.1576 22.896 27.4961ZM30.6211 25.2109V31H29.4468V24.1318H30.5894L30.6211 25.2109ZM32.7666 24.0938L32.7603 25.1855C32.6629 25.1644 32.5698 25.1517 32.481 25.1475C32.3963 25.139 32.299 25.1348 32.189 25.1348C31.9181 25.1348 31.679 25.1771 31.4717 25.2617C31.2643 25.3464 31.0887 25.4648 30.9448 25.6172C30.8009 25.7695 30.6867 25.9515 30.6021 26.1631C30.5216 26.3704 30.4688 26.599 30.4434 26.8486L30.1133 27.0391C30.1133 26.6243 30.1535 26.235 30.2339 25.8711C30.3185 25.5072 30.4476 25.1855 30.6211 24.9062C30.7946 24.6227 31.0146 24.4027 31.2812 24.2461C31.5521 24.0853 31.8737 24.0049 32.2461 24.0049C32.3307 24.0049 32.4281 24.0155 32.5381 24.0366C32.6481 24.0535 32.7243 24.0726 32.7666 24.0938ZM37.0449 24.1318V25.0332H33.3315V24.1318H37.0449ZM34.5884 22.4624H35.7627V29.2988C35.7627 29.5316 35.7987 29.7072 35.8706 29.8257C35.9425 29.9442 36.0356 30.0225 36.1499 30.0605C36.2642 30.0986 36.3869 30.1177 36.5181 30.1177C36.6154 30.1177 36.717 30.1092 36.8228 30.0923C36.9328 30.0711 37.0153 30.0542 37.0703 30.0415L37.0767 31C36.9836 31.0296 36.8608 31.0571 36.7085 31.0825C36.5604 31.1121 36.3805 31.127 36.1689 31.127C35.8812 31.127 35.6167 31.0698 35.3755 30.9556C35.1343 30.8413 34.9417 30.6509 34.7979 30.3843C34.6582 30.1134 34.5884 29.7495 34.5884 29.2925V22.4624Z"
                    fill="#6C757D"
                  />
                </svg>
              ),
              onClick: () => {
                // Export functionality not needed in preview
              },
            },
          ]}
        />
        <form className="procedure-form">
          <div className="form-row">
            <div className="form-group">
              <label>
                Document Number<span className="required">*</span>
              </label>
              <input
                type="text"
                value={procedurePreviewData?.procedureNumber || ""}
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Document Type (Read Only)</label>
              <input
                type="text"
                value={procedurePreviewData?.procedureType || ""}
                readOnly
              />
            </div>
            <div className="form-group">
              <label>
                References (Separate Each Reference using Space Key)
              </label>
              <input
                type="text"
                value={procedurePreviewData?.references || ""}
                readOnly
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Document Description (Read Only)</label>
              <div style={{ width: "92%" }}>
                <RenderHtml
                  descriptionBox={true}
                  content={procedurePreviewData?.description || ""}
                />
              </div>
            </div>
            <div className="form-group">
              <label>Revision Details</label>
              <textarea
                value={procedurePreviewData?.revisionDetails || ""}
                readOnly
                style={{ resize: "none" }}
              />
            </div>
          </div>
        </form>
        <div style={{ padding: "10px" }} />
        <div>
          <h4 style={{ paddingLeft: 16 }}>Revisions Table</h4>
          <div style={{ paddingLeft: 16, paddingRight: 16 }}>
            {/* Full revisions table with all columns */}
            <table className="table">
              <thead>
                <tr>
                  <th>Rev</th>
                  <th>Date Released</th>
                  <th>Revision Details</th>
                  <th>Submitter</th>
                  <th>Approvers</th>
                  <th>Released By</th>
                  <th>References</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  // Sort revisions using the same logic as AddProcedure
                  const revisionData = procedurePreviewData?.revisionData || [];
                  const sortedRevisions = [...revisionData].sort((a, b) => {
                    const revA = parseRevision(a.rev);
                    const revB = parseRevision(b.rev);
                    if (!revA && !revB) return 0;
                    if (!revA) return 1;
                    if (!revB) return -1;
                    if (revA.type === "special") return -1;
                    if (revB.type === "special") return 1;
                    if (revA.type === "special_chars") return -1;
                    if (revB.type === "special_chars") return 1;
                    if (revA.base !== revB.base)
                      return revA.base.localeCompare(revB.base);
                    if (revA.type === "major" && revB.type !== "major")
                      return -1;
                    if (revB.type === "major" && revA.type !== "major")
                      return 1;
                    if (revA.minorNum !== revB.minorNum)
                      return revA.minorNum - revB.minorNum;
                    return revA.amendChar.localeCompare(revB.amendChar);
                  });

                  return sortedRevisions.map((r, i) => {
                    // Format date released
                    const formatDate = (dateString) => {
                      if (!dateString) return "-";
                      try {
                        const date = new Date(dateString);
                        return date.toLocaleDateString();
                      } catch (e) {
                        return "-";
                      }
                    };

                    // Get latest status
                    const latestStatus =
                      r.status_changes?.find((sc) => sc.is_latest)
                        ?.status_changed_to ||
                      r.status ||
                      "-";

                    // Check if maintained outside system - use status_changes like Documents/RevisionTable
                    const isMaintainedOutside =
                      r.status_changes?.find((sc) => sc.is_latest)
                        ?.status_changed_to === "MAINTAINED OUTSIDE OF SYSTEM";

                    // Get submitter (from status_changes or direct field)
                    const submitterStatus = r.status_changes?.find(
                      (sc) =>
                        sc.status_changed_to === "Submitted For Approval" ||
                        sc.status_changed_to === "Not Submitted"
                    );
                    const submitter = isMaintainedOutside
                      ? "MAINTAINED OUTSIDE OF SYSTEM"
                      : submitterStatus?.changed_by_user
                      ? formatName(r, submitterStatus.changed_by_user)
                      : r.submitter
                      ? formatName(r, r.submitter)
                      : "-";

                    // Get approvers (from status_changes where status is "Approved")
                    const approvedStatuses =
                      r.status_changes?.filter(
                        (sc) => sc.status_changed_to === "Approved"
                      ) || [];
                    const approvers = isMaintainedOutside
                      ? "MAINTAINED OUTSIDE OF SYSTEM"
                      : approvedStatuses.length > 0
                      ? approvedStatuses
                          .map((sc) =>
                            sc.changed_by_user
                              ? formatName(r, sc.changed_by_user)
                              : ""
                          )
                          .filter(Boolean)
                          .join(", ") || "-"
                      : r.approver
                      ? formatName(r, r.approver)
                      : "-";

                    // Get releaser (from status_changes where status is "Released")
                    const releasedStatus = r.status_changes?.find(
                      (sc) => sc.status_changed_to === "Released"
                    );
                    const releaser = isMaintainedOutside
                      ? "MAINTAINED OUTSIDE OF SYSTEM"
                      : releasedStatus?.changed_by_user
                      ? formatName(r, releasedStatus.changed_by_user)
                      : r.releasedBy || r.releaser
                      ? formatName(r, r.releasedBy || r.releaser)
                      : "-";

                    return (
                      <tr key={i}>
                        <td>{r.rev || "-"}</td>
                        <td>{formatDate(r.date_released)}</td>
                        <td>{r.revision_details || "-"}</td>
                        <td>{submitter}</td>
                        <td>{approvers}</td>
                        <td>{releaser}</td>
                        <td>{r.reference || "-"}</td>
                        <td>{latestStatus}</td>
                        <td>
                          {!isMaintainedOutside && (
                            <button
                              className="right-arrow"
                              disabled={true}
                              style={{ cursor: "not-allowed", opacity: 0.5 }}
                            >
                              <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        </div>
        <div style={{ height: 80 }} />
      </div>
    );
  }

  return (
    <div>
      {/* AppBar with Version History trigger */}
      <AppBar
        title={`${type} ${partNumber}, Rev ${myRevision}`}
        showTablesDropdown={false}
        showBlackTitle={true}
        showBookmark={false}
        navigateTwoPagesBack={false}
        showEyeIcon={false}
        showProfileButton={false}
        showQuestionIcon={false}
        onBack={handleAppBarBack}
        // Add Version History trigger to AppBar dropdown
        subTitleAboveTitle={
          <>{localStorage.getItem("user_name")} is Previewing</>
        }
        versionHistoryHandler={() => setShowVersionHistory(true)}
        buttons={[
          {
            label: (
              <svg
                width="38"
                height="36"
                viewBox="0 0 38 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.5 9.9C11.6326 9.9 11.7598 9.95268 11.8536 10.0464C11.9473 10.1402 12 10.2674 12 10.4V12.9C12 13.1652 12.1054 13.4196 12.2929 13.6071C12.4804 13.7946 12.7348 13.9 13 13.9H25C25.2652 13.9 25.5196 13.7946 25.7071 13.6071C25.8946 13.4196 26 13.1652 26 12.9V10.4C26 10.2674 26.0527 10.1402 26.1464 10.0464C26.2402 9.95268 26.3674 9.9 26.5 9.9C26.6326 9.9 26.7598 9.95268 26.8536 10.0464C26.9473 10.1402 27 10.2674 27 10.4V12.9C27 13.4304 26.7893 13.9391 26.4142 14.3142C26.0391 14.6893 25.5304 14.9 25 14.9H13C12.4696 14.9 11.9609 14.6893 11.5858 14.3142C11.2107 13.9391 11 13.4304 11 12.9V10.4C11 10.2674 11.0527 10.1402 11.1464 10.0464C11.2402 9.95268 11.3674 9.9 11.5 9.9Z"
                  fill="#6C757D"
                />
                <path
                  d="M18.646 11.854C18.6924 11.9006 18.7476 11.9375 18.8084 11.9627C18.8691 11.9879 18.9342 12.0009 19 12.0009C19.0658 12.0009 19.1309 11.9879 19.1916 11.9627C19.2524 11.9375 19.3076 11.9006 19.354 11.854L22.354 8.854C22.4479 8.76011 22.5006 8.63278 22.5006 8.5C22.5006 8.36722 22.4479 8.23989 22.354 8.146C22.2601 8.05211 22.1328 7.99937 22 7.99937C21.8672 7.99937 21.7399 8.05211 21.646 8.146L19.5 10.293V1.5C19.5 1.36739 19.4473 1.24021 19.3536 1.14645C19.2598 1.05268 19.1326 1 19 1C18.8674 1 18.7402 1.05268 18.6464 1.14645C18.5527 1.24021 18.5 1.36739 18.5 1.5V10.293L16.354 8.146C16.2601 8.05211 16.1328 7.99937 16 7.99937C15.8672 7.99937 15.7399 8.05211 15.646 8.146C15.5521 8.23989 15.4994 8.36722 15.4994 8.5C15.4994 8.63278 15.5521 8.76011 15.646 8.854L18.646 11.854Z"
                  fill="#6C757D"
                />
                <path
                  d="M6.94434 30.0034V31H2.05029V30.0034H6.94434ZM2.29785 21.7578V31H1.07275V21.7578H2.29785ZM6.29688 25.7314V26.728H2.05029V25.7314H6.29688ZM6.88086 21.7578V22.7607H2.05029V21.7578H6.88086ZM9.07715 24.1318L10.5815 26.6328L12.105 24.1318H13.4824L11.2354 27.5215L13.5522 31H12.1938L10.6069 28.4229L9.02002 31H7.65527L9.96582 27.5215L7.7251 24.1318H9.07715ZM15.9072 25.4521V33.6406H14.7266V24.1318H15.8057L15.9072 25.4521ZM20.5347 27.5088V27.6421C20.5347 28.1414 20.4754 28.6048 20.3569 29.0322C20.2384 29.4554 20.0649 29.8236 19.8364 30.1367C19.6121 30.4499 19.335 30.6932 19.0049 30.8667C18.6748 31.0402 18.2961 31.127 17.8687 31.127C17.4328 31.127 17.0477 31.055 16.7134 30.9111C16.3791 30.7673 16.0955 30.5578 15.8628 30.2827C15.63 30.0076 15.4438 29.6776 15.3042 29.2925C15.1688 28.9074 15.0757 28.4736 15.0249 27.9912V27.2803C15.0757 26.7725 15.1709 26.3175 15.3105 25.9155C15.4502 25.5135 15.6343 25.1707 15.8628 24.8872C16.0955 24.5994 16.377 24.3815 16.707 24.2334C17.0371 24.0811 17.418 24.0049 17.8496 24.0049C18.2812 24.0049 18.6642 24.0895 18.9985 24.2588C19.3328 24.4238 19.6143 24.6608 19.8428 24.9697C20.0713 25.2786 20.2427 25.6489 20.3569 26.0806C20.4754 26.508 20.5347 26.984 20.5347 27.5088ZM19.354 27.6421V27.5088C19.354 27.166 19.318 26.8444 19.2461 26.5439C19.1742 26.2393 19.062 25.9727 18.9097 25.7441C18.7616 25.5114 18.5711 25.3294 18.3384 25.1982C18.1056 25.0628 17.8285 24.9951 17.5068 24.9951C17.2106 24.9951 16.9525 25.0459 16.7324 25.1475C16.5166 25.249 16.3325 25.3866 16.1802 25.5601C16.0278 25.7293 15.903 25.924 15.8057 26.144C15.7126 26.3599 15.6427 26.5841 15.5962 26.8169V28.4609C15.6808 28.7572 15.7993 29.0365 15.9517 29.2988C16.104 29.557 16.3071 29.7664 16.561 29.9272C16.8149 30.0838 17.1344 30.1621 17.5195 30.1621C17.8369 30.1621 18.1099 30.0965 18.3384 29.9653C18.5711 29.8299 18.7616 29.6458 18.9097 29.4131C19.062 29.1803 19.1742 28.9137 19.2461 28.6133C19.318 28.3086 19.354 27.9849 19.354 27.6421ZM21.7217 27.6421V27.4961C21.7217 27.001 21.7936 26.5418 21.9375 26.1187C22.0814 25.6912 22.2887 25.321 22.5596 25.0078C22.8304 24.6904 23.1584 24.445 23.5435 24.2715C23.9285 24.0938 24.3602 24.0049 24.8384 24.0049C25.3208 24.0049 25.7546 24.0938 26.1396 24.2715C26.529 24.445 26.859 24.6904 27.1299 25.0078C27.4049 25.321 27.6144 25.6912 27.7583 26.1187C27.9022 26.5418 27.9741 27.001 27.9741 27.4961V27.6421C27.9741 28.1372 27.9022 28.5964 27.7583 29.0195C27.6144 29.4427 27.4049 29.813 27.1299 30.1304C26.859 30.4435 26.5311 30.689 26.146 30.8667C25.7651 31.0402 25.3335 31.127 24.8511 31.127C24.3687 31.127 23.9349 31.0402 23.5498 30.8667C23.1647 30.689 22.8346 30.4435 22.5596 30.1304C22.2887 29.813 22.0814 29.4427 21.9375 29.0195C21.7936 28.5964 21.7217 28.1372 21.7217 27.6421ZM22.896 27.4961V27.6421C22.896 27.9849 22.9362 28.3086 23.0166 28.6133C23.097 28.9137 23.2176 29.1803 23.3784 29.4131C23.5435 29.6458 23.7487 29.8299 23.9941 29.9653C24.2396 30.0965 24.5252 30.1621 24.8511 30.1621C25.1727 30.1621 25.4541 30.0965 25.6953 29.9653C25.9408 29.8299 26.1439 29.6458 26.3047 29.4131C26.4655 29.1803 26.5861 28.9137 26.6665 28.6133C26.7511 28.3086 26.7935 27.9849 26.7935 27.6421V27.4961C26.7935 27.1576 26.7511 26.8381 26.6665 26.5376C26.5861 26.2329 26.4634 25.9642 26.2983 25.7314C26.1375 25.4945 25.9344 25.3083 25.689 25.1729C25.4478 25.0374 25.1642 24.9697 24.8384 24.9697C24.5168 24.9697 24.2332 25.0374 23.9878 25.1729C23.7466 25.3083 23.5435 25.4945 23.3784 25.7314C23.2176 25.9642 23.097 26.2329 23.0166 26.5376C22.9362 26.8381 22.896 27.1576 22.896 27.4961ZM30.6211 25.2109V31H29.4468V24.1318H30.5894L30.6211 25.2109ZM32.7666 24.0938L32.7603 25.1855C32.6629 25.1644 32.5698 25.1517 32.481 25.1475C32.3963 25.139 32.299 25.1348 32.189 25.1348C31.9181 25.1348 31.679 25.1771 31.4717 25.2617C31.2643 25.3464 31.0887 25.4648 30.9448 25.6172C30.8009 25.7695 30.6867 25.9515 30.6021 26.1631C30.5216 26.3704 30.4688 26.599 30.4434 26.8486L30.1133 27.0391C30.1133 26.6243 30.1535 26.235 30.2339 25.8711C30.3185 25.5072 30.4476 25.1855 30.6211 24.9062C30.7946 24.6227 31.0146 24.4027 31.2812 24.2461C31.5521 24.0853 31.8737 24.0049 32.2461 24.0049C32.3307 24.0049 32.4281 24.0155 32.5381 24.0366C32.6481 24.0535 32.7243 24.0726 32.7666 24.0938ZM37.0449 24.1318V25.0332H33.3315V24.1318H37.0449ZM34.5884 22.4624H35.7627V29.2988C35.7627 29.5316 35.7987 29.7072 35.8706 29.8257C35.9425 29.9442 36.0356 30.0225 36.1499 30.0605C36.2642 30.0986 36.3869 30.1177 36.5181 30.1177C36.6154 30.1177 36.717 30.1092 36.8228 30.0923C36.9328 30.0711 37.0153 30.0542 37.0703 30.0415L37.0767 31C36.9836 31.0296 36.8608 31.0571 36.7085 31.0825C36.5604 31.1121 36.3805 31.127 36.1689 31.127C35.8812 31.127 35.6167 31.0698 35.3755 30.9556C35.1343 30.8413 34.9417 30.6509 34.7979 30.3843C34.6582 30.1134 34.5884 29.7495 34.5884 29.2925V22.4624Z"
                  fill="#6C757D"
                />
              </svg>
            ),
            disabled: !areNodesReadyForExport,
            title: "Export will be enabled once all nodes are loaded.",
            onClick: () => {
              setIsExportPopupOpen(true);
            },
          },
        ]}
      />

      <div
        ref={zoomContainerRef}
        style={{
          transform: `scale(${zoomLevel})`,
          transformOrigin: "top center",
          transition: "transform 0.2s ease",
        }}
      >
        {
          <div
            style={{
              fontSize: "12px",
              color: "#444",
              marginBottom: "8px",
            }}
          >
            {basedOnText && <ShowLightText text={basedOnText} />}
            {currentText && <ShowLightText text={currentText} />}
          </div>
        }
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            padding: "8px 0",
            flexWrap: "wrap", // for responsiveness
          }}
        >
          {/* Checkbox + Title + Description */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                margin: 0,
              }}
            >
              <span style={{ fontSize: "20px", fontWeight: 600 }}>
                {type} {partNumber}
              </span>
            </label>

            {/* Description */}
            <span
              style={{ marginLeft: "2px", marginTop: "5px", color: "#666" }}
            >
              Description: <RenderHtml content={description} />
            </span>
          </div>

          {/* Right-aligned section */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              marginLeft: "auto",
            }}
          >
            <div>
              <strong>Status: </strong>
              <span style={{ color: "orange" }}>{status}</span>
            </div>

            <div>
              <strong>Revision: </strong>
              <span>{myRevision}</span>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h3 style={{ marginBottom: "-7px" }}>Revisions Table</h3>
          {/* <div className="button-container" style={{ margin: 0 }}>
            <button
              className="create-revision-button"
              onClick={handleSaveClick}
            >
              Create New Revision
            </button>
          </div> */}
        </div>
        <table className="table" style={{ marginTop: "-10px" }}>
          <thead>
            <tr>
              <th>Rev</th>
              <th>Date Released</th>
              <th>Revision Details</th>
              <th>Submitter / Requestor</th>
              <th>Approver</th>
              <th>References</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {[...revisionDataToRender]
              .sort((a, b) => {
                const revA = parseRevision(a.rev);
                const revB = parseRevision(b.rev);
                if (!revA && !revB) return 0;
                if (!revA) return 1;
                if (!revB) return -1;
                if (revA.type === "special") return -1;
                if (revB.type === "special") return 1;
                if (revA.base !== revB.base)
                  return revA.base.localeCompare(revB.base);
                if (revA.type === "major" && revB.type !== "major") return -1;
                if (revB.type === "major" && revA.type !== "major") return 1;
                if (revA.minorNum !== revB.minorNum)
                  return revA.minorNum - revB.minorNum;
                return revA.amendChar.localeCompare(revB.amendChar);
              })
              .map((rev, index) => {
                // Flatten all required_by entries from status_changes
                const requiredBy = "required_by" in rev ? rev.required_by : [];

                // Find users by purpose
                const submitter = requiredBy.find(
                  (rb) => rb.purpose?.toLowerCase() === "submit"
                )?.user;

                const approvers = requiredBy
                  .filter((rb) => rb.purpose?.toLowerCase() === "approve")
                  .map((rb) => rb.user)
                  .filter(Boolean); // filter out nulls

                const isCurrentOpnRev =
                  rev.procedure_revision_id === revisionId;
                const showNavLink =
                  !rev.is_maintained_outside_system && !isCurrentOpnRev
                    ? true
                    : false;

                return (
                  <tr
                    key={index}
                    className={`${
                      isCurrentOpnRev && "hilight-current-revision"
                    }`}
                  >
                    <td
                      style={
                        showNavLink
                          ? { cursor: "pointer", textDecoration: "underline" }
                          : {}
                      }
                      onClick={() => {
                        if (!showNavLink) return;
                        RedirectToRevision({
                          type_name: rev.type_name,
                          part_number: rev.part_number,
                          procedureRevisionId: rev.procedure_revision_id,
                          description: rev.part_description,
                          status: rev?.status_changes.find(
                            (s) => s.is_latest === true
                          )?.status_changed_to,
                          partId: rev.part_ref,
                          revision: rev.rev,
                        });
                      }}
                    >
                      {rev.rev || "-"}
                    </td>
                    <td>
                      {rev.date_released
                        ? new Date(rev.date_released).toLocaleDateString(
                            "ja-JP",
                            {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            }
                          )
                        : "-"}
                    </td>
                    <td>
                      {(() => {
                        const isCurrent =
                          rev.procedure_revision_id === revisionId;
                        const value =
                          isCurrent && overrideRevisionDetails != null
                            ? overrideRevisionDetails
                            : rev.revision_details;
                        return value || "-";
                      })()}
                    </td>
                    <td>
                      {rev.is_maintained_outside_system ? (
                        <div>MAINTAINED OUTSIDE OF SYSTEM</div>
                      ) : (
                        requiredBy
                          .filter(
                            (rb) => rb.purpose?.toLowerCase() === "submit"
                          )
                          .map((rb, i) => {
                            const name = formatName(rev, rb.user);
                            return (
                              <div key={i}>
                                {!rb.is_open
                                  ? `Submitted by ${name}`
                                  : `Pending Submission from ${name}`}
                              </div>
                            );
                          })
                      )}
                    </td>

                    <td>
                      {rev.is_maintained_outside_system ? (
                        <div>MAINTAINED OUTSIDE OF SYSTEM</div>
                      ) : (
                        requiredBy
                          .filter(
                            (rb) => rb.purpose?.toLowerCase() === "approve"
                          )
                          .map((rb, i) => {
                            const name = formatName(rev, rb.user);
                            return (
                              <div key={i}>
                                {!rb.is_open
                                  ? `Approved by ${name}`
                                  : `Pending Approval from ${name}`}
                              </div>
                            );
                          })
                      )}
                    </td>
                    <td>
                      {(() => {
                        const isCurrent =
                          rev.procedure_revision_id === revisionId;
                        const value =
                          isCurrent && overrideReference != null
                            ? overrideReference
                            : rev.reference;
                        return value || "-";
                      })()}
                    </td>
                    <td>
                      {rev.status_changes?.find((sc) => sc.is_latest)
                        ?.status_changed_to || "-"}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        <h3>Training Log</h3>
        <table className="table" style={{ marginTop: "-12px" }}>
          <thead>
            <tr>
              <th>Date of Training</th>
              <th>Trainer</th>
              <th>Trainer Signature</th>
              <th>Trainee</th>
              <th>Trainee Signature</th>
              <th>Revision Trained</th>
              <th>Training Status of Trainee</th>
            </tr>
          </thead>
          <tbody>
            {trainingLogs.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{new Date(row.date_of_training).toLocaleDateString()}</td>
                  <td>
                    {row.trainer
                      ? `${row.trainer.first_name} ${row.trainer.last_name}`
                      : "N/A"}
                  </td>
                  <td>
                    {row.trainer_signature?.data ? (
                      <img
                        src={`data:image/png;base64,${btoa(
                          String.fromCharCode(
                            ...new Uint8Array(row.trainer_signature.data)
                          )
                        )}`}
                        alt="Trainer Signature"
                        className="signature"
                      />
                    ) : (
                      "No Signature"
                    )}
                  </td>
                  <td>
                    {row.trainee
                      ? `${row.trainee.first_name} ${row.trainee.last_name}`
                      : "N/A"}
                  </td>
                  <td>
                    {row.trainee_signature?.data ? (
                      <img
                        src={`data:image/png;base64,${btoa(
                          String.fromCharCode(
                            ...new Uint8Array(row.trainee_signature.data)
                          )
                        )}`}
                        alt="Trainee Signature"
                        className="signature"
                      />
                    ) : (
                      "No Signature"
                    )}
                  </td>
                  <td>{row.version_id_ref || "N/A"}</td>
                  <td>
                    {row.is_maintained_outside_system
                      ? "Maintained Outside System"
                      : "In System"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <h3>{type} BOM</h3>
        <table className="table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Item Code</th>
              <th>Description</th>
              <th>Qty Per</th>
              <th>Unit</th>
            </tr>
          </thead>
          <tbody>
            {bomTable
              .slice() // avoid mutating original
              .sort((a, b) => {
                // 1. Sort by orders (ascending)
                const orderA = parseInt(a.orders || 0, 10);
                const orderB = parseInt(b.orders || 0, 10);
                if (orderA !== orderB) return orderA - orderB;

                // 2. If orders are equal, sort by part_number (numbers first, then alphabet)
                const partNumberA = a.part_number || "";
                const partNumberB = b.part_number || "";

                // Helper to split into numeric and alpha
                const splitPart = (str) => {
                  const match = str.match(/^(\d+)?([A-Za-z].*)?$/);
                  if (!match) return { num: NaN, rest: str };
                  return {
                    num: match[1] ? parseInt(match[1], 10) : NaN,
                    rest: match[2] || str,
                  };
                };
                const aSplit = splitPart(partNumberA);
                const bSplit = splitPart(partNumberB);

                // Numbers first
                if (!isNaN(aSplit.num) && isNaN(bSplit.num)) return -1;
                if (isNaN(aSplit.num) && !isNaN(bSplit.num)) return 1;
                if (!isNaN(aSplit.num) && !isNaN(bSplit.num)) {
                  if (aSplit.num !== bSplit.num) return aSplit.num - bSplit.num;
                  // If numbers equal, compare rest
                  return aSplit.rest.localeCompare(bSplit.rest);
                }
                // Both are alpha or both are NaN
                return partNumberA.localeCompare(partNumberB);
              })
              .map((rev, index) => {
                // Flatten all required_by entries from status_changes

                return (
                  <tr key={index}>
                    <td>{rev.type_name}</td>
                    <td>{rev.part_number}</td>
                    <td>
                      <RenderHtml content={rev.part_description} />
                    </td>
                    <td>{rev.qty}</td>
                    <td>{rev.unit_name}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
        {/* Sections List */}
        {sortedSections
          .filter((section) => section.section_name)
          .sort((a, b) => {
            const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
            const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

            const orderCompare = compareSiblingOrders(orderA, orderB);
            if (orderCompare !== 0) return orderCompare;

            // Fallback: compare created_at
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return dateB - dateA; // latest comes first
          })
          .map((section, index) => {
            return (
              <div
                key={section.section_tree_node_id}
                style={{
                  margin: "20px 0",
                  clear: "both",
                }}
              >
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    clear: "both",
                  }}
                >
                  <h2 style={{ margin: 0, clear: "both" }}>
                    Section {index + 1}
                  </h2>
                </label>
                <hr />
                <hr />
                <div>{section.section_name}</div>
                <RenderHtml content={section.short_description || ""} />

                {/* Steps for this section */}
                {(steps[section.section_tree_node_id] || []).map(
                  (step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = sortedSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc + (steps[s.section_tree_node_id]?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    const newSubsteps = substeps[stepId] || [];

                    const substepLetter = String.fromCharCode(
                      65 + newSubsteps.length
                    ); // A, B, C...

                    // Calculate media counters before navigation
                    const currentAttachmentCounter = attachmentCounter;
                    const currentVideoCounter = videoCounter;
                    const currentFormCounter = formCounter;
                    const currentCanvasCounter = canvasCounter;
                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;

                    // Dedupe helper for videos to avoid old + edited duplicates
                    const dedupeVideos = (arr) => {
                      const seen = new Set();
                      const result = [];
                      const items = (arr || []).slice().reverse(); // keep latest occurrence
                      for (const v of items) {
                        const orderKey = String(
                          v.sibling_order ??
                            v.procedure_tree?.sibling_order ??
                            ""
                        );
                        const key =
                          v.video_tree_node_id ||
                          v.video_tree_node_ref ||
                          v.existingVideoId ||
                          (orderKey && `order:${orderKey}`) ||
                          v.created_at ||
                          Math.random().toString(36);
                        if (seen.has(key)) continue;
                        seen.add(key);
                        result.push(v);
                      }
                      return result.reverse();
                    };

                    const combinedItems = [
                      ...(finalRichTexts[stepId] || []).map((item) => ({
                        ...item,
                        type: "richText",
                      })),
                      ...(finalForms[stepId] || []).map((item) => ({
                        ...item,
                        type: "form",
                      })),
                      ...(finalAttachments[stepId] || []).map((item) => ({
                        ...item,
                        type: "attachment",
                      })),
                      ...(finalCanvases[stepId] || []).map((item) => {
                        return {
                          ...item,
                          type: "canvas",
                        };
                      }),
                      ...dedupeVideos(finalVideos[stepId]).map((item) => ({
                        ...item,
                        type: "video",
                      })),
                    ]; // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );
                    filteredItems.sort((a, b) => {
                      const orderA =
                        a.sibling_order || a.procedure_tree?.sibling_order;
                      const orderB =
                        b.sibling_order || b.procedure_tree?.sibling_order;

                      const orderCompare = compareSiblingOrders(orderA, orderB);
                      if (orderCompare !== 0) return orderCompare;

                      // Fallback: compare created_at
                      const dateA = new Date(a.created_at);
                      const dateB = new Date(b.created_at);
                      return dateB - dateA; // latest comes first
                    });
                    const allChildrenUnderStep = [
                      ...(finalRichTexts[stepId] || []),
                      ...(finalForms[stepId] || []),
                      ...(finalAttachments[stepId] || []),
                      ...(finalCanvases[stepId] || []),
                      ...(finalVideos[stepId] || []),
                      ...(substeps[stepId] || []),
                    ];

                    return (
                      <div
                        key={stepId}
                        style={{ marginTop: "20px", clear: "both" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            clear: "both",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              gap: "8px",
                              cursor: "pointer",
                              clear: "both",
                            }}
                          >
                            <h2 style={{ margin: 0, clear: "both" }}>
                              Step {globalStepNumber}
                            </h2>
                          </label>

                          <div
                            style={{
                              color: "#888",
                              fontSize: "14px",
                              fontWeight: "normal",
                              clear: "both",
                            }}
                          >
                            {generateCompleteTreePath({
                              sectionIndex: index,
                              stepIndex: globalStepNumber - 1,
                              substepIndex: undefined,
                              nodeType: undefined,
                              nodeIndex: undefined,
                            })}
                          </div>
                        </div>
                        <hr />
                        <RenderHtml content={step.short_description || ""} />
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort((a, b) => {
                                const orderA = parseInt(a.orders || 0, 10);
                                const orderB = parseInt(b.orders || 0, 10);
                                if (orderA !== orderB) return orderA - orderB;
                                // Fallback to created_at if orders are equal or missing
                                return (
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                                );
                              })
                              .map((myStep) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.description ||
                                  myStep.part_info?.description ||
                                  "";
                                const qtyText =
                                  myStep.qty && myStep.qty !== 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}&nbsp;
                                  </>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {[...step.parts_required]
                              .sort((a, b) => {
                                // 1. Sort by orders (ascending)
                                const orderA = parseInt(
                                  a.part_info?.type_info?.orders || 0,
                                  10
                                );
                                const orderB = parseInt(
                                  b.part_info?.type_info?.orders || 0,
                                  10
                                );
                                if (orderA !== orderB) return orderA - orderB;

                                // 2. If orders are equal, sort by part_number (numbers first, then alphabet)
                                const partNumberA =
                                  a.part_info?.part_number || "";
                                const partNumberB =
                                  b.part_info?.part_number || "";

                                // Helper to split into numeric and alpha
                                const splitPart = (str) => {
                                  const match = str.match(
                                    /^(\d+)?([A-Za-z].*)?$/
                                  );
                                  if (!match) return { num: NaN, rest: str };
                                  return {
                                    num: match[1]
                                      ? parseInt(match[1], 10)
                                      : NaN,
                                    rest: match[2] || str,
                                  };
                                };
                                const aSplit = splitPart(partNumberA);
                                const bSplit = splitPart(partNumberB);

                                // Numbers first
                                if (!isNaN(aSplit.num) && isNaN(bSplit.num))
                                  return -1;
                                if (isNaN(aSplit.num) && !isNaN(bSplit.num))
                                  return 1;
                                if (!isNaN(aSplit.num) && !isNaN(bSplit.num)) {
                                  if (aSplit.num !== bSplit.num)
                                    return aSplit.num - bSplit.num;
                                  // If numbers equal, compare rest
                                  return aSplit.rest.localeCompare(bSplit.rest);
                                }
                                // Both are alpha or both are NaN
                                return partNumberA.localeCompare(partNumberB);
                              })
                              .map((row) => (
                                <tr>
                                  <td>{row.part_info.type_info.name}</td>
                                  <td>{row.part_info.part_number}</td>
                                  <td>
                                    <RenderHtml
                                      content={row.part_info.description}
                                    />
                                  </td>
                                  <td>{row.qty === 0 ? "" : row.qty}</td>
                                  <td>
                                    {(() => {
                                      // The unit_name field contains the unit ID, not the name
                                      // Use getUnitNameById to look up the actual unit name
                                      const unitId =
                                        row.part_info?.unit_info?.unit_name;
                                      if (unitId && units && units.length > 0) {
                                        const unitName = getUnitNameById(
                                          unitId,
                                          units
                                        );
                                        return unitName || unitId || "";
                                      }
                                      return "";
                                    })()}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item, childIndex) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;

                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              // const label = (
                              //   <h2>Rich Text {globalRichTextNumber}</h2>
                              // );

                              const newSiblingOrderForRichText =
                                getAdjustedSiblingOrder(
                                  item.sibling_order || "null",
                                  allChildrenUnderStep
                                );

                              return (
                                <div
                                  key={item.rich_text_node_id}
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      {/* {label} */}
                                    </label>
                                  </div>

                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.category_data?.category_name ??
                                      item.category_info?.category_name ??
                                      ""}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginTop: "-6px",
                                        clear: "both",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              // const label = <h2>Video {globalVideoNumber}</h2>;

                              const newSiblingOrderForVideo =
                                getAdjustedSiblingOrder(
                                  item.sibling_order || "null",
                                  allChildrenUnderStep
                                );

                              return (
                                <div
                                  key={
                                    item.video_tree_node_id ||
                                    item.video_tree_node_ref
                                  }
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      {/* {label} */}
                                    </label>
                                  </div>

                                  {renderVideo(item)}

                                  {item.video_url && (
                                    <div style={{ marginTop: "4px" }}>
                                      {item.video_url}
                                    </div>
                                  )}

                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = <h2>Form {globalFormNumber}</h2>;
                              // render form block here
                              return (
                                <div key={item.form_tree_node_id}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {label}
                                    </label>
                                  </div>
                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const nodeHeading = `Canvas ${globalCanvasNumber}`;
                              const label = <h2>{nodeHeading}</h2>;
                              const canvasId = item.canvas_tree_node_id;
                              const currentPage =
                                canvasCurrentPages[canvasId] || 0;
                              const setCurrentPage = (pageIndex) => {
                                setCanvasCurrentPages((prev) => ({
                                  ...prev,
                                  [canvasId]: pageIndex,
                                }));
                              };

                              // Get pages from canvas data (using enhanced data from IndexedDB)
                              const getPages = (canvasData) => {
                                // Use enhanced data if available, otherwise fall back to original data
                                const dataToUse =
                                  enhancedCanvasData[canvasId] || canvasData;

                                if (
                                  !dataToUse.pages ||
                                  !Array.isArray(dataToUse.pages)
                                ) {
                                  // Fallback to old structure - create a single page with shapes
                                  return [
                                    {
                                      canvas_page_id: "default",
                                      shapes: dataToUse.shapes || [],
                                      layout_config: {
                                        layout: { columns: [] },
                                      },
                                    },
                                  ];
                                }

                                // Sort pages by pageOrder to maintain correct order
                                // Create a copy of the array before sorting to avoid read-only errors
                                const sortedPages = [...dataToUse.pages].sort(
                                  (a, b) => {
                                    // First try to sort by pageOrder if available
                                    if (
                                      a.pageOrder !== undefined &&
                                      b.pageOrder !== undefined
                                    ) {
                                      return a.pageOrder - b.pageOrder;
                                    }
                                    // Fallback to created_at timestamp (oldest first)
                                    const dateA = new Date(a.created_at || 0);
                                    const dateB = new Date(b.created_at || 0);
                                    return dateA - dateB;
                                  }
                                );


                                return sortedPages;
                              };

                              // Check if this is a canvas element from navigation (has fresh data)
                              let canvasData = item;

                              // If we have a navigation element with canvas data, use that instead
                              if (
                                element &&
                                element.type === "canvas" &&
                                element.canvas_tree_node_id === canvasId
                              ) {
                                canvasData = element;
                              } else {
                              }

                              const pages = getPages(canvasData);

                              // Debug: Log the pages data to understand ordering

                              const newSiblingOrderForCanvas =
                                getAdjustedSiblingOrder(
                                  item.sibling_order || "null",
                                  allChildrenUnderStep
                                );

                              return (
                                <div
                                  key={item.canvas_tree_node_id}
                                  className="canvas-container"
                                  style={{
                                    marginTop: "40px",
                                    clear: "both",
                                    pageBreakInside: "avoid",
                                    breakInside: "avoid",
                                    height: "auto", // Override the 100vh from CSS
                                    position: "static", // Override any positioning
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      {/* {label} */}
                                    </label>

                                    {/* <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div> */}
                                  </div>

                                  <div>{item.short_description}</div>

                                  {/* Display all pages vertically */}
                                  <CanvasDisplay
                                    pages={pages}
                                    hasUserContent={hasUserContent}
                                    getTextStyle={getTextStyle}
                                    stripHtmlPreserveFormatting={
                                      stripHtmlPreserveFormatting
                                    }
                                    estimateKonvaTextHeight={
                                      estimateKonvaTextHeight
                                    }
                                    formatListContent={formatListContent}
                                    hasNoteContent={hasNoteContent}
                                    hasTaskContent={hasTaskContent}
                                    calculateGroupHeight={calculateGroupHeight}
                                    calculateTextBlockWidth={
                                      calculateTextBlockWidth
                                    }
                                  />
                                </div>
                              );
                            }
                            case "attachment": {
                              // Normalize attachment objects so renderPreview finds `attachment`
                              const attachmentList = (
                                item.attachments || []
                              ).map((att) => {
                                const normalized = {
                                  attachment:
                                    att?.attachment ||
                                    att?.base64 ||
                                    att?.url ||
                                    "",
                                  type: att?.type,
                                  name: att?.name,
                                };

                                return normalized;
                              });

                              if (attachmentList.length === 0) {
                                return null;
                              }

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              // const label = (
                              //   <h2>Attachment {globalAttachmentNumber}</h2>
                              // );
                              const newSiblingOrderForAttachment =
                                getAdjustedSiblingOrder(
                                  item.sibling_order || "null",
                                  allChildrenUnderStep
                                );

                              return (
                                <div key={item.attachment_tree_node_id}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {/* {label} */}
                                    </label>
                                  </div>
                                  <div style={{ whiteSpace: "pre-wrap" }}>
                                    {item.short_description}
                                  </div>
                                  {attachmentList.map((attachment, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        marginLeft: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(substeps[stepId] || [])
                          .slice()
                          .sort((a, b) => {
                            const orderA = parseFloat(a?.sibling_order ?? 0);
                            const orderB = parseFloat(b?.sibling_order ?? 0);
                            return orderA - orderB;
                          })
                          .map((substep, substepIndex) => {
                            const substepId = substep.sub_step_tree_node_id;
                            // Dedupe helper for videos at substep level as well
                            const dedupeVideosSub = (arr) => {
                              const seen = new Set();
                              const result = [];
                              const items = (arr || []).slice().reverse(); // keep latest occurrence
                              for (const v of items) {
                                const orderKey = String(
                                  v.sibling_order ??
                                    v.procedure_tree?.sibling_order ??
                                    ""
                                );
                                const key =
                                  v.video_tree_node_id ||
                                  v.video_tree_node_ref ||
                                  v.existingVideoId ||
                                  (orderKey && `order:${orderKey}`) ||
                                  v.created_at ||
                                  Math.random().toString(36);
                                if (seen.has(key)) continue;
                                seen.add(key);
                                result.push(v);
                              }
                              return result.reverse();
                            };

                            const combinedItems = [
                              ...(finalRichTexts[substepId] || []).map(
                                (item) => ({
                                  ...item,
                                  type: "richText",
                                })
                              ),
                              ...(finalForms[substepId] || []).map((item) => ({
                                ...item,
                                type: "form",
                              })),
                              ...(finalAttachments[substepId] || []).map(
                                (item) => ({
                                  ...item,
                                  type: "attachment",
                                })
                              ),
                              ...(finalCanvases[substepId] || []).map(
                                (item) => {
                                  return {
                                    ...item,
                                    type: "canvas",
                                  };
                                }
                              ),
                              ...dedupeVideosSub(finalVideos[substepId]).map(
                                (item) => ({
                                  ...item,
                                  type: "video",
                                })
                              ),
                            ]; // Filter out substeps or unwanted items (same as your current filter)
                            const filteredItems = combinedItems;

                            filteredItems.sort((a, b) => {
                              const orderA =
                                a.sibling_order ||
                                a.procedure_tree?.sibling_order;
                              const orderB =
                                b.sibling_order ||
                                b.procedure_tree?.sibling_order;

                              const orderCompare = compareSiblingOrders(
                                orderA,
                                orderB
                              );
                              if (orderCompare !== 0) return orderCompare;

                              // Fallback: compare created_at
                              const dateA = new Date(a.created_at);
                              const dateB = new Date(b.created_at);
                              return dateB - dateA; // latest comes first
                            });

                            // Global step number (same logic you already use for steps)
                            const stepsBeforeThisOne =
                              sortedSections
                                .slice(0, index)
                                .reduce((sectionAcc, s) => {
                                  const newSteps =
                                    steps[s.section_tree_node_id] || [];
                                  return sectionAcc + newSteps.length;
                                }, 0) + stepIndex;

                            const globalStepNumber = stepsBeforeThisOne + 1;

                            // Final substep label like Substep 5A
                            const substepLetter = String.fromCharCode(
                              65 + substepIndex
                            ); // A, B, C, ...
                            const newSubstepLetter = String.fromCharCode(
                              65 + substepIndex + 1
                            );
                            const allChildrenUnderSubstep = [
                              ...(finalRichTexts[substepId] || []),
                              ...(finalForms[substepId] || []),
                              ...(finalAttachments[substepId] || []),
                              ...(finalCanvases[substepId] || []),
                              ...(finalVideos[substepId] || []),
                              ...(substeps[substepId] || []),
                            ];
                            const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;
                            const newSiblingOrder = getAdjustedSiblingOrder(
                              substep.sibling_order || "null",
                              allChildrenUnderSubstep
                            );
                            const globalRichTextNumber = richTextCounter; // ✅ use then increment
                            const globalAttachmentNumber = attachmentCounter;
                            const globalVideoNumber = videoCounter;
                            const globalCanvasNumber = canvasCounter;
                            const globalFormNumber = formCounter;

                            return (
                              <div
                                key={substepId}
                                style={{ marginTop: "20px", clear: "both" }}
                              >
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "8px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      <h2 style={{ margin: 0, clear: "both" }}>
                                        {globalSubstepLabel}
                                      </h2>
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        clear: "both",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber} &gt; Substep{" "}
                                      {globalStepNumber}
                                      {substepLetter}
                                    </div>
                                  </div>

                                  <hr />

                                  <div style={{ whiteSpace: "pre-wrap" }}>
                                    {substep.short_description}
                                  </div>
                                </div>

                                {/* Substep Content */}
                                {filteredItems.map((item, childIndex) => {
                                  switch (item.type) {
                                    case "richText": {
                                      const globalRichTextNumber =
                                        richTextCounter++; // ✅ use then increment
                                      // render richText block here
                                      // const label = (
                                      //   <h2>
                                      //     Rich Text {globalRichTextNumber}
                                      //   </h2>
                                      // );

                                      const newSiblingOrderForRichText =
                                        getAdjustedSiblingOrder(
                                          item.sibling_order || "null",
                                          allChildrenUnderSubstep
                                        );

                                      return (
                                        <div
                                          key={item.rich_text_node_id}
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                clear: "both",
                                              }}
                                            >
                                              {/* {label} */}
                                            </label>
                                          </div>

                                          <div
                                            style={{
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                              clear: "both",
                                              whiteSpace: "pre-wrap",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          <div
                                            style={{
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.category_data
                                              ?.category_name ??
                                              item.category_info
                                                ?.category_name ??
                                              ""}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                            }}
                                          >
                                            <div
                                              style={{
                                                marginTop: "-6px",
                                                clear: "both",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.rich_text_content,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "video": {
                                      const globalVideoNumber = videoCounter++; // ✅ use then increment
                                      // const label = (
                                      //   <h2>Video {globalVideoNumber}</h2>
                                      // );

                                      const newSiblingOrderForVideo =
                                        getAdjustedSiblingOrder(
                                          item.sibling_order || "null",
                                          allChildrenUnderSubstep
                                        );

                                      return (
                                        <div
                                          key={
                                            item.video_tree_node_id ||
                                            item.video_tree_node_ref
                                          }
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                clear: "both",
                                              }}
                                            >
                                              {/* {label} */}
                                            </label>
                                          </div>

                                          {renderVideo(item)}

                                          {item.video_url && (
                                            <div
                                              style={{
                                                marginTop: "4px",
                                              }}
                                            >
                                              {item.video_url}
                                            </div>
                                          )}

                                          <div
                                            style={{ whiteSpace: "pre-wrap" }}
                                          >
                                            {item.short_description}
                                          </div>
                                        </div>
                                      );
                                    }

                                    case "form": {
                                      const globalFormNumber = formCounter++; // ✅ use then increment
                                      const label = (
                                        <h2>Form {globalFormNumber}</h2>
                                      );
                                      // render form block here
                                      return (
                                        <div key={item.form_tree_node_id}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                marginTop: "20px",
                                                clear: "both",
                                              }}
                                            >
                                              {label}
                                            </label>
                                          </div>
                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }
                                    case "canvas": {
                                      const globalCanvasNumber =
                                        canvasCounter++; // ✅ use then increment
                                      const nodeHeading = `Canvas ${globalCanvasNumber}`;
                                      const label = <h2>{nodeHeading}</h2>;
                                      const canvasId = item.canvas_tree_node_id;
                                      const currentPage =
                                        canvasCurrentPages[canvasId] || 0;
                                      const setCurrentPage = (pageIndex) => {
                                        setCanvasCurrentPages((prev) => ({
                                          ...prev,
                                          [canvasId]: pageIndex,
                                        }));
                                      };

                                      // Get pages from canvas data (using enhanced data from IndexedDB)
                                      const getPages = (canvasData) => {
                                        // Use enhanced data if available, otherwise fall back to original data
                                        const dataToUse =
                                          enhancedCanvasData[canvasId] ||
                                          canvasData;

                                        if (
                                          !dataToUse.pages ||
                                          !Array.isArray(dataToUse.pages)
                                        ) {
                                          // Fallback to old structure - create a single page with shapes
                                          return [
                                            {
                                              canvas_page_id: "default",
                                              shapes: dataToUse.shapes || [],
                                              layout_config: {
                                                layout: { columns: [] },
                                              },
                                            },
                                          ];
                                        }

                                        // Sort pages by pageOrder to maintain correct order
                                        // Create a copy of the array before sorting to avoid read-only errors
                                        const sortedPages = [
                                          ...dataToUse.pages,
                                        ].sort((a, b) => {
                                          // First try to sort by pageOrder if available
                                          if (
                                            a.pageOrder !== undefined &&
                                            b.pageOrder !== undefined
                                          ) {
                                            return a.pageOrder - b.pageOrder;
                                          }
                                          // Fallback to created_at timestamp (oldest first)
                                          const dateA = new Date(
                                            a.created_at || 0
                                          );
                                          const dateB = new Date(
                                            b.created_at || 0
                                          );
                                          return dateA - dateB;
                                        });


                                        return sortedPages;
                                      };
                                      // Check if this is a canvas element from navigation (has fresh data)
                                      let canvasData = item;
                                      // If we have a navigation element with canvas data, use that instead
                                      if (
                                        element &&
                                        element.type === "canvas" &&
                                        element.canvas_tree_node_id ===
                                          item.canvas_tree_node_id
                                      ) {
                                        canvasData = element;
                                      } else {
                                      }

                                      const pages = getPages(canvasData);

                                      // Debug: Log the pages data to understand ordering (fallback case)

                                      const newSiblingOrderForCanvas =
                                        getAdjustedSiblingOrder(
                                          item.sibling_order || "null",
                                          allChildrenUnderSubstep
                                        );

                                      const handleCheckboxChange = () => {
                                        navigate(
                                          `/selected-section-element/canvas/${sectionId}/${revisionId}/${partId}/${stepId}/Step ${globalStepNumber}/${partNumber}/${myRevision}/${globalCanvasNumber}/${substepCounter}/${attachmentCounter}/${videoCounter}/${formCounter}/${canvasCounter}/${stepCounter}/Section ${
                                            index + 1
                                          }/Canvas ${globalCanvasNumber}/null/${newSiblingOrderForCanvas}`,
                                          {
                                            state: {
                                              data: {
                                                ...item,
                                                steps: steps[sectionId],
                                                sourceSubstepIndex:
                                                  substepIndex,
                                                sourceStepId: stepId,
                                                sourceSectionIndex: index,
                                                fromSubstepSiblingOrder:
                                                  item.sibling_order,
                                                type,
                                                stepIndex,
                                                childIndex,
                                                status: location.state?.status,
                                                fromSubstepLetter:
                                                  substepLetter,
                                                revisionData,
                                                substepId,

                                                node: item, // richText, form, etc.
                                                nodeType: "canvas", // "richText", "form", etc.
                                                fromNodeId:
                                                  item.canvas_tree_node_id, // original node ID
                                                partNumbers: step.parts_required
                                                  .map(
                                                    (p) =>
                                                      p.part_info?.part_number
                                                  )
                                                  .filter(Boolean),
                                                related_nodes: {
                                                  rich_texts:
                                                    richTexts[stepId]?.filter(
                                                      (rt) => rt !== item
                                                    ) || [],
                                                  forms: forms[stepId] || [],
                                                  attachments:
                                                    attachments[
                                                      stepId
                                                    ]?.flatMap(
                                                      (wrapper) =>
                                                        wrapper.attachments ||
                                                        []
                                                    ) || [],
                                                  videos: videos[stepId] || [],
                                                  canvases:
                                                    finalCanvases[stepId] || [],
                                                  partNumbers:
                                                    step.parts_required
                                                      .map(
                                                        (p) =>
                                                          p.part_info
                                                            ?.part_number
                                                      )
                                                      .filter(Boolean),
                                                  sourceSubstepIndex:
                                                    substepIndex,
                                                  sourceStepId: stepId,
                                                  sourceSectionIndex: index,
                                                  stepIndex,
                                                },
                                              },
                                            },
                                          }
                                        );
                                      };
                                      return (
                                        <div
                                          key={item.canvas_tree_node_id}
                                          className="canvas-container"
                                          style={{
                                            marginTop: "40px",
                                            clear: "both",
                                            pageBreakInside: "avoid",
                                            breakInside: "avoid",
                                            height: "auto", // Override the 100vh from CSS
                                            position: "static", // Override any positioning
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                clear: "both",
                                              }}
                                            >
                                              {/* {label} */}
                                            </label>

                                            {/* <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {index + 1} &gt; Step{" "}
                                              {globalStepNumber} &gt; Substep{" "}
                                              {substepCounter}
                                            </div> */}
                                          </div>

                                          <div>{item.short_description}</div>

                                          {/* Display all pages vertically */}
                                          <CanvasDisplay
                                            pages={pages}
                                            hasUserContent={hasUserContent}
                                            getTextStyle={getTextStyle}
                                            stripHtmlPreserveFormatting={
                                              stripHtmlPreserveFormatting
                                            }
                                            estimateKonvaTextHeight={
                                              estimateKonvaTextHeight
                                            }
                                            formatListContent={
                                              formatListContent
                                            }
                                            hasNoteContent={hasNoteContent}
                                            hasTaskContent={hasTaskContent}
                                            calculateGroupHeight={
                                              calculateGroupHeight
                                            }
                                            calculateTextBlockWidth={
                                              calculateTextBlockWidth
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                    case "attachment": {
                                      const attachmentList =
                                        item.attachments || [];
                                      if (attachmentList.length === 0)
                                        return null;

                                      //  const globalAttachmentNumber =
                                      //           attachmentCounter++; // ✅ use then increment
                                      const globalAttachmentNumber =
                                        attachmentCounter++; // ✅ Increment here per attachment
                                      // const label = (
                                      //   <h2>
                                      //     Attachment {globalAttachmentNumber}
                                      //   </h2>
                                      // );
                                      const newSiblingOrderForAttachment =
                                        getAdjustedSiblingOrder(
                                          item.sibling_order || "null",
                                          allChildrenUnderSubstep
                                        );

                                      const handleCheckboxChange = () => {
                                        navigate(
                                          `/selected-section-element/attachment/${sectionId}/${revisionId}/${partId}/${stepId}/Step ${globalStepNumber} > ${globalSubstepLabel}/${partNumber}/${myRevision}/${globalAttachmentNumber}/${substepCounter}/${attachmentCounter}/${videoCounter}/${formCounter}/${canvasCounter}/${stepCounter}/Section ${
                                            index + 1
                                          }/Attachment ${globalAttachmentNumber}/${substepId}/${newSiblingOrderForAttachment}`,
                                          {
                                            state: {
                                              data: {
                                                ...item,
                                                steps: steps[sectionId],
                                                sourceSubstepIndex:
                                                  substepIndex,
                                                sourceStepId: stepId,
                                                sourceSectionIndex: index,
                                                stepIndex,
                                                fromSubstepSiblingOrder:
                                                  item.sibling_order,
                                                type,
                                                status: location.state?.status,
                                                revisionData,
                                                substepId,

                                                childTreeId:
                                                  item.attachment_tree_node_id,
                                                fromSubstepLetter:
                                                  substepLetter,
                                                childIndex,
                                                node: item, // richText, form, etc.
                                                nodeType: "attachment", // "richText", "form", etc.
                                                fromNodeId:
                                                  item.attachment_tree_node_id, // original node ID
                                                partNumbers: step.parts_required
                                                  .map(
                                                    (p) =>
                                                      p.part_info?.part_number
                                                  )
                                                  .filter(Boolean),
                                                related_nodes: {
                                                  rich_texts:
                                                    richTexts[stepId]?.filter(
                                                      (rt) => rt !== item
                                                    ) || [],
                                                  forms: forms[stepId] || [],
                                                  attachments:
                                                    attachments[
                                                      stepId
                                                    ]?.flatMap(
                                                      (wrapper) =>
                                                        wrapper.attachments ||
                                                        []
                                                    ) || [],
                                                  videos: videos[stepId] || [],
                                                  canvases:
                                                    finalCanvases[stepId] || [],
                                                  partNumbers:
                                                    step.parts_required
                                                      .map(
                                                        (p) =>
                                                          p.part_info
                                                            ?.part_number
                                                      )
                                                      .filter(Boolean),
                                                  sourceSubstepIndex:
                                                    substepIndex,
                                                  sourceStepId: stepId,
                                                  sourceSectionIndex: index,
                                                  stepIndex,
                                                },
                                              },
                                            },
                                          }
                                        );
                                      };

                                      return (
                                        <div key={item.attachment_tree_node_id}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                marginTop: "20px",
                                                clear: "both",
                                              }}
                                            >
                                              {/* {label} */}
                                            </label>
                                          </div>
                                          <div>{item.short_description}</div>
                                          {attachmentList.map(
                                            (attachment, i) => (
                                              <div
                                                key={i}
                                                style={{
                                                  marginLeft: "20px",
                                                  clear: "both",
                                                }}
                                              >
                                                {renderPreview(attachment)}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    }
                                    default:
                                      return null;
                                  }
                                })}
                              </div>
                            );
                          })}
                      </div>
                    );
                  }
                )}
              </div>
            );
          })}
      </div>
      {/* Save Modal */}
      {isApprovalModalOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content1"
            style={{
              position: "relative",
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              width: "90%",
              maxWidth: "500px",
              maxHeight: "90vh",
              overflowY: "auto",
              overflowX: "hidden",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <h3
                className="modal-header"
                style={{ fontSize: "14px", margin: 0 }}
              >
                Submit Revision For Approval
              </h3>
              <button
                onClick={() => setIsApprovalModalOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                title="Close"
              >
                <FontAwesomeIcon icon={faTimes} size="1x" color="gray" />
              </button>
            </div>
            <hr className="divider" />

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "baseline",
                columnGap: "12px",
                rowGap: "4px",
                marginLeft: "10px",
                marginBottom: "4px",
              }}
            >
              <strong style={{ fontSize: "15px" }}>
                {type} {partNumber}
              </strong>
              <RenderHtml content={description} inline />
            </div>

            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                Revision: {myRevision}
              </label>
            </div>

            <div className="form-group">
              <label>
                <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                  Submitter:
                </span>{" "}
                {localStorage.getItem("user_name")}
              </label>
            </div>

            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                Comment<span style={{ color: "#0D6EFD" }}>*</span>
              </label>
              <textarea
                className="input-textarea"
                placeholder="Enter Comment..."
                value={revisionDetails}
                onChange={(e) => setRevisionDetails(e.target.value)}
                style={{
                  height: "70px",
                }}
              ></textarea>
            </div>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                marginTop: "-17px",
              }}
            >
              <input
                type="checkbox"
                style={{ width: "13px", height: "13px", marginLeft: "10px" }}
                onChange={() => {
                  setIsReviewed(!isReviewed);
                }}
                value={isReviewed}
              />

              <h3
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  marginLeft: "-5px",
                }}
              >
                I have reviewed the revisions mentioned on previous screen
                <span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span>
              </h3>
            </label>
            <div className="form-group" style={{ marginTop: "-12px" }}>
              <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                Enter Password<span style={{ color: "#0D6EFD" }}>*</span>
              </label>
              <input
                type="password"
                className="input-field"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="form-group" style={{ marginBottom: "8px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <label style={{ fontSize: "12px" }}>
                  Sign Here
                  <span className="required" style={{ marginLeft: "-1px" }}>
                    *
                  </span>
                </label>

                <svg
                  onClick={() => {
                    if (sigPadRef.current) {
                      sigPadRef.current.clear();
                      setSignature("");
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  width="50"
                  height="14"
                  viewBox="0 0 50 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 14C5.16667 14 4.38611 13.8417 3.65833 13.525C2.93056 13.2083 2.29722 12.7806 1.75833 12.2417C1.21944 11.7028 0.791667 11.0694 0.475 10.3417C0.158333 9.61389 0 8.83333 0 8H1.33333C1.33333 9.3 1.78611 10.4028 2.69167 11.3083C3.59722 12.2139 4.7 12.6667 6 12.6667C7.3 12.6667 8.40278 12.2139 9.30833 11.3083C10.2139 10.4028 10.6667 9.3 10.6667 8C10.6667 6.7 10.2139 5.59722 9.30833 4.69167C8.40278 3.78611 7.3 3.33333 6 3.33333H5.9L6.93333 4.36667L6 5.33333L3.33333 2.66667L6 0L6.93333 0.966667L5.9 2H6C6.83333 2 7.61389 2.15833 8.34167 2.475C9.06944 2.79167 9.70278 3.21944 10.2417 3.75833C10.7806 4.29722 11.2083 4.93056 11.525 5.65833C11.8417 6.38611 12 7.16667 12 8C12 8.83333 11.8417 9.61389 11.525 10.3417C11.2083 11.0694 10.7806 11.7028 10.2417 12.2417C9.70278 12.7806 9.06944 13.2083 8.34167 13.525C7.61389 13.8417 6.83333 14 6 14Z"
                    fill="#0D6EFD"
                  />
                  <path
                    d="M24.1641 8.83496H25.4766C25.4082 9.46387 25.2282 10.0267 24.9365 10.5234C24.6449 11.0202 24.2324 11.4144 23.6992 11.7061C23.166 11.9932 22.5007 12.1367 21.7031 12.1367C21.1198 12.1367 20.5889 12.0273 20.1104 11.8086C19.6364 11.5898 19.2285 11.2799 18.8867 10.8789C18.5449 10.4733 18.2806 9.98796 18.0938 9.42285C17.9115 8.85319 17.8203 8.21973 17.8203 7.52246V6.53125C17.8203 5.83398 17.9115 5.2028 18.0938 4.6377C18.2806 4.06803 18.5472 3.5804 18.8936 3.1748C19.2445 2.76921 19.666 2.45703 20.1582 2.23828C20.6504 2.01953 21.2041 1.91016 21.8193 1.91016C22.5713 1.91016 23.207 2.05143 23.7266 2.33398C24.2461 2.61654 24.6494 3.00846 24.9365 3.50977C25.2282 4.00651 25.4082 4.58301 25.4766 5.23926H24.1641C24.1003 4.77441 23.9818 4.37565 23.8086 4.04297C23.6354 3.70573 23.3893 3.44596 23.0703 3.26367C22.7513 3.08138 22.3343 2.99023 21.8193 2.99023C21.3773 2.99023 20.9876 3.07454 20.6504 3.24316C20.3177 3.41178 20.0374 3.65104 19.8096 3.96094C19.5863 4.27083 19.4176 4.64225 19.3037 5.0752C19.1898 5.50814 19.1328 5.98893 19.1328 6.51758V7.52246C19.1328 8.01009 19.1829 8.4681 19.2832 8.89648C19.388 9.32487 19.5452 9.70085 19.7549 10.0244C19.9645 10.348 20.2311 10.6032 20.5547 10.79C20.8783 10.9723 21.2611 11.0635 21.7031 11.0635C22.2637 11.0635 22.7103 10.9746 23.043 10.7969C23.3757 10.6191 23.6263 10.3639 23.7949 10.0312C23.9681 9.69857 24.0911 9.2998 24.1641 8.83496ZM28.457 1.5V12H27.1855V1.5H28.457ZM33.5566 12.1367C33.0417 12.1367 32.5745 12.0501 32.1553 11.877C31.7406 11.6992 31.3828 11.4508 31.082 11.1318C30.7858 10.8128 30.5579 10.4346 30.3984 9.99707C30.2389 9.55957 30.1592 9.08105 30.1592 8.56152V8.27441C30.1592 7.67285 30.248 7.13737 30.4258 6.66797C30.6035 6.19401 30.8451 5.79297 31.1504 5.46484C31.4557 5.13672 31.8021 4.88835 32.1895 4.71973C32.5768 4.55111 32.9779 4.4668 33.3926 4.4668C33.9212 4.4668 34.377 4.55794 34.7598 4.74023C35.1471 4.92253 35.4639 5.17773 35.71 5.50586C35.9561 5.82943 36.1383 6.21224 36.2568 6.6543C36.3753 7.0918 36.4346 7.57031 36.4346 8.08984V8.65723H30.9111V7.625H35.1699V7.5293C35.1517 7.20117 35.0833 6.88216 34.9648 6.57227C34.8509 6.26237 34.6686 6.00716 34.418 5.80664C34.1673 5.60612 33.8255 5.50586 33.3926 5.50586C33.1055 5.50586 32.8411 5.56738 32.5996 5.69043C32.3581 5.80892 32.1507 5.98665 31.9775 6.22363C31.8044 6.46061 31.6699 6.75 31.5742 7.0918C31.4785 7.43359 31.4307 7.8278 31.4307 8.27441V8.56152C31.4307 8.91243 31.4785 9.24284 31.5742 9.55273C31.6745 9.85807 31.818 10.127 32.0049 10.3594C32.1963 10.5918 32.4264 10.7741 32.6953 10.9062C32.9688 11.0384 33.2786 11.1045 33.625 11.1045C34.0716 11.1045 34.4499 11.0133 34.7598 10.8311C35.0697 10.6488 35.3408 10.4049 35.5732 10.0996L36.3389 10.708C36.1794 10.9495 35.9766 11.1797 35.7305 11.3984C35.4844 11.6172 35.1813 11.7949 34.8213 11.9316C34.4658 12.0684 34.0443 12.1367 33.5566 12.1367ZM42.2725 10.7354V6.92773C42.2725 6.63607 42.2132 6.38314 42.0947 6.16895C41.9808 5.9502 41.8076 5.78158 41.5752 5.66309C41.3428 5.5446 41.0557 5.48535 40.7139 5.48535C40.3949 5.48535 40.1146 5.54004 39.873 5.64941C39.6361 5.75879 39.4492 5.90234 39.3125 6.08008C39.1803 6.25781 39.1143 6.44922 39.1143 6.6543H37.8496C37.8496 6.38997 37.918 6.12793 38.0547 5.86816C38.1914 5.6084 38.3874 5.3737 38.6426 5.16406C38.9023 4.94987 39.2122 4.78125 39.5723 4.6582C39.9368 4.5306 40.3424 4.4668 40.7891 4.4668C41.3268 4.4668 41.8008 4.55794 42.2109 4.74023C42.6257 4.92253 42.9492 5.19824 43.1816 5.56738C43.4186 5.93197 43.5371 6.38997 43.5371 6.94141V10.3867C43.5371 10.6328 43.5576 10.8949 43.5986 11.1729C43.6442 11.4508 43.7103 11.6901 43.7969 11.8906V12H42.4775C42.4137 11.8542 42.3636 11.6605 42.3271 11.4189C42.2907 11.1729 42.2725 10.945 42.2725 10.7354ZM42.4912 7.51562L42.5049 8.4043H41.2266C40.8665 8.4043 40.5452 8.43392 40.2627 8.49316C39.9801 8.54785 39.7432 8.63216 39.5518 8.74609C39.3604 8.86003 39.2145 9.00358 39.1143 9.17676C39.014 9.34538 38.9639 9.54362 38.9639 9.77148C38.9639 10.0039 39.0163 10.2158 39.1211 10.4072C39.2259 10.5986 39.3831 10.7513 39.5928 10.8652C39.807 10.9746 40.069 11.0293 40.3789 11.0293C40.7663 11.0293 41.1081 10.9473 41.4043 10.7832C41.7005 10.6191 41.9352 10.4186 42.1084 10.1816C42.2861 9.94466 42.3818 9.71452 42.3955 9.49121L42.9355 10.0996C42.9036 10.291 42.8171 10.5029 42.6758 10.7354C42.5345 10.9678 42.3454 11.1911 42.1084 11.4053C41.876 11.6149 41.598 11.7904 41.2744 11.9316C40.9554 12.0684 40.5954 12.1367 40.1943 12.1367C39.693 12.1367 39.2533 12.0387 38.875 11.8428C38.5013 11.6468 38.2096 11.3848 38 11.0566C37.7949 10.724 37.6924 10.3525 37.6924 9.94238C37.6924 9.5459 37.7699 9.19727 37.9248 8.89648C38.0798 8.59115 38.3031 8.33822 38.5947 8.1377C38.8864 7.93262 39.2373 7.77767 39.6475 7.67285C40.0576 7.56803 40.5156 7.51562 41.0215 7.51562H42.4912ZM46.791 5.76562V12H45.5264V4.60352H46.7568L46.791 5.76562ZM49.1016 4.5625L49.0947 5.73828C48.9899 5.71549 48.8896 5.70182 48.7939 5.69727C48.7028 5.68815 48.598 5.68359 48.4795 5.68359C48.1878 5.68359 47.9303 5.72917 47.707 5.82031C47.4837 5.91146 47.2946 6.03906 47.1396 6.20312C46.9847 6.36719 46.8617 6.56315 46.7705 6.79102C46.6839 7.01432 46.627 7.26042 46.5996 7.5293L46.2441 7.73438C46.2441 7.28776 46.2874 6.86849 46.374 6.47656C46.4652 6.08464 46.6042 5.73828 46.791 5.4375C46.9779 5.13216 47.2148 4.89518 47.502 4.72656C47.7936 4.55339 48.14 4.4668 48.541 4.4668C48.6322 4.4668 48.737 4.47819 48.8555 4.50098C48.974 4.51921 49.056 4.53971 49.1016 4.5625Z"
                    fill="#0D6EFD"
                  />
                </svg>
              </div>

              <div
                style={{
                  border: "1px solid #CED4DA",
                  width: "480px",
                  borderRadius: "5px",
                  height: "100px",
                }}
              >
                <SignatureCanvas
                  ref={sigPadRef}
                  penColor="black"
                  onEnd={handleEndDrawing}
                  canvasProps={{
                    width: 480,
                    height: 100,
                    className: "signature-canvas",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: "pointer",
                }}
                onClick={() => setIsApprovalModalOpen(false)}
              >
                Close
              </button>
              <button
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: "pointer",
                  marginRight: "7px",
                }}
                onClick={handleCreateRevision}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Reject Modal */}
      {isRejectModalOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content1"
            style={{
              position: "relative",
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              width: "90%",
              maxWidth: "500px",
              maxHeight: "90vh",
              overflowY: "auto",
              overflowX: "hidden",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <h3
                className="modal-header"
                style={{ fontSize: "14px", margin: 0 }}
              >
                Reject Revision From Release
              </h3>
              <button
                onClick={() => setIsRejectModalOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                title="Close"
              >
                <FontAwesomeIcon icon={faTimes} size="1x" color="gray" />
              </button>
            </div>
            <hr className="divider" />

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "baseline",
                columnGap: "12px",
                rowGap: "4px",
                marginLeft: "10px",
                marginBottom: "4px",
              }}
            >
              <strong style={{ fontSize: "15px" }}>
                {type} {partNumber}
              </strong>
              <RenderHtml content={description} inline />
            </div>

            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                Revision: {myRevision}
              </label>
            </div>

            <div className="form-group">
              <label>
                <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                  Rejector:
                </span>{" "}
                {localStorage.getItem("user_name")}
              </label>
            </div>
            <div className="form-group">
              <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                Comment<span className="required">*</span>
              </label>
              <textarea
                className="input-textarea"
                placeholder="Enter comment..."
                value={revisionDetails}
                onChange={(e) => setRevisionDetails(e.target.value)}
                style={{
                  minHeight: "70px",
                }}
              ></textarea>
            </div>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: "pointer",
                marginTop: "-17px",
              }}
            >
              <input
                type="checkbox"
                style={{ width: "13px", height: "13px", marginLeft: "10px" }}
                onChange={() => {
                  setIsReviewed(!isReviewed);
                }}
                value={isReviewed}
              />
              <h3
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  marginLeft: "-5px",
                }}
              >
                I have reviewed the revisions mentioned on previous screen
                <span style={{ color: "#0D6EFD", marginLeft: "-1px" }}>*</span>
              </h3>
            </label>

            <div className="form-group" style={{ marginTop: "-12px" }}>
              <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                Enter Password<span className="required">*</span>
              </label>
              <input
                type="password"
                className="input-field"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="form-group" style={{ marginBottom: "8px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <label style={{ fontSize: "12px" }}>
                  Sign Here
                  <span className="required" style={{ marginLeft: "-1px" }}>
                    *
                  </span>
                </label>

                <svg
                  onClick={() => {
                    if (sigPadRef.current) {
                      sigPadRef.current.clear();
                      setSignature("");
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  width="50"
                  height="14"
                  viewBox="0 0 50 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 14C5.16667 14 4.38611 13.8417 3.65833 13.525C2.93056 13.2083 2.29722 12.7806 1.75833 12.2417C1.21944 11.7028 0.791667 11.0694 0.475 10.3417C0.158333 9.61389 0 8.83333 0 8H1.33333C1.33333 9.3 1.78611 10.4028 2.69167 11.3083C3.59722 12.2139 4.7 12.6667 6 12.6667C7.3 12.6667 8.40278 12.2139 9.30833 11.3083C10.2139 10.4028 10.6667 9.3 10.6667 8C10.6667 6.7 10.2139 5.59722 9.30833 4.69167C8.40278 3.78611 7.3 3.33333 6 3.33333H5.9L6.93333 4.36667L6 5.33333L3.33333 2.66667L6 0L6.93333 0.966667L5.9 2H6C6.83333 2 7.61389 2.15833 8.34167 2.475C9.06944 2.79167 9.70278 3.21944 10.2417 3.75833C11.2083 4.93056 11.525 5.65833 11.525 6.38611C11.525 7.16667 11.2083 7.8001 10.7806 8.33906C10.3528 8.87802 9.85205 9.3417 9.27832 9.73047C8.70459 10.1192 8.09722 10.4667 7.50833 10.7734C6.91944 11.0801 6.30278 11.3333 5.66667 11.5501C5.03056 11.7667 4.38611 11.9195 3.73167 11.9917C3.07722 12.0638 2.40833 12.0638 1.73958 12.0638C1.07083 12.0638 0.475 11.9917 0 11.8417C0 11.6917 0.158333 11.5417 0.475 11.3917C0.791667 11.2417 1.21944 11.0917 1.75833 10.9417C2.29722 10.7917 2.93056 10.6417 3.65833 10.525C4.38611 10.4083 5.16667 10.3333 6 10.3333Z"
                    fill="#0D6EFD"
                  />
                  <path
                    d="M24.1641 8.83496H25.4766C25.4082 9.46387 25.2282 10.0267 24.9365 10.5234C24.6449 11.0202 24.2324 11.4144 23.6992 11.7061C23.166 11.9932 22.5007 12.1367 21.7031 12.1367C21.1198 12.1367 20.5889 12.0273 20.1104 11.8086C19.6364 11.5898 19.2285 11.2799 18.8867 10.8789C18.5449 10.4733 18.2806 9.98796 18.0938 9.42285C17.9115 8.85319 17.8203 8.21973 17.8203 7.52246V6.53125C17.8203 5.83398 17.9115 5.2028 18.0938 4.6377C18.2806 4.06803 18.5472 3.5804 18.8936 3.1748C19.2445 2.76921 19.666 2.45703 20.1582 2.23828C20.6504 2.01953 21.2041 1.91016 21.8193 1.91016C22.5713 1.91016 23.207 2.05143 23.7266 2.33398C24.2461 2.61654 24.6494 3.00846 24.9365 3.50977C25.2282 4.00651 25.4082 4.58301 25.4766 5.23926H24.1641C24.1003 4.77441 23.9818 4.37565 23.8086 4.04297C23.6354 3.70573 23.3893 3.44596 23.0703 3.26367C22.7513 3.08138 22.3343 2.99023 21.8193 2.99023C21.3773 2.99023 20.9876 3.07454 20.6504 3.24316C20.3177 3.41178 20.0374 3.65104 19.8096 3.96094C19.5863 4.27083 19.4176 4.64225 19.3037 5.0752C19.1898 5.50814 19.1328 5.98893 19.1328 6.51758V7.52246C19.1328 8.01009 19.1829 8.4681 19.2832 8.89648C19.388 9.32487 19.5452 9.70085 19.7549 10.0244C19.9645 10.348 20.2311 10.6032 20.5547 10.79C20.8783 10.9723 21.2611 11.0635 21.7031 11.0635C22.2637 11.0635 22.7103 10.9746 23.043 10.7969C23.3757 10.6191 23.6263 10.3639 23.7949 10.0312C23.9681 9.69857 24.0911 9.2998 24.1641 8.83496ZM28.457 1.5V12H27.1855V1.5H28.457ZM33.5566 12.1367C33.0417 12.1367 32.5745 12.0501 32.1553 11.877C31.7406 11.6992 31.3828 11.4508 31.082 11.1318C30.7858 10.8128 30.5579 10.4346 30.3984 9.99707C30.2389 9.55957 30.1592 9.08105 30.1592 8.56152V8.27441C30.1592 7.67285 30.248 7.13737 30.4258 6.66797C30.6035 6.19401 30.8451 5.79297 31.1504 5.46484C31.4557 5.13672 31.8021 4.88835 32.1895 4.71973C32.5768 4.55111 32.9779 4.4668 33.3926 4.4668C33.9212 4.4668 34.377 4.55794 34.7598 4.74023C35.1471 4.92253 35.4639 5.17773 35.71 5.50586C35.9561 5.82943 36.1383 6.21224 36.2568 6.6543C36.3753 7.0918 36.4346 7.57031 36.4346 8.08984V8.65723H30.9111V7.625H35.1699V7.5293C35.1517 7.20117 35.0833 6.88216 34.9648 6.57227C34.8509 6.26237 34.6686 6.00716 34.418 5.80664C34.1673 5.60612 33.8255 5.50586 33.3926 5.50586C33.1055 5.50586 32.8411 5.56738 32.5996 5.69043C32.3581 5.80892 32.1507 5.98665 31.9775 6.22363C31.8044 6.46061 31.6699 6.75 31.5742 7.0918C31.4785 7.43359 31.4307 7.8278 31.4307 8.27441V8.56152C31.4307 8.91243 31.4785 9.24284 31.5742 9.55273C31.6745 9.85807 31.818 10.127 32.0049 10.3594C32.1963 10.5918 32.4264 10.7741 32.6953 10.9062C32.9688 11.0384 33.2786 11.1045 33.625 11.1045C34.0716 11.1045 34.4499 11.0133 34.7598 10.8311C35.0697 10.6488 35.3408 10.4049 35.5732 10.0996L36.3389 10.708C36.1794 10.9495 35.9766 11.1797 35.7305 11.3984C35.4844 11.6172 35.1813 11.7949 34.8213 11.9316C34.4658 12.0684 34.0443 12.1367 33.5566 12.1367ZM42.2725 10.7354V6.92773C42.2725 6.63607 42.2132 6.38314 42.0947 6.16895C41.9808 5.9502 41.8076 5.78158 41.5752 5.66309C41.3428 5.5446 41.0557 5.48535 40.7139 5.48535C40.3949 5.48535 40.1146 5.54004 39.873 5.64941C39.6361 5.75879 39.4492 5.90234 39.3125 6.08008C39.1803 6.25781 39.1143 6.44922 39.1143 6.6543H37.8496C37.8496 6.38997 37.918 6.12793 38.0547 5.86816C38.1914 5.6084 38.3874 5.3737 38.6426 5.16406C38.9023 4.94987 39.2122 4.78125 39.5723 4.6582C39.9368 4.5306 40.3424 4.4668 40.7891 4.4668C41.3268 4.4668 41.8008 4.55794 42.2109 4.74023C42.6257 4.92253 42.9492 5.19824 43.1816 5.56738C43.4186 5.93197 43.5371 6.38997 43.5371 6.94141V10.3867C43.5371 10.6328 43.5576 10.8949 43.5986 11.1729C43.6442 11.4508 43.7103 11.6901 43.7969 11.8906V12H42.4775C42.4137 11.8542 42.3636 11.6605 42.3271 11.4189C42.2907 11.1729 42.2725 10.945 42.2725 10.7354ZM42.4912 7.51562L42.5049 8.4043H41.2266C40.8665 8.4043 40.5452 8.43392 40.2627 8.49316C39.9801 8.54785 39.7432 8.63216 39.5518 8.74609C39.3604 8.86003 39.2145 9.00358 39.1143 9.17676C39.014 9.34538 38.9639 9.54362 38.9639 9.77148C38.9639 10.0039 39.0163 10.2158 39.1211 10.4072C39.2259 10.5986 39.3831 10.7513 39.5928 10.8652C39.807 10.9746 40.069 11.0293 40.3789 11.0293C40.7663 11.0293 41.1081 10.9473 41.4043 10.7832C41.7005 10.6191 41.9352 10.4186 42.1084 10.1816C42.2861 9.94466 42.3818 9.71452 42.3955 9.49121L42.9355 10.0996C42.9036 10.291 42.8171 10.5029 42.6758 10.7354C42.5345 10.9678 42.3454 11.1911 42.1084 11.4053C41.876 11.6149 41.598 11.7904 41.2744 11.9316C40.9554 12.0684 40.5954 12.1367 40.1943 12.1367C39.693 12.1367 39.2533 12.0387 38.875 11.8428C38.5013 11.6468 38.2096 11.3848 38 11.0566C37.7949 10.724 37.6924 10.3525 37.6924 9.94238C37.6924 9.5459 37.7699 9.19727 37.9248 8.89648C38.0798 8.59115 38.3031 8.33822 38.5947 8.1377C38.8864 7.93262 39.2373 7.77767 39.6475 7.67285C40.0576 7.56803 40.5156 7.51562 41.0215 7.51562H42.4912ZM46.791 5.76562V12H45.5264V4.60352H46.7568L46.791 5.76562ZM49.1016 4.5625L49.0947 5.73828C48.9899 5.71549 48.8896 5.70182 48.7939 5.69727C48.7028 5.68815 48.598 5.68359 48.4795 5.68359C48.1878 5.68359 47.9303 5.72917 47.707 5.82031C47.4837 5.91146 47.2946 6.03906 47.1396 6.20312C46.9847 6.36719 46.8617 6.56315 46.7705 6.79102C46.6839 7.01432 46.627 7.26042 46.5996 7.5293L46.2441 7.73438C46.2441 7.28776 46.2874 6.86849 46.374 6.47656C46.4652 6.08464 46.6042 5.73828 46.791 5.4375C46.9779 5.13216 47.2148 4.89518 47.502 4.72656C47.7936 4.55339 48.14 4.4668 48.541 4.4668C48.6322 4.4668 48.737 4.47819 48.8555 4.50098C48.974 4.51921 49.056 4.53971 49.1016 4.5625Z"
                    fill="#0D6EFD"
                  />
                </svg>
              </div>

              <div
                style={{
                  border: "1px solid #CED4DA",
                  width: "480px",
                  borderRadius: "5px",
                  height: "100px",
                }}
              >
                <SignatureCanvas
                  ref={sigPadRef}
                  penColor="black"
                  onEnd={handleEndDrawing}
                  canvasProps={{
                    width: 480,
                    height: 100,
                    className: "signature-canvas",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: "pointer",
                }}
                onClick={() => setIsRejectModalOpen(false)}
              >
                Close
              </button>
              <button
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: "pointer",
                  marginRight: "7px",
                }}
                onClick={handleRejectRevision}
              >
                Reject
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Save Modal */}
      {isModalOpen && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content1"
            style={{
              position: "relative",
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              width: "90%",
              maxWidth: "500px",
              maxHeight: "90vh",
              overflowY: "auto",
              overflowX: "hidden",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              // boxSizing: 'border-box'
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <h3
                className="modal-header"
                style={{ fontSize: "12px", margin: 0 }}
              >
                Draft New Revision
              </h3>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                title="Close"
              >
                <FontAwesomeIcon icon={faTimes} size="1x" color="gray" />
              </button>
            </div>

            <hr className="divider" />

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "baseline",
                columnGap: "12px",
                rowGap: "4px",
                marginLeft: "10px",
                marginBottom: "4px",
              }}
            >
              <strong style={{ fontSize: "14px" }}>
                {type} {partNumber}
              </strong>
              <RenderHtml content={description} inline />
            </div>

            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "8px",
                width: "100%",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                  minWidth: "50px",
                  fontSize: "12px",
                }}
              >
                Revision:
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  width: "100%",
                }}
              >
                {(() => {
                  if (revisionData.length === 0) {
                    return (
                      <label
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <input
                          type="radio"
                          name="revision"
                          value="A-"
                          checked={revision === "A-"}
                          onChange={() => setRevision("A-")}
                        />
                        <span style={{ fontSize: "12px" }}>A- (Major)</span>
                      </label>
                    );
                  }

                  const groupBySeries = (revisions) => {
                    const series = {};
                    for (const rev of revisions) {
                      const parsed = parseRevision(rev.rev);
                      if (!parsed) continue;
                      const majorKey = parsed.base;
                      const minorKey = `${parsed.base}${parsed.minorNum}`;
                      series[majorKey] ??= [];
                      series[majorKey].push(rev);
                      if (parsed.type === "minor" || parsed.type === "amend") {
                        series[minorKey] ??= [];
                        series[minorKey].push(rev);
                      }
                    }
                    return series;
                  };

                  const allRejected = (revList = []) =>
                    revList.length > 0 &&
                    revList.every(
                      (r) =>
                        r.status_changes?.[0]?.status_changed_to?.toLowerCase() ===
                        "rejected"
                    );

                  const sortedRevisions = [...revisionData].sort((a, b) => {
                    const revA = parseRevision(a.rev);
                    const revB = parseRevision(b.rev);
                    if (!revA && !revB) return 0;
                    if (!revA) return 1;
                    if (!revB) return -1;
                    if (revA.type === "special") return -1;
                    if (revB.type === "special") return 1;
                    if (revA.base !== revB.base)
                      return revA.base.localeCompare(revB.base);
                    if (revA.type === "major" && revB.type !== "major")
                      return -1;
                    if (revB.type === "major" && revA.type !== "major")
                      return 1;
                    if (revA.minorNum !== revB.minorNum)
                      return revA.minorNum - revB.minorNum;
                    return revA.amendChar.localeCompare(revB.amendChar);
                  });

                  const lastRevision =
                    sortedRevisions[sortedRevisions.length - 1];
                  const fromRevStatus =
                    lastRevision?.status_changes?.[0]?.status_changed_to?.toLowerCase() ||
                    "";

                  const isRejectedOrExternal = [
                    "rejected",
                    "external",
                  ].includes(fromRevStatus);
                  if (isRejectedOrExternal) return null;
                  const lastRevParsed = parseRevision(lastRevision.rev || "A0");
                  if (!lastRevParsed) return null;

                  const getNextLetter = (str) => {
                    const lastChar = str[str.length - 1];
                    const rest = str.slice(0, -1);
                    const nextChar = String.fromCharCode(
                      lastChar.charCodeAt(0) + 1
                    );
                    if (lastChar === "Z") return rest + "A";
                    return rest + nextChar;
                  };
                  // Find the highest major revision base that exists
                  const findHighestMajorBase = () => {
                    const majorBases = revisionData
                      .map((rev) => {
                        const parsed = parseRevision(rev.rev);
                        return parsed && parsed.type === "major"
                          ? parsed.base
                          : null;
                      })
                      .filter((base) => base !== null)
                      .sort();

                    if (majorBases.length === 0) {
                      // No major revisions exist, start with A
                      return "A";
                    }

                    // Return the highest major base
                    return majorBases[majorBases.length - 1];
                  };
                  const highestMajorBase = findHighestMajorBase();
                  const nextMajorBase = getNextLetter(highestMajorBase);
                  const majorRev = `${nextMajorBase}-`;

                  // Get the current revision being viewed for amendment generation
                  const currentRevisionForAmend = revisionData.find(
                    (rev) => rev.procedure_revision_id === revisionId
                  );
                  const currentRevParsed = parseRevision(
                    currentRevisionForAmend?.rev
                  );

                  // Find the next available minor number for the current revision's base
                  const findNextMinorNumber = () => {
                    const base = currentRevParsed?.base;
                    if (!base) return 1;

                    // Get all existing minor revisions for this base
                    const existingMinors = revisionData
                      .filter((rev) => {
                        const parsed = parseRevision(rev.rev);
                        return (
                          parsed &&
                          parsed.base === base &&
                          parsed.type === "minor"
                        );
                      })
                      .map((rev) => parseRevision(rev.rev).minorNum)
                      .sort((a, b) => a - b);

                    if (existingMinors.length === 0) {
                      // No existing minors, start with 1
                      return 1;
                    }

                    // Find the next number after the highest existing minor
                    return existingMinors[existingMinors.length - 1] + 1;
                  };

                  const nextMinorNum = findNextMinorNumber();
                  const minorRev = `${
                    currentRevParsed?.base || lastRevParsed.base
                  }${nextMinorNum}`;

                  // Find the next available amendment character
                  const findNextAmendmentChar = () => {
                    const base = currentRevParsed?.base;
                    const minorNum = currentRevParsed?.minorNum;

                    // Get all existing amendments for this base and minor number
                    const existingAmendments = revisionData
                      .filter((rev) => {
                        const parsed = parseRevision(rev.rev);
                        return (
                          parsed &&
                          parsed.base === base &&
                          parsed.minorNum === minorNum &&
                          parsed.type === "amend"
                        );
                      })
                      .map((rev) => parseRevision(rev.rev).amendChar)
                      .sort();

                    if (existingAmendments.length === 0) {
                      // No existing amendments, start with 'a'
                      return "a";
                    }

                    // Find the next character after the highest existing amendment
                    const lastChar =
                      existingAmendments[existingAmendments.length - 1];
                    return String.fromCharCode(lastChar.charCodeAt(0) + 1);
                  };

                  const amendCharNext = findNextAmendmentChar();

                  const amendRev =
                    currentRevParsed?.type === "major"
                      ? `${currentRevParsed.base}-${amendCharNext}`
                      : `${currentRevParsed.base}${currentRevParsed.minorNum}${amendCharNext}`;

                  const isReleasedOrArchived = [
                    "released",
                    "archived",
                  ].includes(fromRevStatus);

                  const existingRevs = revisionData.map((r) => r.rev);

                  const series = groupBySeries([...revisionData]);
                  const majorSeriesKey = lastRevParsed.base;
                  const minorSeriesKey = `${lastRevParsed.base}${lastRevParsed.minorNum}`;

                  const allowMinor = !allRejected(series[majorSeriesKey] || []);

                  const allowAmend = !allRejected(series[minorSeriesKey] || []);

                  const options = [];

                  // Get the current revision being viewed
                  const currentRevision = revisionData.find(
                    (rev) => rev.procedure_revision_id === revisionId
                  );

                  // Use the canCreateRevision function to determine what types can be created
                  const { canCreate, reason } = canCreateRevision(
                    currentRevision,
                    revisionData
                  );

                  if (!canCreate) {
                    // If revision creation is not allowed, show error message
                    return (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {reason}
                      </div>
                    );
                  }

                  // Helper function to check if any subsequent major series has all rejected revisions
                  const hasSubsequentMajorSeriesWithAllRejected = (
                    currentRevParsed,
                    allRevisions
                  ) => {
                    // Get all revisions that come after the current revision
                    const sortedRevisions = [...allRevisions].sort((a, b) => {
                      const revA = parseRevision(a.rev);
                      const revB = parseRevision(b.rev);
                      if (!revA && !revB) return 0;
                      if (!revA) return 1;
                      if (!revB) return -1;
                      if (revA.type === "special") return -1;
                      if (revB.type === "special") return 1;
                      if (revA.base !== revB.base)
                        return revA.base.localeCompare(revB.base);
                      if (revA.type === "major" && revB.type !== "major")
                        return -1;
                      if (revB.type === "major" && revA.type !== "major")
                        return 1;
                      if (revA.minorNum !== revB.minorNum)
                        return revA.minorNum - revB.minorNum;
                      return revA.amendChar.localeCompare(revB.amendChar);
                    });

                    const currentRevisionIndex = sortedRevisions.findIndex(
                      (rev) =>
                        rev.procedure_revision_id ===
                        currentRevision.procedure_revision_id
                    );

                    if (currentRevisionIndex === -1) return false;

                    const subsequentRevisions = sortedRevisions.slice(
                      currentRevisionIndex + 1
                    );

                    // Get all unique major series from subsequent revisions
                    const subsequentMajorSeries = new Set();
                    subsequentRevisions.forEach((rev) => {
                      const parsed = parseRevision(rev.rev);
                      if (parsed && parsed.base !== currentRevParsed.base) {
                        subsequentMajorSeries.add(parsed.base);
                      }
                    });

                    // Check if any of these major series have all their revisions rejected
                    for (const majorSeries of subsequentMajorSeries) {
                      const revisionsInMajorSeries = subsequentRevisions.filter(
                        (rev) => {
                          const parsed = parseRevision(rev.rev);
                          return parsed && parsed.base === majorSeries;
                        }
                      );

                      if (
                        revisionsInMajorSeries.length > 0 &&
                        revisionsInMajorSeries.every((rev) => {
                          const status = rev?.status_changes
                            ?.find((sc) => sc.is_latest)
                            ?.status_changed_to?.toLowerCase();
                          return status === "rejected";
                        })
                      ) {
                        return true;
                      }
                    }

                    return false;
                  };

                  // Check if any subsequent major series has all rejected revisions
                  const hasRejectedMajorSeries =
                    hasSubsequentMajorSeriesWithAllRejected(
                      currentRevParsed,
                      revisionData
                    );

                  // Check if we can create major revisions
                  const canCreateMajor =
                    reason.includes("multiple revision types") ||
                    reason.includes("any revision type") ||
                    reason.includes("No subsequent revisions exist") ||
                    reason.includes("All subsequent revisions are rejected");

                  // Check if we can create minor revisions
                  const canCreateMinor =
                    (reason.includes("multiple revision types") ||
                      reason.includes("any revision type") ||
                      reason.includes("No subsequent revisions exist") ||
                      reason.includes(
                        "All subsequent revisions are rejected"
                      )) &&
                    !hasRejectedMajorSeries; // Don't allow minor if any subsequent major series is all rejected

                  // Check if we can create amendments (only from Released or Archived revisions)
                  const currentRevisionStatus = currentRevision?.status_changes
                    ?.find((sc) => sc.is_latest)
                    ?.status_changed_to?.toLowerCase();
                  // For amendments, we need to be more specific about when to apply the rejected major series restriction
                  // Only apply it when we're not in the "amendment only" case (which means there are active subsequent revisions)
                  // OR when we're not in the "All subsequent revisions are rejected" case
                  const shouldBlockAmendmentDueToRejectedSeries =
                    hasRejectedMajorSeries &&
                    !reason.includes("amendment only") &&
                    !reason.includes("All subsequent revisions are rejected");

                  const canCreateAmendment =
                    (reason.includes("amendment only") ||
                      reason.includes("any revision type") ||
                      reason.includes(
                        "All subsequent revisions are rejected"
                      )) &&
                    (currentRevisionStatus === "released" ||
                      currentRevisionStatus === "archived") &&
                    !shouldBlockAmendmentDueToRejectedSeries;

                  // Add Major revision option if allowed
                  if (canCreateMajor) {
                    options.push({
                      label: `${majorRev} (Major)`,
                      value: majorRev,
                    });
                  }

                  // Add Minor revision option if allowed
                  if (
                    canCreateMinor &&
                    (allowMinor ||
                      reason.includes("All subsequent revisions are rejected"))
                  ) {
                    options.push({
                      label: `${minorRev} (Minor)`,
                      value: minorRev,
                    });
                  }

                  // Add Amendment option if allowed
                  if (
                    canCreateAmendment &&
                    !existingRevs.includes(amendRev) &&
                    (allowAmend ||
                      reason.includes(
                        "All subsequent revisions are rejected"
                      ) ||
                      reason.includes("any revision type"))
                  ) {
                    options.push({
                      label: `${amendRev} (Amend)`,
                      value: amendRev,
                    });
                  }

                  if (options.length > 0 && revision === "A") {
                    setRevision(options[0].value);
                  }

                  return options.map((opt) => (
                    <label
                      key={opt.value}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        marginBottom: "6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <input
                        type="radio"
                        name="revision"
                        value={opt.value}
                        checked={revision === opt.value}
                        onChange={() => setRevision(opt.value)}
                      />
                      {opt.label}
                    </label>
                  ));
                })()}
              </div>
            </div>

            <div
              className="form-group"
              style={{
                display: "none",
                flexDirection: "row",
                alignItems: "flex-start",
                marginBottom: "8px",
                width: "100%",
                whiteSpace: "nowrap",
              }}
            >
              {rule && rule?.parts && rule?.parts.length > 0 && (
                <label
                  style={{
                    marginRight: "10px",
                    whiteSpace: "nowrap",
                    minWidth: "80px",
                    fontSize: "12px",
                  }}
                >
                  Select Template:
                </label>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "start",
                  alignItems: "start",
                  gap: "8px",
                }}
              >
                {rule?.parts.map((row) => (
                  <label
                    key={row.part_number}
                    style={{
                      display: "flex",
                      alignItems: "start",
                      gap: "8px",
                      fontWeight: "normal",
                      whiteSpace: "nowrap",
                      textAlign: "left",
                      // marginLeft: "-50px"
                    }}
                  >
                    <input
                      type="radio"
                      name="template"
                      value={row.part_id}
                      checked={template === row.part_id}
                      onChange={() => setTemplate(row.part_id)}
                    />
                    {row.part_number} - {row.description}
                  </label>
                ))}
              </div>
            </div>

            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "8px",
                width: "100%",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                  minWidth: "120px",
                  fontSize: "12px",
                }}
              >
                Requested By:
              </label>
              <span
                style={{
                  fontSize: "12px",
                  color: "#666",
                  marginLeft: "-40px",
                  marginTop: "-5px",
                }}
              >
                {localStorage.getItem("user_name")}
              </span>
            </div>

            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "8px",
                width: "100%",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                  minWidth: "120px",
                  fontSize: "12px",
                }}
              >
                Submission Required By:
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {users.map((user) => (
                  <label
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "normal",
                      fontSize: "12px",
                    }}
                    key={user.id}
                  >
                    <input
                      type="radio"
                      name="submissionBy"
                      value={user.id}
                      checked={submissionBy === user.id}
                      onChange={() => setSubmissionBy(user.id)}
                      style={{ transform: "scale(0.8)" }}
                    />
                    {user.first_name} {user.last_name}
                  </label>
                ))}
              </div>
            </div>

            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "8px",
                width: "100%",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                  minWidth: "120px",
                  fontSize: "12px",
                }}
              >
                Approval Required from:
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                {approvedUsers.map((user) => (
                  <label
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "normal",
                      fontSize: "12px",
                    }}
                    key={user.id}
                  >
                    <input
                      type="checkbox"
                      value={user.id}
                      checked={approvedBy.includes(user.id)}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setApprovedBy((prev) =>
                          checked
                            ? [...prev, user.id]
                            : prev.filter((id) => id !== user.id)
                        );
                      }}
                      style={{ transform: "scale(0.6)" }}
                    />
                    {user.first_name} {user.last_name}
                  </label>
                ))}
              </div>
            </div>

            <div
              className="form-group"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginBottom: "8px",
                width: "100%",
                whiteSpace: "nowrap",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                  minWidth: "120px",
                  fontSize: "12px",
                }}
              >
                Release Required from:
              </label>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                {releasedUsers.map((user) => (
                  <label
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                      fontWeight: "normal",
                      fontSize: "12px",
                    }}
                    key={user.id}
                  >
                    <input
                      type="radio"
                      name="releasedBy"
                      value={user.id}
                      checked={releasedBy === user.id}
                      onChange={() => setReleasedBy(user.id)}
                      style={{ transform: "scale(0.8)" }}
                    />
                    {user.first_name} {user.last_name}
                  </label>
                ))}
              </div>
            </div>
            <div className="form-group" style={{ marginBottom: "8px" }}>
              <label style={{ fontSize: "12px" }}>
                Enter The Revision Details
                <span className="required" style={{ marginLeft: "-1px" }}>
                  *
                </span>
              </label>
              <textarea
                className="input-textarea"
                placeholder="Add Video and risk Analysis Attachement"
                value={revisionDetailsForForm}
                onChange={(e) => setRevisionDetailsForForm(e.target.value)}
                style={{
                  fontSize: "12px",
                  padding: "5px",
                  width: "480px",
                  minHeight: "60px",
                  resize: "none",
                }}
              ></textarea>
            </div>

            <div className="form-group" style={{ marginBottom: "8px" }}>
              <label style={{ fontSize: "12px" }}>
                Enter Password
                <span className="required" style={{ marginLeft: "-1px" }}>
                  *
                </span>
              </label>
              <input
                type="password"
                className="input-field"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ fontSize: "13px", padding: "5px", width: "480px" }}
              />
            </div>

            <div className="form-group" style={{ marginBottom: "8px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                <label style={{ fontSize: "12px" }}>
                  Sign Here
                  <span className="required" style={{ marginLeft: "-1px" }}>
                    *
                  </span>
                </label>

                <svg
                  onClick={() => {
                    if (sigPadRef.current) {
                      sigPadRef.current.clear();
                      setSignature("");
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  width="50"
                  height="14"
                  viewBox="0 0 50 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 14C5.16667 14 4.38611 13.8417 3.65833 13.525C2.93056 13.2083 2.29722 12.7806 1.75833 12.2417C1.21944 11.7028 0.791667 11.0694 0.475 10.3417C0.158333 9.61389 0 8.83333 0 8H1.33333C1.33333 9.3 1.78611 10.4028 2.69167 11.3083C3.59722 12.2139 4.7 12.6667 6 12.6667C7.3 12.6667 8.40278 12.2139 9.30833 11.3083C10.2139 10.4028 10.6667 9.3 10.6667 8C10.6667 6.7 10.2139 5.59722 9.30833 4.69167C8.40278 3.78611 7.3 3.33333 6 3.33333H5.9L6.93333 4.36667L6 5.33333L3.33333 2.66667L6 0L6.93333 0.966667L5.9 2H6C6.83333 2 7.61389 2.15833 8.34167 2.475C9.06944 2.79167 9.70278 3.21944 10.2417 3.75833C10.7806 4.29722 11.2083 4.93056 11.525 5.65833C11.8417 6.38611 12 7.16667 12 8C12 8.83333 11.8417 9.61389 11.525 10.3417C11.2083 11.0694 10.7806 11.7028 10.2417 12.2417C9.70278 12.7806 9.06944 13.2083 8.34167 13.525C7.61389 13.8417 6.83333 14 6 14Z"
                    fill="#0D6EFD"
                  />
                  <path
                    d="M24.1641 8.83496H25.4766C25.4082 9.46387 25.2282 10.0267 24.9365 10.5234C24.6449 11.0202 24.2324 11.4144 23.6992 11.7061C23.166 11.9932 22.5007 12.1367 21.7031 12.1367C21.1198 12.1367 20.5889 12.0273 20.1104 11.8086C19.6364 11.5898 19.2285 11.2799 18.8867 10.8789C18.5449 10.4733 18.2806 9.98796 18.0938 9.42285C17.9115 8.85319 17.8203 8.21973 17.8203 7.52246V6.53125C17.8203 5.83398 17.9115 5.2028 18.0938 4.6377C18.2806 4.06803 18.5472 3.5804 18.8936 3.1748C19.2445 2.76921 19.666 2.45703 20.1582 2.23828C20.6504 2.01953 21.2041 1.91016 21.8193 1.91016C22.5713 1.91016 23.207 2.05143 23.7266 2.33398C24.2461 2.61654 24.6494 3.00846 24.9365 3.50977C25.2282 4.00651 25.4082 4.58301 25.4766 5.23926H24.1641C24.1003 4.77441 23.9818 4.37565 23.8086 4.04297C23.6354 3.70573 23.3893 3.44596 23.0703 3.26367C22.7513 3.08138 22.3343 2.99023 21.8193 2.99023C21.3773 2.99023 20.9876 3.07454 20.6504 3.24316C20.3177 3.41178 20.0374 3.65104 19.8096 3.96094C19.5863 4.27083 19.4176 4.64225 19.3037 5.0752C19.1898 5.50814 19.1328 5.98893 19.1328 6.51758V7.52246C19.1328 8.01009 19.1829 8.4681 19.2832 8.89648C19.388 9.32487 19.5452 9.70085 19.7549 10.0244C19.9645 10.348 20.2311 10.6032 20.5547 10.79C20.8783 10.9723 21.2611 11.0635 21.7031 11.0635C22.2637 11.0635 22.7103 10.9746 23.043 10.7969C23.3757 10.6191 23.6263 10.3639 23.7949 10.0312C23.9681 9.69857 24.0911 9.2998 24.1641 8.83496ZM28.457 1.5V12H27.1855V1.5H28.457ZM33.5566 12.1367C33.0417 12.1367 32.5745 12.0501 32.1553 11.877C31.7406 11.6992 31.3828 11.4508 31.082 11.1318C30.7858 10.8128 30.5579 10.4346 30.3984 9.99707C30.2389 9.55957 30.1592 9.08105 30.1592 8.56152V8.27441C30.1592 7.67285 30.248 7.13737 30.4258 6.66797C30.6035 6.19401 30.8451 5.79297 31.1504 5.46484C31.4557 5.13672 31.8021 4.88835 32.1895 4.71973C32.5768 4.55111 32.9779 4.4668 33.3926 4.4668C33.9212 4.4668 34.377 4.55794 34.7598 4.74023C35.1471 4.92253 35.4639 5.17773 35.71 5.50586C35.9561 5.82943 36.1383 6.21224 36.2568 6.6543C36.3753 7.0918 36.4346 7.57031 36.4346 8.08984V8.65723H30.9111V7.625H35.1699V7.5293C35.1517 7.20117 35.0833 6.88216 34.9648 6.57227C34.8509 6.26237 34.6686 6.00716 34.418 5.80664C34.1673 5.60612 33.8255 5.50586 33.3926 5.50586C33.1055 5.50586 32.8411 5.56738 32.5996 5.69043C32.3581 5.80892 32.1507 5.98665 31.9775 6.22363C31.8044 6.46061 31.6699 6.75 31.5742 7.0918C31.4785 7.43359 31.4307 7.8278 31.4307 8.27441V8.56152C31.4307 8.91243 31.4785 9.24284 31.5742 9.55273C31.6745 9.85807 31.818 10.127 32.0049 10.3594C32.1963 10.5918 32.4264 10.7741 32.6953 10.9062C32.9688 11.0384 33.2786 11.1045 33.625 11.1045C34.0716 11.1045 34.4499 11.0133 34.7598 10.8311C35.0697 10.6488 35.3408 10.4049 35.5732 10.0996L36.3389 10.708C36.1794 10.9495 35.9766 11.1797 35.7305 11.3984C35.4844 11.6172 35.1813 11.7949 34.8213 11.9316C34.4658 12.0684 34.0443 12.1367 33.5566 12.1367ZM42.2725 10.7354V6.92773C42.2725 6.63607 42.2132 6.38314 42.0947 6.16895C41.9808 5.9502 41.8076 5.78158 41.5752 5.66309C41.3428 5.5446 41.0557 5.48535 40.7139 5.48535C40.3949 5.48535 40.1146 5.54004 39.873 5.64941C39.6361 5.75879 39.4492 5.90234 39.3125 6.08008C39.1803 6.25781 39.1143 6.44922 39.1143 6.6543H37.8496C37.8496 6.38997 37.918 6.12793 38.0547 5.86816C38.1914 5.6084 38.3874 5.3737 38.6426 5.16406C38.9023 4.94987 39.2122 4.78125 39.5723 4.6582C39.9368 4.5306 40.3424 4.4668 40.7891 4.4668C41.3268 4.4668 41.8008 4.55794 42.2109 4.74023C42.6257 4.92253 42.9492 5.19824 43.1816 5.56738C43.4186 5.93197 43.5371 6.38997 43.5371 6.94141V10.3867C43.5371 10.6328 43.5576 10.8949 43.5986 11.1729C43.6442 11.4508 43.7103 11.6901 43.7969 11.8906V12H42.4775C42.4137 11.8542 42.3636 11.6605 42.3271 11.4189C42.2907 11.1729 42.2725 10.945 42.2725 10.7354ZM42.4912 7.51562L42.5049 8.4043H41.2266C40.8665 8.4043 40.5452 8.43392 40.2627 8.49316C39.9801 8.54785 39.7432 8.63216 39.5518 8.74609C39.3604 8.86003 39.2145 9.00358 39.1143 9.17676C39.014 9.34538 38.9639 9.54362 38.9639 9.77148C38.9639 10.0039 39.0163 10.2158 39.1211 10.4072C39.2259 10.5986 39.3831 10.7513 39.5928 10.8652C39.807 10.9746 40.069 11.0293 40.3789 11.0293C40.7663 11.0293 41.1081 10.9473 41.4043 10.7832C41.7005 10.6191 41.9352 10.4186 42.1084 10.1816C42.2861 9.94466 42.3818 9.71452 42.3955 9.49121L42.9355 10.0996C42.9036 10.291 42.8171 10.5029 42.6758 10.7354C42.5345 10.9678 42.3454 11.1911 42.1084 11.4053C41.876 11.6149 41.598 11.7904 41.2744 11.9316C40.9554 12.0684 40.5954 12.1367 40.1943 12.1367C39.693 12.1367 39.2533 12.0387 38.875 11.8428C38.5013 11.6468 38.2096 11.3848 38 11.0566C37.7949 10.724 37.6924 10.3525 37.6924 9.94238C37.6924 9.5459 37.7699 9.19727 37.9248 8.89648C38.0798 8.59115 38.3031 8.33822 38.5947 8.1377C38.8864 7.93262 39.2373 7.77767 39.6475 7.67285C40.0576 7.56803 40.5156 7.51562 41.0215 7.51562H42.4912ZM46.791 5.76562V12H45.5264V4.60352H46.7568L46.791 5.76562ZM49.1016 4.5625L49.0947 5.73828C48.9899 5.71549 48.8896 5.70182 48.7939 5.69727C48.7028 5.68815 48.598 5.68359 48.4795 5.68359C48.1878 5.68359 47.9303 5.72917 47.707 5.82031C47.4837 5.91146 47.2946 6.03906 47.1396 6.20312C46.9847 6.36719 46.8617 6.56315 46.7705 6.79102C46.6839 7.01432 46.627 7.26042 46.5996 7.5293L46.2441 7.73438C46.2441 7.28776 46.2874 6.86849 46.374 6.47656C46.4652 6.08464 46.6042 5.73828 46.791 5.4375C46.9779 5.13216 47.2148 4.89518 47.502 4.72656C47.7936 4.55339 48.14 4.4668 48.541 4.4668C48.6322 4.4668 48.737 4.47819 48.8555 4.50098C48.974 4.51921 49.056 4.53971 49.1016 4.5625Z"
                    fill="#0D6EFD"
                  />
                </svg>
              </div>

              <div
                style={{
                  border: "1px solid #CED4DA",
                  width: "480px",
                  borderRadius: "5px",
                  height: "100px",
                }}
              >
                <SignatureCanvas
                  ref={sigPadRef}
                  penColor="black"
                  onEnd={handleEndDrawing}
                  canvasProps={{
                    width: 480,
                    height: 100,
                    className: "signature-canvas",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: "pointer",
                }}
              >
                Close
              </button>
              <button
                onClick={createRevision}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: "pointer",
                  marginRight: "7px",
                }}
              >
                Create Revision
              </button>
            </div>
          </div>
        </div>
      )}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}
      <div style={{ height: "100px" }}></div>
      {loading && <Loader />}
      {/* Version History Popup */}
      {showVersionHistory && (
        <Popup
          title="Version History"
          closeModal={() => setShowVersionHistory(false)}
        >
          <div style={{ minWidth: 900, maxWidth: 1200 }}>
            {/* Filter Container */}
            <div
              className="filter-container"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                marginBottom: 16,
                marginTop: "10px",
              }}
            >
              <div
                className="filter-dropdown"
                style={{ marginLeft: "-16px", position: "relative" }}
              >
                <div
                  className="dropdown-header"
                  onClick={() =>
                    setIsVersionDropdownOpen(!isVersionDropdownOpen)
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 12px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    cursor: "pointer",
                    minWidth: 140,
                    backgroundColor: "white",
                  }}
                >
                  <span>
                    {versionFilterOptions.find(
                      (opt) => opt.value === versionHistoryFilter
                    )?.label || "Version History"}
                  </span>
                  <span className="dropdown-arrow" style={{ fontSize: "12px" }}>
                    {isVersionDropdownOpen ? "▲" : "▼"}
                  </span>
                </div>
                {isVersionDropdownOpen && (
                  <div
                    className="dropdown-options"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      zIndex: 1000,
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    {versionFilterOptions.map((option) => (
                      <div
                        key={option.value}
                        className={`radio-option ${
                          versionHistoryFilter === option.value
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => {
                          setVersionHistoryFilter(option.value);
                          setIsVersionDropdownOpen(false);
                        }}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          backgroundColor:
                            versionHistoryFilter === option.value
                              ? "#f0f0f0"
                              : "transparent",
                        }}
                      >
                        <input
                          type="radio"
                          name="versionFilterType"
                          value={option.value}
                          checked={versionHistoryFilter === option.value}
                          onChange={() => {}}
                          style={{ marginRight: "8px" }}
                        />
                        <span className="radio-label">{option.label}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="search-container" style={{ flex: 1 }}>
                <SearchBarWithFilter
                  searchQuery={versionHistorySearch}
                  setSearchQuery={setVersionHistorySearch}
                  columnOptions={versionHistoryColumns}
                  setSearchType={setSearchType}
                  searchType={searchType}
                  setSelectedColumns={setSelectedColumns}
                  selectedColumns={selectedColumns}
                />
              </div>
              <div style={{ width: "160px" }}></div>
            </div>
            {/* Table */}
            <div
              style={{
                maxHeight: 400,
                overflowY: "auto",
                marginTop: "-30px",
              }}
            >
              <table className="table">
                <thead>
                  <tr>
                    <th
                      style={{
                        textAlign: "left",
                        width: "12%",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() => handleVersionSort("date")}
                    >
                      Date {getVersionSortIcon("date")}
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        width: "10%",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() => handleVersionSort("versionId")}
                    >
                      Version ID {getVersionSortIcon("versionId")}
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        width: "10%",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() => handleVersionSort("status")}
                    >
                      Status {getVersionSortIcon("status")}
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        width: "10%",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() => handleVersionSort("modifiedBy")}
                    >
                      Modified by {getVersionSortIcon("modifiedBy")}
                    </th>
                    <th
                      style={{
                        textAlign: "left",
                        width: "53%",
                        position: "relative",
                        cursor: "pointer",
                      }}
                      onClick={() => handleVersionSort("comment")}
                    >
                      Comment {getVersionSortIcon("comment")}
                    </th>
                    <th style={{ textAlign: "left", width: "5%" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {versionHistories.map((row, idx) => {
                    const date = new Date(row.audit_date);

                    // Convert to EST manually by shifting UTC offset
                    const estDate = new Date(
                      date.toLocaleString("en-US", {
                        timeZone: "America/New_York",
                      })
                    );

                    // Format date as YYYY-MM-DD
                    const year = estDate.getFullYear();
                    const month = String(estDate.getMonth() + 1).padStart(
                      2,
                      "0"
                    );
                    const day = String(estDate.getDate()).padStart(2, "0");
                    const formattedDate = `${year}-${month}-${day}`;

                    // Format time as hh:mm AM/PM
                    let hours = estDate.getHours();
                    const minutes = String(estDate.getMinutes()).padStart(
                      2,
                      "0"
                    );
                    const ampm = hours >= 12 ? "PM" : "AM";
                    hours = hours % 12 || 12; // convert 0 to 12
                    const formattedTime = `${hours}:${minutes} ${ampm}`;

                    // Combine with hardcoded EST
                    const finalString = `${formattedDate}, ${formattedTime} EST`;
                    return (
                      <tr key={idx}>
                        <td style={{ textAlign: "left" }}>{finalString}</td>
                        <td>{row.version_id || "-"}</td>
                        <td>{row.action || ""}</td>
                        <td>
                          {row.first_name || ""} {row.last_name || ""}
                        </td>
                        <td>{row.comment || "-"}</td>
                        <td>
                          <button
                            className="right-arrow"
                            style={{
                              border: "none",
                              background: "none",
                              cursor: "pointer",
                            }}
                          >
                            <FontAwesomeIcon icon={faArrowRight} />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {/* Export Button */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <ExportCsvBtn
                handleExportCSV={handleExportCSV}
                disabled={!areNodesReadyForExport}
                title="Export will be enabled once all nodes are loaded."
              />
            </div>
          </div>
        </Popup>
      )}
      {/* Export Options Popup */}
      {isExportPopupOpen && (
        <Popup
          title={<span style={{ fontSize: 18 }}>Select the Export Format</span>}
          closeModal={() => setIsExportPopupOpen(false)}
          width={350}
          headerStyle={{
            boxShadow: "none",
            padding: "10px 38px 6px 16px",
            textAlign: "left",
          }}
        >
          <div
            style={{
              marginLeft: "20px",
              padding: "10px",
              borderTop: "1px solid #E0E0E0",
            }}
          >
            <div
              style={{
                paddingTop: 4,
                paddingBottom: 12,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                gap: 6,
                textAlign: "left",
              }}
            >
              <label
                style={{
                  display: "grid",
                  gridTemplateColumns: "16px 1fr",
                  alignItems: "start",
                  columnGap: 8,
                  marginBottom: 4,
                  width: "100%",
                }}
              >
                <input
                  type="radio"
                  name="exportFormat"
                  value="mhtml"
                  checked={exportFormat === "mhtml"}
                  onChange={() => setExportFormat("mhtml")}
                />
                <span>mHTML</span>
              </label>

              <label
                style={{
                  display: "grid",
                  gridTemplateColumns: "16px 1fr",
                  alignItems: "start",
                  columnGap: 8,
                  marginBottom: 4,
                  width: "100%",
                }}
              >
                <input
                  type="radio"
                  name="exportFormat"
                  value="pdf"
                  checked={exportFormat === "pdf"}
                  onChange={() => setExportFormat("pdf")}
                />
                <span>PDF</span>
              </label>

              <label
                style={{
                  display: "grid",
                  gridTemplateColumns: "16px 1fr",
                  alignItems: "start",
                  columnGap: 8,
                  marginBottom: 4,
                  width: "100%",
                }}
              >
                <input
                  type="radio"
                  name="exportFormat"
                  value="csv_bom"
                  checked={exportFormat === "csv_bom"}
                  onChange={() => setExportFormat("csv_bom")}
                />
                <span>CSV (BOM)</span>
              </label>

              <label
                style={{
                  display: "grid",
                  gridTemplateColumns: "16px 1fr",
                  alignItems: "start",
                  columnGap: 8,
                  marginBottom: 4,
                  width: "100%",
                }}
              >
                <input
                  type="radio"
                  name="exportFormat"
                  value="csv_revisions"
                  checked={exportFormat === "csv_revisions"}
                  onChange={() => setExportFormat("csv_revisions")}
                />
                <span>CSV (Revisions Table)</span>
              </label>

              {/* <label style={{ display: "grid", gridTemplateColumns: "16px 1fr", alignItems: "start", columnGap: 8, marginBottom: 4, width: "100%" }}>
                <input
                  type="radio"
                  name="exportFormat"
                  value="csv_training"
                  checked={exportFormat === "csv_training"}
                  onChange={() => setExportFormat("csv_training")}
                />
                <span>CSV (Training Table)</span>
              </label> */}

              <label
                style={{
                  display: "grid",
                  gridTemplateColumns: "16px 1fr",
                  alignItems: "start",
                  columnGap: 8,
                  marginBottom: 4,
                  width: "100%",
                }}
              >
                <input
                  type="radio"
                  name="exportFormat"
                  value="signatures_workflow"
                  checked={exportFormat === "signatures_workflow"}
                  onChange={() => setExportFormat("signatures_workflow")}
                />
                <span>Signatures (Submit, Approve, Release)</span>
              </label>

              {/* <label style={{ display: "grid", gridTemplateColumns: "16px 1fr", alignItems: "start", columnGap: 8, marginBottom: 4, width: "100%" }}>
                <input
                  type="radio"
                  name="exportFormat"
                  value="signatures_training"
                  checked={exportFormat === "signatures_training"}
                  onChange={() => setExportFormat("signatures_training")}
                />
                <span>Signatures (Training)</span>
              </label> */}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                borderTop: "1px solid #E0E0E0",
                paddingTop: 10,
                marginTop: 6,
              }}
            >
              <button
                style={{
                  padding: "6px 12px",
                  border: "1px solid #ccc",
                  background: "#6c757d",
                  color: "#e9ecef",
                  borderRadius: 4,
                  cursor: "pointer",
                }}
                onClick={() => setIsExportPopupOpen(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  padding: "6px 12px",
                  border: "1px solid #0D6EFD",
                  background: isExporting ? "#6c91ff" : "#0D6EFD",
                  color: "#fff",
                  borderRadius: 4,
                  cursor: isExporting ? "default" : "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                }}
                disabled={isExporting}
                onClick={async () => {
                  if (!areNodesReadyForExport) {
                    showSnackbar(
                      "Export will be enabled once all nodes are loaded.",
                      "info",
                    );
                    return;
                  }
                  try {
                    setIsExporting(true);
                    if (exportFormat === "csv_bom") {
                      handleExportBOMCSV();
                    } else if (exportFormat === "csv_revisions") {
                      handleExportRevisionsCSV();
                    } else if (exportFormat === "csv_training") {
                      handleExportTrainingCSV();
                    } else if (exportFormat === "pdf") {
                      await handleExportPDF();
                    } else if (exportFormat === "mhtml") {
                      await handleExportMHTML();
                    } else if (exportFormat === "signatures_workflow") {
                      await handleExportSignaturesPDF();
                    }
                    setIsExportPopupOpen(false);
                  } finally {
                    setIsExporting(false);
                  }
                }}
              >
                {isExporting ? (
                  <>
                    <span
                      className="spinner"
                      style={{
                        width: 14,
                        height: 14,
                        border: "2px solid rgba(255,255,255,0.6)",
                        borderTopColor: "#fff",
                        borderRadius: "50%",
                        display: "inline-block",
                        animation: "spin 0.8s linear infinite",
                      }}
                    />
                    <span>Exporting...</span>
                  </>
                ) : (
                  <span>Export</span>
                )}
              </button>
            </div>
          </div>
        </Popup>
      )}
      <ExportFormatPopup
        renderPdfEngineOnly
        isOpen={false}
        onClose={() => {}}
        contentRef={pdfEngineContentRef}
        bomTable={bomTable || []}
        revisionData={revisionDataToRender || []}
        trainingLogs={trainingLogs || []}
        partId={partId || ""}
        type={type || ""}
        partNumber={partNumber || ""}
        myRevision={myRevision || ""}
        revisionId={revisionId || ""}
        description={description || ""}
        pdfEngineZipPayload={pdfEngineZipPayload}
        appSetupItems={appSetupItems || []}
        filteredRevisionData={[]}
        status={status || ""}
      />
    </div>
  );
};
export default PreviewNodes;
